// ========================================
// COMPONENTE DE NOVO PEDIDO - CORRIGIDO
// src/NovoPedido.jsx
// ========================================

import React, { useState, useEffect } from 'react';
import { Search, Plus, Printer, Save, X, Trash2, CheckCircle, XCircle, Clock, ShieldCheck, Edit2, Trophy, AlertTriangle, ArrowRight, Check, User, Building2, MapPin, Phone, Mail, FileText, Calendar, ShoppingCart, BarChart3, ChevronDown, ChevronUp, CreditCard, Banknote, Wallet, Receipt, TrendingUp, TrendingDown, Percent, DollarSign, Package, AlertCircle, Diamond } from 'lucide-react';
import { useAuth } from './contexts/AuthContext';

// Lista de formas de pagamento disponíveis
const FORMAS_PAGAMENTO = [
  { id: 'avista', label: 'À Vista (Dinheiro)', icon: 'Banknote', prazo: 0, exigeObservacao: false },
  { id: 'pix', label: 'PIX', icon: 'Wallet', prazo: 0, exigeObservacao: false },
  { id: 'cartao_debito', label: 'Cartão de Débito', icon: 'CreditCard', prazo: 0, exigeObservacao: false },
  { id: 'cartao_credito', label: 'Cartão de Crédito', icon: 'CreditCard', prazo: 30, exigeObservacao: true },
  { id: 'boleto_avista', label: 'Boleto à Vista', icon: 'Receipt', prazo: 0, exigeObservacao: true },
  { id: 'boleto_prazo', label: 'Boleto à Prazo', icon: 'Receipt', prazo: 30, exigeObservacao: true },
  { id: 'ted_doc', label: 'TED/DOC', icon: 'Wallet', prazo: 0, exigeObservacao: true },
  { id: 'deposito', label: 'Depósito Bancário', icon: 'Wallet', prazo: 0, exigeObservacao: true },
  { id: 'cheque_avista', label: 'Cheque à Vista', icon: 'Receipt', prazo: 0, exigeObservacao: true },
  { id: 'cheque_prazo', label: 'Cheque à Prazo', icon: 'Receipt', prazo: 30, exigeObservacao: true },
  { id: 'entrada_parcelas', label: 'Entrada + Parcelas', icon: 'CreditCard', prazo: 30, exigeObservacao: true },
  { id: 'outro', label: 'Outro (especificar)', icon: 'FileText', prazo: 0, exigeObservacao: true },
];
import ConsultaPedidos from './ConsultaPedidos';
import { clienteAPI, produtoAPI, custoAPI, pedidoAPI, usuarioAPI } from './services/api';
import { useModal } from './contexts/ModalContext';
import { montarModalErro } from './utils/modalErro';
import { getStatusConfig, getStatusByScore, STATUS_CONFIG, StatusBadge } from './config/statusConfig';
import Loading from './components/Loading';
import { imprimirProposta as imprimirPropostaService } from './services/impressaoService';

const PrimaliaPVCSystem = () => {
  const { showModal } = useModal();
  const { usuario: usuarioLogado } = useAuth();

  const [telaAtual, setTelaAtual] = useState('novo-pedido');
  const [showCadastro, setShowCadastro] = useState(false);
  const [cnpj, setCnpj] = useState('');
  const [cliente, setCliente] = useState(null);
  const [pedidoSalvo, setPedidoSalvo] = useState(false);
  const [pedidoSalvoId, setPedidoSalvoId] = useState(null);
  // Registro que o servidor devolveu ao salvar — é o que a impressão usa
  const [pedidoSalvoDados, setPedidoSalvoDados] = useState(null);
  const [editandoCliente, setEditandoCliente] = useState(false);
  const [clienteEditado, setClienteEditado] = useState(null);
  const [aprovacaoTab1, setAprovacaoTab1] = useState(false);
  const [aprovacaoTab2, setAprovacaoTab2] = useState(false);

  // Estados para busca por nome (autocomplete)
  const [sugestoesClientes, setSugestoesClientes] = useState([]);
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);
  const [buscandoNome, setBuscandoNome] = useState(false);
  const buscaNomeRef = React.useRef(null);
  const sugestoesRef = React.useRef(null);
  const debounceTimerRef = React.useRef(null);
  
  
  // Estados de expansão das seções
  const [expandido, setExpandido] = useState({
    proposta: true,
    cliente: true,
    entrega: true,
    pedido: true,
    resumo: true,
    admin: true,
    pagamento: true,
    observacao: true,
    analiseCredito: true
  });

  // Estado para formas de pagamento (até 4 opções)
  const [formasPagamento, setFormasPagamento] = useState([
    { forma: '', observacao: '' },
    { forma: '', observacao: '' },
    { forma: '', observacao: '' },
    { forma: '', observacao: '' }
  ]);

  // Estado para análise de crédito parcelado
  const [analiseCredito, setAnaliseCredito] = useState({
    carregando: false,
    pedidosTodos: [],
    pedidosParcelados: [],
    totalHistorico: 0,
    totalHistoricoParcelados: 0,
    quantidade: 0,
    quantidadeParcelados: 0,
    valorPedidoAtual: 0,
    totalGeral: 0,
    quantidadeTotal: 0,
    mediaParcelado: 0,
    limiteCredito: 0,
    porte: '',
    ultrapassouLimite: false,
    percentualParcelamento: 0,
    percentualDoLimite: 0,
    limitePersonalizado: false,
    limitePadrao: 0
  });

  // Estado para observação geral do pedido
  const [observacaoPedido, setObservacaoPedido] = useState('');

  // Estado para observação do cliente (vem do cadastro, editável no pedido)
  const [observacaoCliente, setObservacaoCliente] = useState('');

  // Estado para hora fim do pedido (quando salvar)
  const [horaFimPedido, setHoraFimPedido] = useState('');

  // Estados para Dados da Entrega
  const [mesmoEnderecoCliente, setMesmoEnderecoCliente] = useState(null);
  const [enderecoEntrega, setEnderecoEntrega] = useState('');
  const [bairroEntrega, setBairroEntrega] = useState('');
  const [cidadeEntrega, setCidadeEntrega] = useState('');
  const [estadoEntrega, setEstadoEntrega] = useState('Parana');
  
  // Estados para Taxa de Entrega
  const [temTaxaEntrega, setTemTaxaEntrega] = useState(null);
  const [valorTaxaEntrega, setValorTaxaEntrega] = useState('');
  
  // Estado para seleção de responsável (Admin/Diretoria/Administrativo podem selecionar)
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [responsavelSelecionado, setResponsavelSelecionado] = useState('');
  
  const toggleExpandir = (secao) => {
    setExpandido(prev => ({ ...prev, [secao]: !prev[secao] }));
  };
  
  const [novoCliente, setNovoCliente] = useState({ 
    nome: '', cnpj: '', endereco: '', bairro: '', cidade: '', estado: 'Parana', telefone: '', email: '', rede: '', data_constituicao_nascimento: ''
  });
  const [erroValidacao, setErroValidacao] = useState({ cnpj: '', telefone: '' });
  const [verificandoCnpj, setVerificandoCnpj] = useState(false);
  
  const [pedido, setPedido] = useState({ 
    data: new Date().toLocaleDateString('pt-BR'), hora: '', proposta: '', vendedor: '', bairro: '', forro: [], acessorios: [] 
  });

  const [produtosForro, setProdutosForro] = useState([]);
  const [acessoriosLista, setAcessoriosLista] = useState([]);
  const [custos, setCustos] = useState([]);
  const [loading, setLoading] = useState(true);

  // ========================================
  // PRODUTOS ESPECIAIS (Demais Produtos)
  // ========================================
  const [produtosEspeciais, setProdutosEspeciais] = useState([]); // Lista de produtos disponíveis
  const [itensEspeciais, setItensEspeciais] = useState([]); // Itens adicionados ao pedido
  const [modoVendaEspecial, setModoVendaEspecial] = useState(false); // true = venda de produtos especiais, false = venda normal

  // Verificar se usuário pode vender produtos especiais
  const podeVenderProdutosEspeciais = () => {
    // Admin sempre pode
    const dep = (usuarioLogado?.departamento || '').toLowerCase();
    if (dep === 'admin' || dep === 'administrador' || dep === 'diretoria') {
      return true;
    }
    return usuarioLogado?.pode_vender_produtos_especiais === true || 
           usuarioLogado?.permissoes?.pode_vender_produtos_especiais === true;
  };

  // Alternar para modo de venda de produtos especiais
  const ativarModoVendaEspecial = () => {
    if (pedido.forro.length > 0 || pedido.acessorios.length > 0) {
      showModal({ 
        type: 'warning', 
        title: 'Atenção', 
        message: 'Você já tem produtos normais no pedido. Deseja removê-los e vender apenas Produtos Especiais?',
        confirmText: 'Sim, Vender Especiais',
        cancelText: 'Cancelar',
        showCancel: true,
        onConfirm: () => {
          setPedido({ ...pedido, forro: [], acessorios: [] });
          setModoVendaEspecial(true);
        }
      });
    } else {
      setModoVendaEspecial(true);
    }
  };

  // Alternar para modo de venda normal
  const ativarModoVendaNormal = () => {
    if (itensEspeciais.length > 0) {
      showModal({ 
        type: 'warning', 
        title: 'Atenção', 
        message: 'Você já tem Produtos Especiais no pedido. Deseja removê-los e vender produtos normais?',
        confirmText: 'Sim, Vender Normais',
        cancelText: 'Cancelar',
        showCancel: true,
        onConfirm: () => {
          setItensEspeciais([]);
          setModoVendaEspecial(false);
        }
      });
    } else {
      setModoVendaEspecial(false);
    }
  };

  // ========================================
  // FUNÇÕES DE MÁSCARA E VALIDAÇÃO
  // ========================================
  
  // Máscara de CPF: 000.000.000-00
  const mascaraCPF = (valor) => {
    return valor
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  };

  // Máscara de CNPJ: 00.000.000/0000-00
  const mascaraCNPJ = (valor) => {
    return valor
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  };

  // Máscara automática CPF/CNPJ
  const mascaraCpfCnpj = (valor) => {
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length <= 11) {
      return mascaraCPF(valor);
    } else {
      return mascaraCNPJ(valor);
    }
  };

  // Máscara de Telefone: (99) 9999-9999 ou (99) 99999-9999
  const mascaraTelefone = (valor) => {
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length <= 10) {
      // Telefone fixo: (99) 9999-9999
      return apenasNumeros
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    } else {
      // Celular: (99) 99999-9999
      return apenasNumeros
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    }
  };

  // Validar formato de telefone
  const validarTelefone = (telefone) => {
    const apenasNumeros = telefone.replace(/\D/g, '');
    return apenasNumeros.length >= 10 && apenasNumeros.length <= 11;
  };

  // Validar formato de CPF/CNPJ
  const validarCpfCnpj = (valor) => {
    const apenasNumeros = valor.replace(/\D/g, '');
    return apenasNumeros.length === 11 || apenasNumeros.length === 14;
  };

  // Handler para mudança de CPF/CNPJ com validação de duplicidade
  const handleCnpjChange = async (valor) => {
    const valorFormatado = mascaraCpfCnpj(valor);
    setNovoCliente({ ...novoCliente, cnpj: valorFormatado });
    setErroValidacao(prev => ({ ...prev, cnpj: '' }));

    // Só verificar quando tiver CPF ou CNPJ completo
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length === 11 || apenasNumeros.length === 14) {
      setVerificandoCnpj(true);
      try {
        // Buscar se já existe cliente com esse CPF/CNPJ
        const clienteExistente = await clienteAPI.buscarPorCNPJ(valorFormatado);
        if (clienteExistente) {
          setErroValidacao(prev => ({ ...prev, cnpj: 'Cliente já cadastrado com este CPF/CNPJ' }));
        }
      } catch (error) {
        // Se não encontrou, é ok - pode cadastrar
      } finally {
        setVerificandoCnpj(false);
      }
    }
  };

  // Handler para mudança de telefone com máscara
  const handleTelefoneChange = (valor) => {
    const valorFormatado = mascaraTelefone(valor);
    setNovoCliente({ ...novoCliente, telefone: valorFormatado });
    
    // Validar formato
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length > 0 && apenasNumeros.length < 10) {
      setErroValidacao(prev => ({ ...prev, telefone: 'Telefone inválido' }));
    } else {
      setErroValidacao(prev => ({ ...prev, telefone: '' }));
    }
  };

  // Somente Admin e Diretoria vêem a visão administrativa (custos, lucro, margem)
  const podeVerVisaoAdmin = () => {
    if (!usuarioLogado) return false;
    const dep = (usuarioLogado.departamento || '').toLowerCase().trim();
    return dep === 'admin' || dep === 'diretoria';
  };

  // Verifica se é Representante (não deve ver % Acabamento)
  const isVendasOuRepresentante = () => {
    if (!usuarioLogado) return false;
    const dep = (usuarioLogado.departamento || '').toLowerCase();
    return dep === 'representante';
  };

  // Verifica se pode ver % Acabamento (Admin, Diretoria, Administrativo, Vendas)
  const podeVerPercentualAcabamento = () => {
    if (!usuarioLogado) return false;
    const dep = (usuarioLogado.departamento || '').toLowerCase();
    return dep === 'admin' || dep === 'diretoria' || dep === 'administrativo' || dep === 'vendas';
  };

  const podeAprovarPedido = () => podeVerVisaoAdmin();
  
  // Verificar se pode selecionar responsável (permissão específica)
  const podeSelecionarResponsavel = () => {
    return usuarioLogado?.permissoes?.pode_alterar_responsavel === true;
  };

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const [forros, paineis, acessorios, custosData, usuarios, demaisProdutos] = await Promise.all([
        produtoAPI.listarPorGrupo('Forro'),
        produtoAPI.listarPorGrupo('Painel'),
        produtoAPI.listarPorGrupo('Acessórios'),
        custoAPI.listarTodos(),
        usuarioAPI.listarAtivos(),
        produtoAPI.listarPorGrupo('Demais Produtos')
      ]);
      // Apenas Forro no dropdown principal
      setProdutosForro(forros);
      // Combina Acessórios + Painel no dropdown de acabamentos
      setAcessoriosLista([...acessorios, ...paineis]);
      setCustos(custosData);
      setListaUsuarios(usuarios);
      // Produtos Especiais (Demais Produtos)
      setProdutosEspeciais(demaisProdutos || []);
    } catch (error) {
      console.error('Erro:', error);
      showModal({ type: 'error', title: 'Erro', message: 'Erro ao carregar dados.', confirmText: 'OK', showCancel: false });
    } finally { setLoading(false); }
  };

  const gerarNumeroProposta = async () => {
    try {
      // ========================================
      // GERAR NÚMERO PROVISÓRIO (ANO-MÊS-????)
      // O número real será gerado no backend no momento de salvar
      // Isso evita conflitos de concorrência entre usuários
      // ========================================
      const dataAtual = new Date();
      const ano = dataAtual.getFullYear();
      const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
      const horaAtual = new Date().toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      
      // Número provisório - será substituído pelo backend
      const numeroProvisorio = `${ano}-${mes}-????`;
      
      const nomeResp = usuarioLogado?.nome_completo || usuarioLogado?.nome || usuarioLogado?.username_ldap || 'Não identificado';
      setPedido(prev => ({ ...prev, proposta: numeroProvisorio, hora: horaAtual, vendedor: nomeResp, bairro: cliente?.bairro || '' }));
    } catch (error) {
      const dataAtual = new Date();
      const numeroProvisorio = `${dataAtual.getFullYear()}-${String(dataAtual.getMonth() + 1).padStart(2, '0')}-????`;
      const nomeResp = usuarioLogado?.nome_completo || usuarioLogado?.nome || usuarioLogado?.username_ldap || 'Não identificado';
      setPedido(prev => ({ ...prev, proposta: numeroProvisorio, hora: new Date().toLocaleTimeString('pt-BR'), vendedor: nomeResp, bairro: cliente?.bairro || '' }));
    }
  };

  useEffect(() => {
    if (cliente && usuarioLogado) {
      gerarNumeroProposta();
      setPedidoSalvo(false); setPedidoSalvoId(null); setPedidoSalvoDados(null);
      setAprovacaoTab1(false); setAprovacaoTab2(false);
      // Resetar formas de pagamento quando cliente muda
      setFormasPagamento([
        { forma: '', observacao: '' },
        { forma: '', observacao: '' },
        { forma: '', observacao: '' },
        { forma: '', observacao: '' }
      ]);
    }
  }, [cliente, usuarioLogado]);

  // ========================================
  // CONSTANTES PARA ANÁLISE DE CRÉDITO PARCELADO
  // (Movido para antes dos returns condicionais)
  // ========================================
  // Cartão de Crédito NÃO é parcelado para a empresa (recebe à vista)
  const FORMAS_PARCELADAS_LISTA = [
    'Boleto à Prazo',
    'Cheque à Prazo',
    'Entrada + Parcelas'
  ];

  // Limites padrão por porte do cliente
  const LIMITES_PADRAO_PORTE = {
    '0': 1000,
    '1': 5000,
    '2': 10000,
    '3': 20000
  };

  // Função para verificar se o limite foi personalizado
  const verificarLimitePersonalizado = (porte, limiteAtual) => {
    if (!porte || !limiteAtual) return { personalizado: false, limitePadrao: 0 };
    const limitePadrao = LIMITES_PADRAO_PORTE[porte] || 0;
    return {
      personalizado: limiteAtual !== limitePadrao,
      limitePadrao: limitePadrao
    };
  };

  // Effect para recalcular análise quando forma de pagamento ou itens mudam
  // (Movido para antes dos returns condicionais para evitar erro de hooks)
  useEffect(() => {
    const temParcelado = formasPagamento.some(fp => FORMAS_PARCELADAS_LISTA.includes(fp.forma));
    
    if (cliente && temParcelado) {
      // Calcular análise de crédito inline
      const calcular = async () => {
        setAnaliseCredito(prev => ({ ...prev, carregando: true }));
        try {
          const resultado = await pedidoAPI.buscarPedidosParceladosCliente(cliente.id);
          
          // Calcular valor do pedido atual
          const calcResumoTab = (tabela) => {
            const itensForro = pedido.forro.filter(f => f.ordem === tabela && f.familia);
            const itensAcessorios = pedido.acessorios.filter(a => a.ordem === tabela && a.produto);
            let total = 0;
            itensForro.forEach(item => { total += parseFloat(item.total) || 0; });
            itensAcessorios.forEach(item => { total += parseFloat(item.total) || 0; });
            return total;
          };
          const valorAtual = calcResumoTab('Tabela 1') + calcResumoTab('Tabela 2');
          
          // Total geral = histórico de TODOS os pedidos + pedido atual
          const totalGeral = resultado.totalValor + valorAtual;
          const qtdTotal = resultado.quantidade + (valorAtual > 0 ? 1 : 0);
          
          // Média = total geral / quantidade de pedidos
          const media = qtdTotal > 0 ? totalGeral / qtdTotal : 0;
          
          const limiteCredito = parseFloat(cliente.limite_credito) || 0;
          
          // Calcular percentual do limite (média / limite * 100)
          const percentualDoLimite = limiteCredito > 0 ? (media / limiteCredito) * 100 : 0;
          
          // Ultrapassou apenas se passar de 150% do limite
          const ultrapassou = percentualDoLimite > 150;
          
          // Verificar se o limite foi personalizado
          const infoLimite = verificarLimitePersonalizado(cliente.porte, limiteCredito);

          setAnaliseCredito({
            carregando: false,
            pedidosTodos: resultado.pedidos,
            pedidosParcelados: resultado.pedidosParcelados || [],
            totalHistorico: resultado.totalValor,
            totalHistoricoParcelados: resultado.totalValorParcelados || 0,
            quantidade: resultado.quantidade,
            quantidadeParcelados: resultado.quantidadeParcelados || 0,
            valorPedidoAtual: valorAtual,
            totalGeral: totalGeral,
            quantidadeTotal: qtdTotal,
            mediaParcelado: media,
            limiteCredito: limiteCredito,
            porte: cliente.porte || 'Não definido',
            ultrapassouLimite: ultrapassou,
            percentualParcelamento: resultado.percentualParcelamento || 0,
            percentualDoLimite: percentualDoLimite,
            limitePersonalizado: infoLimite.personalizado,
            limitePadrao: infoLimite.limitePadrao
          });
        } catch (error) {
          console.error('Erro ao calcular análise de crédito:', error);
          setAnaliseCredito(prev => ({ ...prev, carregando: false }));
        }
      };
      calcular();
    } else {
      setAnaliseCredito({
        carregando: false,
        pedidosTodos: [],
        pedidosParcelados: [],
        totalHistorico: 0,
        totalHistoricoParcelados: 0,
        quantidade: 0,
        quantidadeParcelados: 0,
        valorPedidoAtual: 0,
        totalGeral: 0,
        quantidadeTotal: 0,
        mediaParcelado: 0,
        limiteCredito: 0,
        porte: '',
        ultrapassouLimite: false,
        percentualParcelamento: 0,
        percentualDoLimite: 0,
        limitePersonalizado: false,
        limitePadrao: 0
      });
    }
  }, [cliente, formasPagamento, pedido.forro, pedido.acessorios]);

  // Fechar sugestões ao clicar fora
  React.useEffect(() => {
    const handleClickFora = (e) => {
      if (
        sugestoesRef.current && !sugestoesRef.current.contains(e.target) &&
        buscaNomeRef.current && !buscaNomeRef.current.contains(e.target)
      ) {
        setMostrarSugestoes(false);
      }
    };
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, []);

  if (telaAtual === 'consulta') return <ConsultaPedidos setTelaAtual={setTelaAtual} />;

  if (loading) {
    return <Loading texto="Carregando sistema..." tamanho="lg" fullScreen={true} />;
  }

  // Função para formatar números no padrão brasileiro (1.234,56)
  const formatarMoeda = (valor) => {
    return (valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Detectar se o valor digitado parece um CPF/CNPJ (maioria números) ou nome
  const pareceDocumento = (valor) => {
    const somenteNumeros = valor.replace(/[.\-\/\s]/g, '');
    return /^\d+$/.test(somenteNumeros) && somenteNumeros.length >= 1;
  };

  // Handler do campo unificado de busca
  const handleCampoBusca = (valor) => {
    setCnpj(valor);
    
    // Se parece documento, não busca por nome
    if (pareceDocumento(valor)) {
      setSugestoesClientes([]);
      setMostrarSugestoes(false);
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      return;
    }
    
    // Se parece nome, busca com debounce
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (valor.trim().length < 2) {
      setSugestoesClientes([]);
      setMostrarSugestoes(false);
      return;
    }
    setBuscandoNome(true);
    debounceTimerRef.current = setTimeout(async () => {
      try {
        const resultados = await clienteAPI.buscarPorNome(valor.trim());
        setSugestoesClientes(resultados);
        setMostrarSugestoes(resultados.length > 0);
      } catch (err) {
        console.error('Erro ao buscar clientes por nome:', err);
        setSugestoesClientes([]);
      } finally {
        setBuscandoNome(false);
      }
    }, 300);
  };

  // Selecionar cliente da lista de sugestões - preenche CPF/CNPJ e já busca
  const selecionarClienteSugestao = (clienteSelecionado) => {
    setCnpj(clienteSelecionado.cnpj || '');
    setMostrarSugestoes(false);
    setSugestoesClientes([]);
    // Buscar automaticamente após selecionar
    if (clienteSelecionado.cnpj) {
      setTimeout(() => buscar(clienteSelecionado.cnpj), 100);
    }
  };

  const buscar = async (cnpjParam) => {
    try {
      const cnpjBusca = cnpjParam || cnpj;
      const clienteEncontrado = await clienteAPI.buscarPorCNPJ(cnpjBusca);
      if (clienteEncontrado) { 
        // Usar status calculado ou status original para verificação
        const statusParaVerificar = clienteEncontrado.status_calculado || clienteEncontrado.status_cadastro;
        
        // Verificar status do cadastro - Status que bloqueiam pedidos
        if (statusParaVerificar === 'EM_ANALISE' || statusParaVerificar === 'PENDENTE') {
          showModal({ 
            type: 'warning', 
            title: 'Cadastro em Análise', 
            message: 'Este cliente está com o cadastro em análise. Aguarde a aprovação para criar pedidos.', 
            confirmText: 'Entendi', 
            showCancel: false 
          });
          return;
        }
        if (statusParaVerificar === 'REJEITADO') {
          showModal({ 
            type: 'error', 
            title: 'Cadastro Rejeitado', 
            message: 'Este cliente teve o cadastro rejeitado. Entre em contato com o Administrativo para mais detalhes.', 
            confirmText: 'Entendi', 
            showCancel: false 
          });
          return;
        }
        if (statusParaVerificar === 'EXCLUIDO') {
          showModal({ 
            type: 'error', 
            title: 'Cliente Excluído', 
            message: 'Este cliente foi excluído do sistema. Entre em contato com o Administrativo para mais detalhes.', 
            confirmText: 'Entendi', 
            showCancel: false 
          });
          return;
        }
        
        // Cliente pode fazer pedido - setar o cliente
        setCliente(clienteEncontrado);
        setObservacaoCliente(clienteEncontrado.observacao_analise || '');
        setShowCadastro(false);
      }
      else { showModal({ type: 'warning', title: 'Não encontrado', message: 'Deseja cadastrar?', confirmText: 'Cadastrar', cancelText: 'Cancelar', showCancel: true, onConfirm: () => setShowCadastro(true) }); }
    } catch (error) { showModal({ type: 'error', title: 'Erro', message: 'Erro ao buscar.', confirmText: 'OK', showCancel: false }); }
  };
  
  const salvar = async () => {
    // Validar campos obrigatórios
    if (!novoCliente.nome || !novoCliente.cnpj) { 
      showModal({ type: 'warning', title: 'Campos obrigatórios', message: 'Preencha Nome e CPF/CNPJ.', confirmText: 'OK', showCancel: false }); 
      return; 
    }

    // Validar telefone obrigatório
    if (!novoCliente.telefone || !validarTelefone(novoCliente.telefone)) {
      showModal({ type: 'warning', title: 'Telefone inválido', message: 'Informe um telefone válido no formato (99) 9999-9999 ou (99) 99999-9999.', confirmText: 'OK', showCancel: false });
      return;
    }

    // Validar formato de CPF/CNPJ
    if (!validarCpfCnpj(novoCliente.cnpj)) {
      showModal({ type: 'warning', title: 'CPF/CNPJ inválido', message: 'Informe um CPF (11 dígitos) ou CNPJ (14 dígitos) válido.', confirmText: 'OK', showCancel: false });
      return;
    }

    // Verificar se tem erro de duplicidade
    if (erroValidacao.cnpj) {
      showModal({ type: 'error', title: 'Cliente já cadastrado', message: 'Já existe um cliente cadastrado com este CPF/CNPJ. Utilize a busca para encontrá-lo.', confirmText: 'OK', showCancel: false });
      return;
    }

    try {
      // Passar usuário logado para registrar o vendedor responsável
      const resultado = await clienteAPI.criar(novoCliente, usuarioLogado);
      setShowCadastro(false);
      setNovoCliente({ nome: '', cnpj: '', endereco: '', bairro: '', cidade: '', estado: 'Parana', telefone: '', email: '', rede: '', data_constituicao_nascimento: '' });
      setErroValidacao({ cnpj: '', telefone: '' });
      setCnpj('');
      
      // Verificar se foi aprovado automaticamente
      if (resultado?.aprovadoAutomaticamente) {
        // Se foi aprovado automaticamente, já pode usar o cliente
        setCliente(resultado.cliente);
        setObservacaoCliente(resultado.cliente.observacao_analise || '');
        showModal({ 
          type: 'success', 
          title: 'Cliente Aprovado Automaticamente!', 
          message: 'O cliente foi cadastrado e aprovado automaticamente com Porte 1 (Limite R$ 5.000,00). Você já pode criar pedidos para este cliente!', 
          confirmText: 'OK', 
          showCancel: false 
        });
      } else {
        // Não setar o cliente como selecionado, pois ainda está pendente de aprovação
        showModal({ 
          type: 'success', 
          title: 'Cliente Enviado para Análise', 
          message: 'O cadastro do cliente foi enviado para aprovação. Você será notificado quando o cadastro for aprovado e poderá criar pedidos para este cliente.', 
          confirmText: 'OK', 
          showCancel: false 
        });
      }
    } catch (error) { showModal({ type: 'error', title: 'Erro', message: error.code === '23505' ? 'CPF/CNPJ já existe.' : 'Erro ao cadastrar.', confirmText: 'OK', showCancel: false }); }
  };

  const getCusto = (familia_produto, estado, tabela) => {
    // Busca exata primeiro
    let c = custos.find(x => x.familia_produto === familia_produto && x.estado === estado && x.tipo_tabela === tabela);
    
    // Se não encontrou, tenta busca case-insensitive e sem espaços extras
    if (!c) {
      const familiaNorm = (familia_produto || '').toLowerCase().replace(/\s+/g, ' ').trim();
      const estadoNorm = (estado || '').toLowerCase().trim();
      const tabelaNorm = (tabela || '').toLowerCase().trim();
      c = custos.find(x => 
        (x.familia_produto || '').toLowerCase().replace(/\s+/g, ' ').trim() === familiaNorm &&
        (x.estado || '').toLowerCase().trim() === estadoNorm &&
        (x.tipo_tabela || '').toLowerCase().trim() === tabelaNorm
      );
    }
    
    return c ? parseFloat(c.custo_producao) : 0;
  };

  // Função para obter margem exigida do produto
  const getMargemExigida = (familia_produto, estado, tabela) => {
    // Busca exata primeiro
    let c = custos.find(x => x.familia_produto === familia_produto && x.estado === estado && x.tipo_tabela === tabela);
    
    // Se não encontrou, tenta busca case-insensitive e sem espaços extras
    if (!c) {
      const familiaNorm = (familia_produto || '').toLowerCase().replace(/\s+/g, ' ').trim();
      const estadoNorm = (estado || '').toLowerCase().trim();
      const tabelaNorm = (tabela || '').toLowerCase().trim();
      c = custos.find(x => 
        (x.familia_produto || '').toLowerCase().replace(/\s+/g, ' ').trim() === familiaNorm &&
        (x.estado || '').toLowerCase().trim() === estadoNorm &&
        (x.tipo_tabela || '').toLowerCase().trim() === tabelaNorm
      );
    }
    
    return c ? parseFloat(c.margem_exigida) : 0;
  };

  // Função para formatar pontuação (trava máx 50, sem "+" na frente)
  const formatarPontuacao = (valor) => {
    const pontuacao = valor || 0;
    // Trava máxima de 50 pontos para exibição
    const pontuacaoExibida = pontuacao > 50 ? 50 : pontuacao;
    return pontuacaoExibida.toFixed(2).replace('.', ',');
  };

  // Função para limpar nome de produto removendo código no início (ex: "R Rodaforro..." vira "Rodaforro...")
  const limparNomeProduto = (nome) => {
    if (!nome) return nome;
    // Remove código de 1-3 caracteres seguido de espaço no início do nome
    return nome.replace(/^[A-Z0-9]{1,3}\s+/, '');
  };

  // Função para obter valor sugerido de venda
  const getValorSugerido = (familia_produto, estado, tabela) => {
    const c = custos.find(x => x.familia_produto === familia_produto && x.estado === estado && x.tipo_tabela === tabela);
    return c ? parseFloat(c.valor_sugerido_venda) : 0;
  };

  // Função para obter valor mínimo de venda
  const getValorMinimo = (familia_produto, estado, tabela) => {
    const c = custos.find(x => x.familia_produto === familia_produto && x.estado === estado && x.tipo_tabela === tabela);
    return c ? parseFloat(c.valor_minimo_venda) : 0;
  };

  const calcResumo = (tabela) => {
    const estadoCliente = cliente?.estado || 'Parana';
    // tabela pode ser 'Tabela 1', 'Tabela 2', 1 ou 2
    const tipoTabela = tabela === 1 || tabela === 'Tabela 1' ? 'Tabela 1' : 'Tabela 2';
    const itensForro = pedido.forro.filter(f => f.ordem === tipoTabela && f.familia);
    const itensAcessorios = pedido.acessorios.filter(a => a.ordem === tipoTabela && a.produto);
    
    // Se não tem itens nesta tabela, retorna tudo como null/zero
    const temItens = itensForro.length > 0 || itensAcessorios.length > 0;
    
    if (!temItens) {
      return { 
        resumo: [], 
        resumoDetalhado: [],
        valorGerado: 0, 
        valorForro: 0,
        valorAcabamento: 0,
        custoProducao: 0, 
        lucro: 0, 
        margem: 0,
        margemExigidaMedia: 0,
        diferencaMargem: 0, 
        pontuacao: 0, 
        tabela,
        temItens: false
      };
    }
    
    // ========================================
    // NOVA LÓGICA: Agrupar por FAMÍLIA do forro (não por forroId)
    // Se tem 2 linhas de "Forro 6mm" com metragens diferentes, soma tudo
    // A pontuação é calculada sobre o TOTAL da família
    // ========================================
    
    // Primeiro, agrupar forros por FAMÍLIA
    const gruposPorFamilia = {};
    
    itensForro.forEach(forro => {
      const familia = forro.familia;
      if (!gruposPorFamilia[familia]) {
        gruposPorFamilia[familia] = {
          familia: familia,
          // Margem exigida vem da família
          margemExigida: getMargemExigida(familia, estadoCliente, tipoTabela),
          // Totais do grupo (todos os forros da mesma família + acabamentos)
          totalVenda: 0,
          custoTotal: 0,
          // Totais separados para exibição
          totalForro: 0,
          custoForro: 0,
          qtdeForro: 0, // Total de m² da família
          totalAcabamentos: 0,
          custoAcabamentos: 0,
          // Lista de forroIds desta família (para vincular acabamentos)
          forroIds: [],
          // Lista de acabamentos da família
          acabamentos: []
        };
      }
      
      const qtdeForro = parseFloat(forro.m2) || 0;
      const totalForro = parseFloat(forro.total) || 0;
      const custoForro = qtdeForro * (parseFloat(forro.custo) || 0);
      
      gruposPorFamilia[familia].qtdeForro += qtdeForro;
      gruposPorFamilia[familia].totalForro += totalForro;
      gruposPorFamilia[familia].custoForro += custoForro;
      gruposPorFamilia[familia].totalVenda += totalForro;
      gruposPorFamilia[familia].custoTotal += custoForro;
      gruposPorFamilia[familia].forroIds.push(forro.id);
    });
    
    // Depois, adicionar acabamentos às suas respectivas famílias (pelo forroId)
    // IMPORTANTE: nenhum acabamento pode ficar de fora do total.
    // Antes, quando o vínculo com o forro pai não era encontrado (id string x number,
    // forro pai removido, tabela trocada só no acabamento), o acabamento continuava
    // aparecendo nas linhas do pedido mas o valor sumia de valorGerado — e é justamente
    // esse valorGerado que vai para valor_tabela1/valor_tabela2 no banco.
    let fallbackIndex = 0; // Round-robin para distribuir órfãos entre os forros
    itensAcessorios.forEach(acess => {
      const forroId = acess.forroId;

      // 1. Match direto com o forro pai (tolerante a string x number)
      let forroPai = (forroId !== undefined && forroId !== null)
        ? itensForro.find(f => String(f.id) === String(forroId))
        : null;

      // 2. FALLBACK: distribui órfãos round-robin entre os forros da tabela
      if (!forroPai && itensForro.length > 0) {
        forroPai = itensForro[fallbackIndex % itensForro.length];
        fallbackIndex++;
      }

      // Família de destino: a do forro pai ou, se a tabela não tem nenhum forro,
      // a família do próprio acabamento (para o valor não se perder)
      const familia = forroPai ? forroPai.familia : (acess.familia || acess.produto);
      if (!familia) return;

      if (!gruposPorFamilia[familia]) {
        gruposPorFamilia[familia] = {
          familia: familia,
          margemExigida: getMargemExigida(familia, estadoCliente, tipoTabela),
          totalVenda: 0,
          custoTotal: 0,
          totalForro: 0,
          custoForro: 0,
          qtdeForro: 0,
          totalAcabamentos: 0,
          custoAcabamentos: 0,
          forroIds: [],
          acabamentos: []
        };
      }

      const qtdeAcess = parseInt(acess.qtde) || 0;
      const totalAcess = parseFloat(acess.total) || 0;
      const custoAcess = qtdeAcess * (parseFloat(acess.custo) || 0);

      gruposPorFamilia[familia].acabamentos.push({
        produto: acess.produto,
        qtde: qtdeAcess,
        preco: parseFloat(acess.preco) || 0,
        custo: parseFloat(acess.custo) || 0,
        total: totalAcess,
        forroId: forroId
      });

      gruposPorFamilia[familia].totalAcabamentos += totalAcess;
      gruposPorFamilia[familia].custoAcabamentos += custoAcess;
      gruposPorFamilia[familia].totalVenda += totalAcess;
      gruposPorFamilia[familia].custoTotal += custoAcess;
    });
    
    // Calcular métricas para cada FAMÍLIA (forro agrupado + acabamentos)
    let somaValores = 0;
    let somaPontuacaoPonderada = 0;
    let somaMargemExigidaPonderada = 0;
    
    // Famílias que têm pontuação dividida por 3
    const FAMILIAS_PONTUACAO_DIVIDIDA = ['Forro 8 mm', 'Forro Colorido'];
    
    Object.values(gruposPorFamilia).forEach(grupo => {
      const totalGrupo = grupo.totalVenda || 0;
      const custoGrupo = grupo.custoTotal || 0;
      const lucroGrupo = totalGrupo - custoGrupo;
      
      // Margem atingida = (Lucro / Total Venda) * 100 - calculada no TOTAL da FAMÍLIA
      const margemAtingida = totalGrupo > 0 ? (lucroGrupo / totalGrupo) * 100 : 0;
      
      // Margem exigida vem da FAMÍLIA
      const margemExigida = grupo.margemExigida || 0;
      
      // Margem mínima exigida em R$ = Total Venda da FAMÍLIA * Margem Exigida %
      const margemExigidaReais = totalGrupo * (margemExigida / 100);
      
      // Diferença em R$ = Lucro da FAMÍLIA - Margem Mínima Exigida (R$)
      const diferencaReais = lucroGrupo - margemExigidaReais;
      
      // Pontuação da família = Margem Atingida % - Margem Exigida %
      let pontuacaoGrupo = margemAtingida - margemExigida;
      
      // Se a família for "Forro 8 mm" ou "Forro Colorido", dividir pontuação por 3
      if (FAMILIAS_PONTUACAO_DIVIDIDA.includes(grupo.familia)) {
        pontuacaoGrupo = pontuacaoGrupo / 3;
      }
      
      // Aplicar limitador de 50 pontos por família
      const pontuacaoGrupoLimitada = Math.min(pontuacaoGrupo, 50);
      
      // Guardar métricas no grupo
      grupo.lucro = lucroGrupo;
      grupo.margemAtingida = margemAtingida;
      grupo.margemExigidaReais = margemExigidaReais;
      grupo.diferencaReais = diferencaReais;
      grupo.pontuacao = pontuacaoGrupo; // Pontuação real (sem limite)
      grupo.pontuacaoLimitada = pontuacaoGrupoLimitada; // Pontuação com limite de 50
      
      // Somar para cálculos totais
      somaMargemExigidaPonderada += margemExigida * totalGrupo;
      somaValores += totalGrupo;
      // Somar as pontuações LIMITADAS de cada família
      somaPontuacaoPonderada += pontuacaoGrupoLimitada;
    });
    
    // Criar entradas para o resumo
    // Forros são agrupados por FAMÍLIA, acabamentos aparecem individualmente
    const resumoLinhas = [];
    
    // Adicionar cada família de forro ao resumo
    Object.values(gruposPorFamilia).forEach(grupo => {
      const forroTotal = grupo.totalForro;
      const forroCusto = grupo.custoForro;
      const forroLucro = forroTotal - forroCusto;
      const forroMargemAtingida = forroTotal > 0 ? (forroLucro / forroTotal) * 100 : 0;
      const forroMargemExigidaReais = forroTotal * (grupo.margemExigida / 100);
      const forroDiferencaReais = forroLucro - forroMargemExigidaReais;
      
      // Preço médio ponderado por m²
      const precoMedio = grupo.qtdeForro > 0 ? forroTotal / grupo.qtdeForro : 0;
      
      // Grupos criados só por acabamento órfão (tabela sem forro) não geram linha de forro
      if (grupo.forroIds.length > 0) resumoLinhas.push({
        produto: grupo.familia,
        preco: precoMedio,
        qtdade: grupo.qtdeForro,
        total: forroTotal,
        custoUnit: grupo.qtdeForro > 0 ? forroCusto / grupo.qtdeForro : 0,
        custoTotal: forroCusto,
        margemExigida: grupo.margemExigida,
        isForro: true,
        lucro: forroLucro,
        margemAtingida: forroMargemAtingida,
        margemExigidaReais: forroMargemExigidaReais,
        diferencaReais: forroDiferencaReais,
        pontuacao: grupo.pontuacaoLimitada // Pontuação da família
      });
      
      // Adicionar acabamentos AGRUPADOS por produto (ex: rodaforros iguais são somados)
      const acabamentosAgrupados = {};
      
      grupo.acabamentos.forEach(acess => {
        const produtoNome = acess.produto;
        
        if (!acabamentosAgrupados[produtoNome]) {
          acabamentosAgrupados[produtoNome] = {
            produto: produtoNome,
            preco: acess.preco,
            custo: acess.custo,
            qtde: 0,
            total: 0,
            custoTotal: 0,
            forroId: acess.forroId
          };
        }
        
        acabamentosAgrupados[produtoNome].qtde += acess.qtde || 0;
        acabamentosAgrupados[produtoNome].total += acess.total || 0;
        acabamentosAgrupados[produtoNome].custoTotal += (acess.qtde || 0) * (acess.custo || 0);
      });
      
      // Adicionar os acabamentos agrupados ao resumo
      Object.values(acabamentosAgrupados).forEach(acessAgrupado => {
        const acessTotal = acessAgrupado.total || 0;
        const acessCusto = acessAgrupado.custoTotal || 0;
        const acessLucro = acessTotal - acessCusto;
        const acessMargemAtingida = acessTotal > 0 ? (acessLucro / acessTotal) * 100 : 0;
        const acessMargemExigidaReais = acessTotal * (grupo.margemExigida / 100);
        const acessDiferencaReais = acessLucro - acessMargemExigidaReais;
        
        resumoLinhas.push({
          produto: acessAgrupado.produto,
          preco: acessAgrupado.preco,
          qtdade: acessAgrupado.qtde,
          total: acessTotal,
          custoUnit: acessAgrupado.custo,
          custoTotal: acessCusto,
          margemExigida: grupo.margemExigida, // Usa margem da família
          isForro: false,
          isAcabamento: true,
          forroId: acessAgrupado.forroId,
          lucro: acessLucro,
          margemAtingida: acessMargemAtingida,
          margemExigidaReais: acessMargemExigidaReais,
          diferencaReais: acessDiferencaReais,
          pontuacao: grupo.pontuacaoLimitada // Usa pontuação da família
        });
      });
    });
    
    const valorGerado = Object.values(gruposPorFamilia).reduce((s, g) => s + (g.totalVenda || 0), 0);
    const custoProducao = Object.values(gruposPorFamilia).reduce((s, g) => s + (g.custoTotal || 0), 0);
    const lucro = valorGerado - custoProducao;
    
    // Margem atingida geral do orçamento
    const margem = valorGerado > 0 ? (lucro / valorGerado) * 100 : 0;
    
    // Margem exigida média ponderada pelo valor de cada grupo
    const margemExigidaMedia = somaValores > 0 ? somaMargemExigidaPonderada / somaValores : 0;
    
    // Margem exigida em R$ do total = Total Venda * Margem Exigida Média %
    const margemExigidaReaisTotal = valorGerado * (margemExigidaMedia / 100);
    
    // Diferença em R$ = Lucro Total - Margem Exigida Total (R$)
    const diferencaReaisTotal = lucro - margemExigidaReaisTotal;
    
    // Pontuação final = SOMA das pontuações limitadas de cada família
    // Cada família tem limite de 50 pontos, depois soma tudo
    const pontuacao = somaPontuacaoPonderada;
    
    // Calcular valores separados de Forro e Acabamento
    const valorForro = Object.values(gruposPorFamilia).reduce((s, g) => s + (g.totalForro || 0), 0);
    const valorAcabamento = Object.values(gruposPorFamilia).reduce((s, g) => s + (g.totalAcabamentos || 0), 0);
    
    return { 
      resumo: resumoLinhas, 
      resumoDetalhado: resumoLinhas,
      valorGerado, 
      valorForro,
      valorAcabamento,
      custoProducao, 
      lucro, 
      margem,
      margemExigidaMedia,
      margemExigidaReaisTotal,
      diferencaReaisTotal,
      pontuacao, 
      tabela,
      temItens: true
    };
  };

  // ========================================
  // FUNÇÃO CORRIGIDA: Determinar status de aprovação
  // ========================================
  const determinarStatusAprovacao = (statusViabilidade, temItens) => {
    // Se não tem itens, não precisa de aprovação
    if (!temItens) return null;
    
    // EXCELENTE, BOA VENDA e VIÁVEL são auto-aprovados (não precisam de aprovação)
    if (['EXCELENTE', 'BOA VENDA', 'VIÁVEL'].includes(statusViabilidade)) {
      return null;
    }
    
    // Apenas EM ANÁLISE e INVIÁVEL precisam de aprovação
    if (['EM ANÁLISE', 'INVIÁVEL'].includes(statusViabilidade)) {
      return 'PENDENTE';
    }
    
    return null;
  };

  // ========================================
  // FUNÇÕES PARA ANÁLISE DE CRÉDITO PARCELADO
  // (FORMAS_PARCELADAS_LISTA está definida antes dos returns condicionais)
  // ========================================

  // Verifica se alguma forma de pagamento selecionada é parcelada
  const temFormaPagamentoParcelada = () => {
    return formasPagamento.some(fp => FORMAS_PARCELADAS_LISTA.includes(fp.forma));
  };

  // Calcular valor do pedido atual (Tabela 1 + Tabela 2)
  const calcularValorPedidoAtual = () => {
    const tab1 = calcResumo('Tabela 1');
    const tab2 = calcResumo('Tabela 2');
    return (tab1.valorGerado || 0) + (tab2.valorGerado || 0);
  };

  // Buscar análise de crédito quando forma parcelada for selecionada
  const calcularAnaliseCredito = async () => {
    if (!cliente || !temFormaPagamentoParcelada()) {
      setAnaliseCredito({
        carregando: false,
        pedidosParcelados: [],
        totalHistorico: 0,
        quantidade: 0,
        valorPedidoAtual: 0,
        mediaParcelado: 0,
        limiteCredito: 0,
        porte: '',
        ultrapassouLimite: false
      });
      return;
    }

    setAnaliseCredito(prev => ({ ...prev, carregando: true }));

    try {
      // Buscar pedidos parcelados dos últimos 3 meses
      const resultado = await pedidoAPI.buscarPedidosParceladosCliente(cliente.id);
      
      // Valor do pedido atual
      const valorAtual = calcularValorPedidoAtual();
      
      // Total = histórico + pedido atual
      const totalGeral = resultado.totalValor + valorAtual;
      
      // Quantidade total = pedidos anteriores + pedido atual (se tem valor)
      const qtdTotal = resultado.quantidade + (valorAtual > 0 ? 1 : 0);
      
      // Média = total / quantidade
      const media = qtdTotal > 0 ? totalGeral / qtdTotal : 0;
      
      // Limite de crédito do cliente
      const limiteCredito = parseFloat(cliente.limite_credito) || 0;
      
      // Verificar se ultrapassou o limite
      const ultrapassou = media > limiteCredito && limiteCredito > 0;

      setAnaliseCredito({
        carregando: false,
        pedidosParcelados: resultado.pedidos,
        totalHistorico: resultado.totalValor,
        quantidade: resultado.quantidade,
        valorPedidoAtual: valorAtual,
        totalGeral: totalGeral,
        quantidadeTotal: qtdTotal,
        mediaParcelado: media,
        limiteCredito: limiteCredito,
        porte: cliente.porte || 'Não definido',
        ultrapassouLimite: ultrapassou
      });
    } catch (error) {
      console.error('Erro ao calcular análise de crédito:', error);
      setAnaliseCredito(prev => ({ ...prev, carregando: false }));
    }
  };

  // Funções auxiliares para formas de pagamento
  const atualizarFormaPagamento = (index, campo, valor) => {
    if (pedidoSalvo) return;
    const novasFormas = [...formasPagamento];
    novasFormas[index][campo] = valor;
    setFormasPagamento(novasFormas);
  };

  const limparFormaPagamento = (index) => {
    if (pedidoSalvo) return;
    const novasFormas = [...formasPagamento];
    novasFormas[index] = { forma: '', observacao: '' };
    setFormasPagamento(novasFormas);
  };

  const getFormasPagamentoSelecionadas = () => {
    return formasPagamento.filter(f => f.forma !== '').length;
  };

  const salvarPedido = async () => {
    if (!cliente) { showModal({ type: 'warning', title: 'Selecione cliente', message: 'Selecione um cliente.', confirmText: 'OK', showCancel: false }); return; }
    if (!pedido.proposta) { showModal({ type: 'warning', title: 'Proposta', message: 'Proposta não gerada.', confirmText: 'OK', showCancel: false }); return; }

    // Validar: deve ter forros/acessórios OU produtos especiais
    const temProdutosNormais = pedido.forro.length > 0 || pedido.acessorios.length > 0;
    const temProdutosEspeciais = itensEspeciais.length > 0;
    
    if (!temProdutosNormais && !temProdutosEspeciais) { 
      showModal({ type: 'warning', title: 'Vazio', message: 'Adicione itens ao pedido.', confirmText: 'OK', showCancel: false }); 
      return; 
    }
    
    // Se estiver no modo especial, validar os itens especiais
    if (modoVendaEspecial) {
      const itensEspeciaisValidos = itensEspeciais.filter(item => item.produto && parseFloat(item.total) > 0);
      if (itensEspeciaisValidos.length === 0) {
        showModal({ 
          type: 'warning', 
          title: 'Produtos Especiais', 
          message: 'Adicione pelo menos um produto especial com valor válido.', 
          confirmText: 'OK', 
          showCancel: false 
        }); 
        return;
      }
    }
    
    // Validar preços mínimos (forros + acessórios)
    const forrosAbaixoMinimo = pedido.forro.filter(f => f.abaixoMinimo);
    const acessoriosAbaixoMinimo = pedido.acessorios.filter(a => a.abaixoMinimo);
    const totalAbaixoMinimo = forrosAbaixoMinimo.length + acessoriosAbaixoMinimo.length;
    
    if (totalAbaixoMinimo > 0) {
      const podeVenderAbaixoMinimo = usuarioLogado?.permissoes?.pode_vender_abaixo_minimo === true || usuarioLogado?.pode_vender_abaixo_minimo === true;
      
      if (!podeVenderAbaixoMinimo) {
        // Sem permissão: bloqueia salvamento
        const tipoMsg = forrosAbaixoMinimo.length > 0 && acessoriosAbaixoMinimo.length > 0
          ? `${forrosAbaixoMinimo.length} forro(s) e ${acessoriosAbaixoMinimo.length} acessório(s)`
          : forrosAbaixoMinimo.length > 0
            ? `${forrosAbaixoMinimo.length} forro(s)`
            : `${acessoriosAbaixoMinimo.length} acessório(s)`;
        showModal({ 
          type: 'error', 
          title: 'Preço Abaixo do Mínimo', 
          message: `Existem ${tipoMsg} com preço abaixo do valor mínimo permitido. Corrija os valores destacados em vermelho antes de salvar.`, 
          confirmText: 'OK', 
          showCancel: false 
        });
        return;
      } else {
        // Com permissão: pede confirmação e continua o fluxo de validação/salvamento
        const tipoMsg = forrosAbaixoMinimo.length > 0 && acessoriosAbaixoMinimo.length > 0
          ? `${forrosAbaixoMinimo.length} forro(s) e ${acessoriosAbaixoMinimo.length} acessório(s)`
          : forrosAbaixoMinimo.length > 0
            ? `${forrosAbaixoMinimo.length} forro(s)`
            : `${acessoriosAbaixoMinimo.length} acessório(s)`;
        showModal({ 
          type: 'warning', 
          title: 'Preço Abaixo do Mínimo', 
          message: `Você tem certeza que deseja salvar este orçamento? Este orçamento contém ${tipoMsg} com preço abaixo do valor mínimo.`, 
          confirmText: 'Confirmar', 
          cancelText: 'Cancelar',
          showCancel: true,
          onConfirm: () => setTimeout(() => continuarSalvamentoPedido(), 100)
        });
        return;
      }
    }
    
    // Continuar validações e salvar
    continuarSalvamentoPedido();
  };

  const continuarSalvamentoPedido = () => {
    // Validar endereço de entrega
    if (mesmoEnderecoCliente === null) {
      showModal({ 
        type: 'warning', 
        title: 'Dados da Entrega', 
        message: 'Selecione se o endereço de entrega é o mesmo do cliente ou não.', 
        confirmText: 'OK', 
        showCancel: false 
      });
      return;
    }
    
    // Validar taxa de entrega
    if (temTaxaEntrega === null) {
      showModal({ 
        type: 'warning', 
        title: 'Taxa de Entrega', 
        message: 'Selecione se há taxa de entrega ou não.', 
        confirmText: 'OK', 
        showCancel: false 
      });
      return;
    }
    
    if (temTaxaEntrega === true && (!valorTaxaEntrega || parseFloat(valorTaxaEntrega) <= 0)) {
      showModal({ 
        type: 'warning', 
        title: 'Taxa de Entrega', 
        message: 'Informe o valor da taxa de entrega.', 
        confirmText: 'OK', 
        showCancel: false 
      });
      return;
    }
    // Validar forma de pagamento
    if (getFormasPagamentoSelecionadas() === 0) {
      showModal({ 
        type: 'warning', 
        title: 'Forma de Pagamento', 
        message: 'Selecione pelo menos uma forma de pagamento.', 
        confirmText: 'OK', 
        showCancel: false 
      });
      return;
    }
    
    // Validar observação obrigatória para certas formas de pagamento
    const formasSemObservacao = formasPagamento.filter(fp => {
      if (!fp.forma) return false;
      const formaConfig = FORMAS_PAGAMENTO.find(f => f.label === fp.forma);
      return formaConfig?.exigeObservacao && (!fp.observacao || fp.observacao.trim() === '');
    });
    
    if (formasSemObservacao.length > 0) {
      const nomes = formasSemObservacao.map(f => f.forma).join(', ');
      showModal({ 
        type: 'warning', 
        title: 'Observação Obrigatória', 
        message: `As seguintes formas de pagamento exigem observação: ${nomes}`, 
        confirmText: 'OK', 
        showCancel: false 
      });
      return;
    }
    showModal({ type: 'warning', title: 'Confirmar', message: 'Após salvar o orçamento, ele será enviado para aprovação e não poderá ser editado.', confirmText: 'Salvar Orçamento', cancelText: 'Cancelar', showCancel: true, onConfirm: executarSalvamentoPedido });
  };

  const executarSalvamentoPedido = async () => {
    try {
      // Capturar hora fim do pedido
      const horaFim = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      setHoraFimPedido(horaFim);

      const tab1 = calcResumo('Tabela 1');
      const tab2 = calcResumo('Tabela 2');
      
      // ========================================
      // LÓGICA CORRIGIDA: Status de viabilidade
      // ========================================
      // Se não tem itens na tabela, status = null
      // Se o valor gerado é 0, status = INVIÁVEL (não pode vender com valor zero)
      // Status baseado na PONTUAÇÃO (Margem Atingida - Margem Exigida)
      const status1 = tab1.temItens ? (tab1.valorGerado === 0 ? 'INVIÁVEL' : getStatusByScore(tab1.pontuacao)) : null;
      const status2 = tab2.temItens ? (tab2.valorGerado === 0 ? 'INVIÁVEL' : getStatusByScore(tab2.pontuacao)) : null;
      
      // ========================================
      // LÓGICA CORRIGIDA: Status de aprovação
      // ========================================
      const statusAprovacao1 = determinarStatusAprovacao(status1, tab1.temItens);
      const statusAprovacao2 = determinarStatusAprovacao(status2, tab2.temItens);
      
      // ========================================
      // CALCULAR STATUS GERAL E PONTUAÇÃO GERAL
      // ========================================
      const temForrosNormais = tab1.temItens || tab2.temItens;
      const temProdutosEspeciais = itensEspeciais.length > 0;
      const valorProdutosEspeciais = itensEspeciais.reduce((acc, item) => acc + (parseFloat(item.total) || 0), 0);
      
      // Total de venda = Forros + Produtos Especiais
      const totalVendaGeral = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0) + valorProdutosEspeciais;
      
      // Pontuação de cada tabela com cap de 50 (para não favorecer lucros excessivos)
      const pontTab1 = tab1.temItens ? Math.min(tab1.pontuacao || 0, 50) : 0;
      const pontTab2 = tab2.temItens ? Math.min(tab2.pontuacao || 0, 50) : 0;
      
      // Pontuação geral = SOMA das pontuações (cada uma limitada a 50)
      // Se tem APENAS produtos especiais, pontuação automática de 0.01
      let pontuacaoGeral = pontTab1 + pontTab2;
      if (!temForrosNormais && temProdutosEspeciais) {
        pontuacaoGeral = 0.01; // Pontuação mínima para VIÁVEL
      }
      
      // Status geral baseado na pontuação
      const statusGeral = (!temForrosNormais && !temProdutosEspeciais) ? 'INVIÁVEL' : getStatusByScore(pontuacaoGeral);
      
      // ========================================
      // Determinar fase e status do orçamento
      // ========================================
      // Todos os orçamentos começam aguardando próxima etapa
      
      const faseAtual = 'AGUARDANDO_PROXIMA_ETAPA';
      const statusLegivel = 'Aguardando Próxima Etapa';
      
      const pedidoData = {
        numero_proposta: pedido.proposta, 
        cliente_id: cliente.id,
        // Data no fuso horário de São Paulo (não UTC)
        data: new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Sao_Paulo' }), 
        hora: pedido.hora,
        hora_fim: horaFim,
        // Usuário que criou o pedido (quem está logado)
        usuario_criacao_pedido: usuarioLogado?.nome_completo || usuarioLogado?.nome || usuarioLogado?.username_ldap || 'Não identificado',
        // Vendedor/Responsável selecionado (pode ser diferente de quem criou)
        vendedor: pedido.vendedor, 
        bairro: cliente.bairro || pedido.bairro,
        
        // Dados da Entrega
        mesmo_endereco_cliente: mesmoEnderecoCliente === true,
        endereco_entrega: mesmoEnderecoCliente === true ? cliente.endereco : (enderecoEntrega || null),
        bairro_entrega: mesmoEnderecoCliente === true ? cliente.bairro : (bairroEntrega || null),
        cidade_entrega: mesmoEnderecoCliente === true ? cliente.cidade : (cidadeEntrega || null),
        estado_entrega: mesmoEnderecoCliente === true ? cliente.estado : (estadoEntrega || null),
        
        // Taxa de Entrega
        tem_taxa_entrega: temTaxaEntrega === true,
        valor_taxa_entrega: temTaxaEntrega === true ? parseFloat(valorTaxaEntrega) || 0 : null,
        
        // Tabela 1 - valores financeiros (null se não tem itens)
        valor_tabela1: tab1.temItens ? tab1.valorGerado : null,
        custo_tabela1: tab1.temItens ? tab1.custoProducao : null,
        lucro_tabela1: tab1.temItens ? tab1.lucro : null,
        margem_minima_tabela1: tab1.temItens ? tab1.margemMinima : null,
        diferenca_tabela1: tab1.temItens ? tab1.diferenca : null,
        pontuacao_tabela1: tab1.temItens ? tab1.pontuacao : null,
        margem_tabela1: tab1.temItens ? tab1.margem : null,
        status_tabela1: status1,  // null se não tem itens
        
        // Tabela 2 - valores financeiros (null se não tem itens)
        valor_tabela2: tab2.temItens ? tab2.valorGerado : null,
        custo_tabela2: tab2.temItens ? tab2.custoProducao : null,
        lucro_tabela2: tab2.temItens ? tab2.lucro : null,
        margem_minima_tabela2: tab2.temItens ? tab2.margemMinima : null,
        diferenca_tabela2: tab2.temItens ? tab2.diferenca : null,
        pontuacao_tabela2: tab2.temItens ? tab2.pontuacao : null,
        margem_tabela2: tab2.temItens ? tab2.margem : null,
        status_tabela2: status2,  // null se não tem itens
        
        // STATUS GERAL E PONTUAÇÃO GERAL DO PEDIDO
        status_geral: statusGeral,
        pontuacao_geral: pontuacaoGeral,
        
        // Valor total de produtos especiais (não entra na margem)
        valor_produtos_especiais: valorProdutosEspeciais,
        
        // Formas de pagamento
        forma_pagamento_1: formasPagamento[0].forma || null,
        observacao_pagamento_1: formasPagamento[0].observacao || null,
        forma_pagamento_2: formasPagamento[1].forma || null,
        observacao_pagamento_2: formasPagamento[1].observacao || null,
        forma_pagamento_3: formasPagamento[2].forma || null,
        observacao_pagamento_3: formasPagamento[2].observacao || null,
        forma_pagamento_4: formasPagamento[3].forma || null,
        observacao_pagamento_4: formasPagamento[3].observacao || null,
        
        // Observação geral do pedido
        observacao_pedido: observacaoPedido || null,
        
        // Observação do cliente (vinda do cadastro, possivelmente editada)
        observacao_cliente: observacaoCliente || null,
        
        // Análise de Crédito - guardar se extrapolou o limite (>150%)
        extrapolou_limite_credito: analiseCredito.ultrapassouLimite || false,
        percentual_limite_credito: analiseCredito.percentualDoLimite || 0,
        
        // ========================================
        // FLUXO: Todo pedido nasce como ORÇAMENTO
        // ========================================
        tipo_documento: 'ORCAMENTO',
        fase_atual: faseAtual,  // Fase do fluxo
        status: statusLegivel,  // Status legível
        aprovado_automaticamente: false,
        data_aprovacao_automatica: null,
        aprovado_por: null,
        observacao_aprovacao: null
      };
      
      // DEBUG: Log detalhado dos cálculos antes de salvar
      
      const pedidoCriado = await pedidoAPI.criar(pedidoData);
      
      // Salvar itens de forro (guardando o ID local para mapeamento)
      const forrosComIdLocal = pedido.forro.map(f => ({
        idLocal: f.id, // ID local do frontend para mapeamento
        pedido_id: pedidoCriado.id, 
        produto_codigo: f.codigo?.toString(), 
        produto_nome: f.produto, 
        familia_produto: f.familia || '', 
        tipo: f.tip, 
        tipo_tabela: f.ordem, 
        quantidade: parseInt(f.qtde) || 0, 
        comprimento: parseFloat(f.comp) || 0, 
        m2: parseFloat(f.m2) || 0, 
        preco_unitario: parseFloat(f.preco) || 0, 
        custo_unitario: parseFloat(f.custo) || 0, 
        total: parseFloat(f.total) || 0 
      }));
      const itensF = forrosComIdLocal.map(({ idLocal, ...rest }) => rest);
      
      // Inserir forros e criar mapeamento de ID local → ID do banco
      let mapaForroIds = {};
      if (itensF.length > 0) {
        const forrosInseridos = await pedidoAPI.inserirItensForro(itensF);
        // Mapear por ordem: forrosComIdLocal[i].idLocal → forrosInseridos[i].id
        forrosComIdLocal.forEach((f, i) => {
          if (forrosInseridos[i]) {
            mapaForroIds[f.idLocal] = forrosInseridos[i].id;
          }
        });
      }
      
      // Salvar itens de acessórios (usando ID do banco em vez do ID local)
      const itensA = pedido.acessorios.map(a => ({ 
        pedido_id: pedidoCriado.id, 
        produto_codigo: a.cod?.toString(), 
        produto_nome: a.produto, 
        familia_produto: a.familia || '', 
        tipo: a.tip, 
        tipo_tabela: a.ordem, 
        quantidade: parseInt(a.qtde) || 0, 
        preco_unitario: parseFloat(a.preco) || 0, 
        custo_unitario: parseFloat(a.custo) || 0, 
        total: parseFloat(a.total) || 0,
        forro_id: a.forroId ? (mapaForroIds[a.forroId] || null) : null
      }));
      
      // Preparar itens de produtos especiais (filtrar apenas itens válidos com produto selecionado)
      const itensE = itensEspeciais
        .filter(e => e.produto && e.total > 0) // Apenas itens com produto e valor
        .map(e => ({
          pedido_id: pedidoCriado.id,
          produto_codigo: e.codigo?.toString() || '',
          produto_nome: e.produto,
          familia_produto: e.familia || 'Demais Produtos',
          quantidade: parseInt(e.qtde) || 1,
          preco_unitario: parseFloat(e.preco) || 0,
          total: parseFloat(e.total) || 0
        }));
      
      if (itensA.length > 0) await pedidoAPI.inserirItensAcessorio(itensA);
      if (itensE.length > 0) await pedidoAPI.inserirItensEspeciais(itensE);
      
      setPedidoSalvo(true); 
      setPedidoSalvoId(pedidoCriado.id);
      setPedidoSalvoDados(pedidoCriado);
      setAprovacaoTab1(false);
      setAprovacaoTab2(false);
      // NÃO limpar itensEspeciais aqui para poder imprimir depois de salvar
      
      // Atualizar o número da proposta com o valor real gerado pelo backend
      const numeroReal = pedidoCriado.numero_proposta;
      setPedido(prev => ({ ...prev, proposta: numeroReal }));
      
      // Mensagem de sucesso ao salvar orçamento (usando número real do backend)
      showModal({ 
        type: 'success', 
        title: 'Orçamento Salvo!', 
        message: `Orçamento ${numeroReal} salvo com sucesso!`, 
        confirmText: 'OK', 
        showCancel: false 
      });
    } catch (error) {
      console.error('Erro ao salvar:', error);
      showModal(montarModalErro(error, { titulo: 'Erro', prefixo: 'Erro ao salvar: ' }));
    }
  };

  // Somente perfil de aprovação de cadastro pode alterar o NOME do cliente
  const podeEditarNomeCliente = (() => {
    if (!usuarioLogado) return false;
    const dep = (usuarioLogado.departamento || '').toLowerCase();
    return dep === 'admin' || dep === 'administrativo' || dep === 'diretoria' ||
           usuarioLogado.permissoes?.pode_aprovar_clientes === true;
  })();

  const iniciarEdicaoCliente = () => { setClienteEditado({ ...cliente }); setEditandoCliente(true); };
  const cancelarEdicaoCliente = () => { setClienteEditado(null); setEditandoCliente(false); };
  const salvarEdicaoCliente = async () => {
    if (!clienteEditado.nome || !clienteEditado.cnpj) { showModal({ type: 'warning', title: 'Campos', message: 'Nome e CNPJ obrigatórios.', confirmText: 'OK', showCancel: false }); return; }
    try {
      const atualizado = await clienteAPI.atualizar(clienteEditado.id, clienteEditado);
      setCliente(atualizado); setEditandoCliente(false); setClienteEditado(null);
      showModal({ type: 'success', title: 'Atualizado!', message: 'Cliente atualizado.', confirmText: 'OK', showCancel: false });
    } catch (error) { showModal({ type: 'error', title: 'Erro', message: 'Erro ao atualizar.', confirmText: 'OK', showCancel: false }); }
  };

  const iniciarNovoPedido = () => {
    setPedido({ data: new Date().toLocaleDateString('pt-BR'), hora: '', proposta: '', vendedor: '', bairro: '', forro: [], acessorios: [] });
    setCliente(null); setPedidoSalvo(false); setPedidoSalvoId(null); setPedidoSalvoDados(null);
    setCnpj('');
    setAprovacaoTab1(false); setAprovacaoTab2(false);
    // Resetar formas de pagamento
    setFormasPagamento([
      { forma: '', observacao: '' },
      { forma: '', observacao: '' },
      { forma: '', observacao: '' },
      { forma: '', observacao: '' }
    ]);
    // Resetar observação do pedido
    setObservacaoPedido('');
    // Resetar observação do cliente
    setObservacaoCliente('');
    // Resetar hora fim
    setHoraFimPedido('');
    // Resetar dados de entrega
    setMesmoEnderecoCliente(null);
    setEnderecoEntrega('');
    setBairroEntrega('');
    setCidadeEntrega('');
    setEstadoEntrega('Parana');
    // Resetar modo de venda especial e itens
    setModoVendaEspecial(false);
    setItensEspeciais([]);
  };

  const aprovarTabela = (tabela) => {
    const nome = usuarioLogado?.username_ldap || usuarioLogado?.nome_completo || 'Usuário';
    showModal({ type: 'warning', title: `Aprovar Tabela ${tabela}?`, message: 'Confirma aprovação?', confirmText: 'Aprovar', cancelText: 'Cancelar', showCancel: true,
      onConfirm: () => {
        if (tabela === 1) setAprovacaoTab1(true); else setAprovacaoTab2(true);
        showModal({ type: 'success', title: 'Aprovada!', message: `Tabela ${tabela} aprovada por ${nome}.`, confirmText: 'OK', showCancel: false });
      }
    });
  };

  const imprimirProposta = (tabela) => {
    const tabelaNum = tabela === 'Tabela 1' ? 1 : 2;
    // Imprime o registro que o servidor gravou — o mesmo que a Consulta de Pedidos
    // usa ao reabrir — para o impresso logo após salvar sair igual ao reaberto.
    // Montado só com os campos da tela, saía "Pedido Nº" no lugar de "Orçamento Nº"
    // e o endereço do cliente no lugar do endereço de entrega.
    const salvo = pedidoSalvoDados;
    // Envia { forma, observacao }: só o nome fazia a observação (ex.: "28/56")
    // sumir do impresso.
    const formasLabel = salvo
      ? [1, 2, 3, 4]
          .filter(n => salvo[`forma_pagamento_${n}`])
          .map(n => ({ forma: salvo[`forma_pagamento_${n}`], observacao: salvo[`observacao_pagamento_${n}`] || '' }))
      : formasPagamento
          .filter(f => f.forma)
          .map(f => {
            const formaConfig = FORMAS_PAGAMENTO.find(fp => fp.id === f.forma);
            return { forma: formaConfig ? formaConfig.label : f.forma, observacao: f.observacao || '' };
          });
    const observacaoImpressao = salvo ? (salvo.observacao_pedido || '') : observacaoPedido;
    
    // Calcular quantidade de tabelas com itens
    const qtdTabelas = (tab1.temItens && tab1.resumo.length > 0 ? 1 : 0) + (tab2.temItens && tab2.resumo.length > 0 ? 1 : 0);
    const freteTotal = temTaxaEntrega ? (parseFloat(valorTaxaEntrega) || 0) : 0;
    // Se só há produtos especiais (sem tabelas normais), o frete total vai para eles
    const fretePorTabela = qtdTabelas > 0 ? freteTotal / qtdTabelas : freteTotal;
    
    // Mapear produtos especiais para formato de impressão
    const produtosEspeciaisMapeados = itensEspeciais.map(e => ({
      produto_nome: e.produto,
      produto_codigo: e.codigo,
      familia_produto: e.familia || 'Demais Produtos',
      quantidade: e.qtde || 1,
      preco_unitario: e.preco || 0,
      total: e.total || 0
    }));
    
    imprimirPropostaService({
      pedido: salvo
        ? { ...salvo, observacao: observacaoImpressao }
        : {
            numero_proposta: pedido.proposta,
            data: pedido.data,
            vendedor: pedido.vendedor,
            observacao: observacaoImpressao
          },
      cliente: cliente,
      forros: pedido.forro,
      acessorios: pedido.acessorios,
      produtosEspeciais: produtosEspeciaisMapeados,
      formaPagamento: formasLabel,
      observacao: observacaoImpressao,
      tabela: tabelaNum,
      valorFrete: fretePorTabela,
      cargoUsuario: usuarioLogado?.departamento || ''
    });
  };

  // Gerar ID único para cada linha de forro
  const gerarForroId = () => `forro_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  const addForro = () => { 
    if (pedidoSalvo) return; 
    setPedido({ 
      ...pedido, 
      forro: [...pedido.forro, { 
        id: gerarForroId(), // ID único para vincular acabamentos
        m2: 0, produto: '', codigo: '', tip: '', familia: '', ordem: 'Tabela 1', qtde: 0, comp: 6, preco: 0, total: 0, custo: 0 
      }] 
    }); 
  };

  // Adicionar acabamento vinculado a uma linha específica de forro
  const addAcessorioParaForro = (forroId, forroOrdem) => { 
    if (pedidoSalvo) return; 
    setPedido({ 
      ...pedido, 
      acessorios: [...pedido.acessorios, { 
        forroId: forroId, // Vincula ao forro pai
        produto: '', cod: '', tip: '', familia: '', ordem: forroOrdem, qtde: 0, preco: 0, total: 0, custo: 0 
      }] 
    }); 
  };

  // Função legada mantida para compatibilidade (não será usada na nova interface)
  const addAcess = () => { if (pedidoSalvo) return; setPedido({ ...pedido, acessorios: [...pedido.acessorios, { produto: '', cod: '', tip: '', familia: '', ordem: 'Tabela 1', qtde: 0, preco: 0, total: 0, custo: 0 }] }); };

  // ========================================
  // FUNÇÕES PARA PRODUTOS ESPECIAIS
  // ========================================
  const addItemEspecial = () => {
    if (pedidoSalvo) return;
    setItensEspeciais([
      ...itensEspeciais,
      {
        id: `esp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        produto: '',
        codigo: '',
        familia: '',
        qtde: 1,
        preco: 0,
        total: 0
      }
    ]);
  };

  const updItemEspecial = (idx, campo, val) => {
    if (pedidoSalvo) return;
    const arr = [...itensEspeciais];
    arr[idx][campo] = val;

    if (campo === 'produto') {
      const p = produtosEspeciais.find(x => x.produto === val);
      if (p) {
        arr[idx].codigo = p.codigo;
        arr[idx].familia = p.familia_produto;
      } else {
        arr[idx].codigo = '';
        arr[idx].familia = '';
      }
    }

    // Calcular total
    if (campo === 'qtde' || campo === 'preco') {
      const qtde = parseFloat(arr[idx].qtde) || 0;
      const preco = parseFloat(arr[idx].preco) || 0;
      arr[idx].total = qtde * preco;
    }

    setItensEspeciais(arr);
  };

  const remItemEspecial = (idx) => {
    if (pedidoSalvo) return;
    setItensEspeciais(itensEspeciais.filter((_, i) => i !== idx));
  };

  // Calcular total dos produtos especiais
  const totalProdutosEspeciais = itensEspeciais.reduce((acc, item) => acc + (parseFloat(item.total) || 0), 0);

  const updForro = (i, campo, val) => {
    if (pedidoSalvo) return;
    // Não permitir valores negativos em qtde
    if (campo === 'qtde' && parseFloat(val) < 0) val = 0;
    const arr = [...pedido.forro]; arr[i][campo] = val;
    
    if (campo === 'produto') {
      if (val) {
        // Produto selecionado - preencher dados
        const p = produtosForro.find(x => x.produto === val);
        if (p) { 
          arr[i].codigo = p.codigo; 
          arr[i].tip = p.tipo; 
          arr[i].familia = p.familia_produto; 
          arr[i].custo = getCusto(p.familia_produto, cliente.estado, arr[i].ordem);
          
          // Verificar se já existe outro produto da mesma família no pedido
          const familiaAtual = p.familia_produto;
          const produtoMesmaFamilia = arr.find((f, idx) => idx !== i && f.familia === familiaAtual && f.preco > 0);
          
          if (produtoMesmaFamilia) {
            // Usar o mesmo preço do produto existente da mesma família
            arr[i].preco = produtoMesmaFamilia.preco;
          } else {
            // Preencher com valor sugerido ao selecionar produto
            arr[i].preco = getValorSugerido(p.familia_produto, cliente.estado, arr[i].ordem);
          }
          arr[i].valorMinimo = getValorMinimo(p.familia_produto, cliente.estado, arr[i].ordem);
        }
      } else {
        // Produto limpo (Selecione...) - resetar todos os campos
        arr[i].codigo = '';
        arr[i].tip = '';
        arr[i].familia = '';
        arr[i].custo = 0;
        arr[i].preco = 0;
        arr[i].valorMinimo = 0;
        arr[i].abaixoMinimo = false;
      }
    }
    
    if (campo === 'ordem' && arr[i].familia) {
      arr[i].custo = getCusto(arr[i].familia, cliente.estado, val);
      
      // Verificar se já existe outro produto da mesma família no pedido
      const familiaAtual = arr[i].familia;
      const produtoMesmaFamilia = arr.find((f, idx) => idx !== i && f.familia === familiaAtual && f.preco > 0);
      
      if (produtoMesmaFamilia) {
        // Manter o mesmo preço do produto existente da mesma família
        arr[i].preco = produtoMesmaFamilia.preco;
      } else {
        // Atualizar valores ao trocar tabela
        arr[i].preco = getValorSugerido(arr[i].familia, cliente.estado, val);
      }
      arr[i].valorMinimo = getValorMinimo(arr[i].familia, cliente.estado, val);
    }
    
    // Verificar se preço está abaixo do mínimo (apenas alerta visual, não força)
    if (campo === 'preco') {
      const valorMinimo = arr[i].valorMinimo || getValorMinimo(arr[i].familia, cliente.estado, arr[i].ordem);
      arr[i].abaixoMinimo = parseFloat(val) < valorMinimo && valorMinimo > 0;
      
      // SINCRONIZAÇÃO DE PREÇO POR FAMÍLIA: 
      // Ao alterar o preço de um produto, sincroniza com todos os outros produtos da mesma família
      const familiaAtual = arr[i].familia;
      if (familiaAtual) {
        const novoPreco = parseFloat(val) || 0;
        arr.forEach((f, idx) => {
          if (idx !== i && f.familia === familiaAtual) {
            f.preco = novoPreco;
            const valorMinimoOutro = f.valorMinimo || getValorMinimo(f.familia, cliente.estado, f.ordem);
            f.abaixoMinimo = novoPreco < valorMinimoOutro && valorMinimoOutro > 0;
            // Recalcular total do item sincronizado
            f.m2 = (parseFloat(f.qtde) || 0) * (parseFloat(f.comp) || 0) * 0.2;
            f.total = f.m2 * novoPreco;
          }
        });
      }
    }
    
    arr[i].m2 = (parseFloat(arr[i].qtde) || 0) * (parseFloat(arr[i].comp) || 0) * 0.2;
    arr[i].total = arr[i].m2 * (parseFloat(arr[i].preco) || 0);
    
    // Se mudou a ordem (tabela), atualizar também os acabamentos vinculados a este forro
    if (campo === 'ordem') {
      const forroId = arr[i].id;
      const novaOrdem = val;
      const acessoriosAtualizados = pedido.acessorios.map(acess => {
        if (acess.forroId === forroId) {
          // Atualizar ordem e recalcular custos/preços
          const novoAcess = { ...acess, ordem: novaOrdem };
          if (novoAcess.familia) {
            novoAcess.custo = getCusto(novoAcess.familia, cliente.estado, novaOrdem);
            novoAcess.preco = getValorSugerido(novoAcess.familia, cliente.estado, novaOrdem);
            novoAcess.valorMinimo = getValorMinimo(novoAcess.familia, cliente.estado, novaOrdem);
            novoAcess.total = (parseInt(novoAcess.qtde) || 0) * (parseFloat(novoAcess.preco) || 0);
          }
          return novoAcess;
        }
        return acess;
      });
      setPedido({ ...pedido, forro: arr, acessorios: acessoriosAtualizados });
    } else {
      setPedido({ ...pedido, forro: arr });
    }
  };

  const updAcess = (i, campo, val) => {
    if (pedidoSalvo) return;
    // Não permitir valores negativos em qtde
    if (campo === 'qtde' && parseFloat(val) < 0) val = 0;
    const arr = [...pedido.acessorios]; arr[i][campo] = val;
    
    if (campo === 'produto') {
      if (val) {
        // Produto selecionado - preencher dados
        const a = acessoriosLista.find(x => x.produto === val);
        if (a) { 
          arr[i].cod = a.codigo; 
          arr[i].tip = a.tipo; 
          arr[i].familia = a.familia_produto; 
          arr[i].custo = getCusto(a.familia_produto, cliente.estado, arr[i].ordem);
          
          // Verificar se já existe outro acabamento da mesma família no pedido
          const familiaAtual = a.familia_produto;
          const acabamentoMesmaFamilia = arr.find((ac, idx) => idx !== i && ac.familia === familiaAtual && ac.preco > 0);
          
          if (acabamentoMesmaFamilia) {
            // Usar o mesmo preço do acabamento existente da mesma família
            arr[i].preco = acabamentoMesmaFamilia.preco;
          } else {
            // Preencher com valor sugerido ao selecionar produto
            arr[i].preco = getValorSugerido(a.familia_produto, cliente.estado, arr[i].ordem);
          }
          arr[i].valorMinimo = getValorMinimo(a.familia_produto, cliente.estado, arr[i].ordem);
        }
      } else {
        // Produto limpo (Selecione...) - resetar todos os campos
        arr[i].cod = '';
        arr[i].tip = '';
        arr[i].familia = '';
        arr[i].custo = 0;
        arr[i].preco = 0;
        arr[i].valorMinimo = 0;
        arr[i].abaixoMinimo = false;
      }
    }
    
    if (campo === 'ordem' && arr[i].familia) {
      arr[i].custo = getCusto(arr[i].familia, cliente.estado, val);
      
      // Verificar se já existe outro acabamento da mesma família no pedido
      const familiaAtual = arr[i].familia;
      const acabamentoMesmaFamilia = arr.find((ac, idx) => idx !== i && ac.familia === familiaAtual && ac.preco > 0);
      
      if (acabamentoMesmaFamilia) {
        // Manter o mesmo preço do acabamento existente da mesma família
        arr[i].preco = acabamentoMesmaFamilia.preco;
      } else {
        // Atualizar valores ao trocar tabela
        arr[i].preco = getValorSugerido(arr[i].familia, cliente.estado, val);
      }
      arr[i].valorMinimo = getValorMinimo(arr[i].familia, cliente.estado, val);
    }
    
    // Verificar se preço está abaixo do mínimo (apenas alerta visual, não força)
    if (campo === 'preco') {
      const valorMinimo = arr[i].valorMinimo || getValorMinimo(arr[i].familia, cliente.estado, arr[i].ordem);
      arr[i].abaixoMinimo = parseFloat(val) < valorMinimo && valorMinimo > 0;
      
      // SINCRONIZAÇÃO DE PREÇO POR FAMÍLIA (ACABAMENTOS):
      // Ao alterar o preço de um acabamento, sincroniza com todos os outros acabamentos da mesma família
      const familiaAtual = arr[i].familia;
      if (familiaAtual) {
        const novoPreco = parseFloat(val) || 0;
        arr.forEach((a, idx) => {
          if (idx !== i && a.familia === familiaAtual) {
            a.preco = novoPreco;
            const valorMinimoOutro = a.valorMinimo || getValorMinimo(a.familia, cliente.estado, a.ordem);
            a.abaixoMinimo = novoPreco < valorMinimoOutro && valorMinimoOutro > 0;
            // Recalcular total do item sincronizado
            a.total = (parseInt(a.qtde) || 0) * novoPreco;
          }
        });
      }
    }
    
    arr[i].total = (parseInt(arr[i].qtde) || 0) * (parseFloat(arr[i].preco) || 0);
    setPedido({ ...pedido, acessorios: arr });
  };

  // Ao excluir um forro, também remove todos os acabamentos vinculados a ele
  const delForro = (i) => { 
    if (!pedidoSalvo) {
      const forroParaRemover = pedido.forro[i];
      const forroId = forroParaRemover?.id;
      setPedido({ 
        ...pedido, 
        forro: pedido.forro.filter((_, x) => x !== i),
        // Remove todos os acabamentos que estavam vinculados a este forro
        acessorios: pedido.acessorios.filter(a => a.forroId !== forroId)
      }); 
    }
  };
  const delAcess = (i) => { if (!pedidoSalvo) setPedido({ ...pedido, acessorios: pedido.acessorios.filter((_, x) => x !== i) }); };

  // ========================================
  // LÓGICA CORRIGIDA: Verificar se pode imprimir
  // Agora olha o STATUS GERAL do pedido, não de cada tabela
  // ========================================
  const podeImprimirProposta = () => {
    // Se tem APENAS produtos especiais (sem forros normais), pode imprimir direto
    const temForrosNormais = tab1.temItens || tab2.temItens;
    const temProdutosEspeciais = itensEspeciais.length > 0;
    
    if (!temForrosNormais && temProdutosEspeciais) {
      // Produtos especiais têm pontuação automática de 0.01 = VIÁVEL
      return true;
    }
    
    // Se não tem nada (nem forros, nem produtos especiais), não pode imprimir
    if (!temForrosNormais && !temProdutosEspeciais) {
      return false;
    }
    
    // Calcular pontuação geral do pedido usando SOMA com cap de 50 em cada tabela
    const totalVendaGeral = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0);
    
    // Pontuação de cada tabela com cap de 50 (para não favorecer lucros excessivos)
    const pontTab1 = tab1.temItens ? Math.min(tab1.pontuacao || 0, 50) : 0;
    const pontTab2 = tab2.temItens ? Math.min(tab2.pontuacao || 0, 50) : 0;
    
    // Pontuação geral = SOMA das pontuações (cada uma limitada a 50)
    const pontuacaoGeral = pontTab1 + pontTab2;
    
    // Obter status geral baseado na pontuação
    const statusGeral = totalVendaGeral === 0 ? 'INVIÁVEL' : getStatusByScore(pontuacaoGeral);
    
    // EXCELENTE, BOA VENDA e VIÁVEL podem imprimir diretamente (auto-aprovados)
    if (['EXCELENTE', 'BOA VENDA', 'VIÁVEL'].includes(statusGeral)) return true;
    
    // EM ANÁLISE e INVIÁVEL só podem imprimir se AMBAS as tabelas estiverem aprovadas localmente
    if (['EM ANÁLISE', 'INVIÁVEL'].includes(statusGeral)) {
      // Se só tem uma tabela, verifica apenas ela
      if (tab1.temItens && !tab2.temItens) return aprovacaoTab1;
      if (!tab1.temItens && tab2.temItens) return aprovacaoTab2;
      // Se tem ambas, precisa de aprovação de ambas
      return aprovacaoTab1 && aprovacaoTab2;
    }
    
    return false;
  };

  // ========================================
  // Obter Status Geral do Pedido
  // ========================================
  const getStatusGeralPedido = () => {
    const temForrosNormais = tab1.temItens || tab2.temItens;
    const temProdutosEspeciais = itensEspeciais.length > 0;
    
    // Se tem APENAS produtos especiais (sem forros normais), retorna VIÁVEL (pontuação 0.01)
    if (!temForrosNormais && temProdutosEspeciais) {
      return 'VIÁVEL';
    }
    
    const totalVendaGeral = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0);
    
    // Pontuação de cada tabela com cap de 50
    const pontTab1 = tab1.temItens ? Math.min(tab1.pontuacao || 0, 50) : 0;
    const pontTab2 = tab2.temItens ? Math.min(tab2.pontuacao || 0, 50) : 0;
    
    // Pontuação geral = SOMA das pontuações (cada uma limitada a 50)
    const pontuacaoGeral = pontTab1 + pontTab2;
    
    return totalVendaGeral === 0 ? 'INVIÁVEL' : getStatusByScore(pontuacaoGeral);
  };

  // ========================================
  // LÓGICA CORRIGIDA: Status de aptidão para exibição
  // Agora baseado no STATUS GERAL do pedido, não individual de cada tabela
  // ========================================
  const getStatusAptidao = (statusTabela, tabelaNum, temItens, statusGeralPedido) => {
    // Se não tem itens, não mostra nada
    if (!temItens) return { texto: '-', cor: 'text-gray-400', bg: 'bg-gray-50', icon: XCircle, mostrarSecao: false };
    
    // Se o STATUS GERAL DO PEDIDO é EXCELENTE, BOA VENDA ou VIÁVEL → auto-aprovado, não mostra seção
    if (['EXCELENTE', 'BOA VENDA', 'VIÁVEL'].includes(statusGeralPedido)) {
      return { texto: 'Sim', cor: 'text-green-600', bg: 'bg-green-50', icon: CheckCircle, mostrarSecao: false };
    }
    
    // Se o STATUS GERAL DO PEDIDO é EM ANÁLISE ou INVIÁVEL → depende de aprovação
    if (['EM ANÁLISE', 'INVIÁVEL'].includes(statusGeralPedido)) {
      const aprov = tabelaNum === 1 ? aprovacaoTab1 : aprovacaoTab2;
      if (aprov) return { texto: 'Aprovado', cor: 'text-teal-600', bg: 'bg-teal-50', icon: ShieldCheck, mostrarSecao: true };
      return { texto: 'Aguardando', cor: 'text-amber-600', bg: 'bg-amber-50', icon: Clock, mostrarSecao: true };
    }
    
    return { texto: 'Não', cor: 'text-red-600', bg: 'bg-red-50', icon: XCircle, mostrarSecao: false };
  };

  // Função para calcular tempo total entre hora início e hora fim
  const calcularTempoTotal = () => {
    if (!pedido.hora || !horaFimPedido) return null;
    
    // Converter hora início (HH:MM:SS) para minutos
    const [horaIni, minIni] = pedido.hora.split(':').map(Number);
    const [horaFim, minFim] = horaFimPedido.split(':').map(Number);
    
    const minutosInicio = horaIni * 60 + minIni;
    const minutosFim = horaFim * 60 + minFim;
    
    let diferencaMinutos = minutosFim - minutosInicio;
    
    // Se a diferença for negativa, significa que passou da meia-noite
    if (diferencaMinutos < 0) {
      diferencaMinutos += 24 * 60;
    }
    
    const horas = Math.floor(diferencaMinutos / 60);
    const minutos = diferencaMinutos % 60;
    
    if (horas === 0) {
      return `${minutos} minuto${minutos !== 1 ? 's' : ''}`;
    } else if (minutos === 0) {
      return `${horas} hora${horas !== 1 ? 's' : ''}`;
    } else {
      return `${horas} hora${horas !== 1 ? 's' : ''} e ${minutos} minuto${minutos !== 1 ? 's' : ''}`;
    }
  };

  // Cálculos
  const tab1 = calcResumo('Tabela 1');
  const tab2 = calcResumo('Tabela 2');
  // Se o valor gerado é 0, status = INVIÁVEL (não pode vender com valor zero)
  // Status baseado na PONTUAÇÃO (Margem Atingida - Margem Exigida)
  const status1 = tab1.temItens ? (tab1.valorGerado === 0 ? 'INVIÁVEL' : getStatusByScore(tab1.pontuacao)) : null;
  const status2 = tab2.temItens ? (tab2.valorGerado === 0 ? 'INVIÁVEL' : getStatusByScore(tab2.pontuacao)) : null;
  const config1 = status1 ? getStatusConfig(status1) : null;
  const config2 = status2 ? getStatusConfig(status2) : null;
  
  // Calcular status geral do pedido para passar ao getStatusAptidao
  const statusGeralPedido = getStatusGeralPedido();
  
  const aptidaoTab1 = getStatusAptidao(status1, 1, tab1.temItens, statusGeralPedido);
  const aptidaoTab2 = getStatusAptidao(status2, 2, tab2.temItens, statusGeralPedido);
  
  // Verifica se o pedido geral é inviável (baseado na pontuação GERAL, não individual)
  const temTabelaInviavel = () => {
    // Se estiver no modo de venda especial, nunca é inviável (produtos especiais são sempre viáveis)
    if (modoVendaEspecial) return false;
    // Verifica o status GERAL do pedido, não o status individual de cada tabela
    return statusGeralPedido === 'INVIÁVEL';
  };
  
  // ========================================
  // Verifica se tem itens no pedido (produtos normais OU especiais)
  const temItensNoPedido = () => {
    // Produtos normais
    if (pedido.forro.length > 0 || pedido.acessorios.length > 0) return true;
    // Produtos especiais (com valor > 0)
    if (itensEspeciais.some(item => item.produto && item.total > 0)) return true;
    return false;
  };

  // Componente Badge usando StatusBadge global
  const StatusBadgeLocal = ({ status }) => {
    if (!status) return <div className="text-gray-400 text-center py-2">Sem itens</div>;
    return <StatusBadge status={status} tamanho="lg" />;
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <div className="px-8 py-6 w-full">

        {/* DIVISÓRIA - DADOS DA PROPOSTA */}
        {cliente && (
          <div className="w-full max-w-6xl mx-auto mb-6">
            <div className="w-full h-px bg-gray-200 mb-6"></div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3 group cursor-default">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                  <FileText size={20} className="text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Dados da Proposta</h2>
                  <p className="text-xs text-gray-400">Informações da proposta atual</p>
                </div>
              </div>
              <button 
                onClick={() => toggleExpandir('proposta')} 
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
              >
                <ChevronDown size={20} className={`transition-transform duration-300 ${expandido.proposta ? 'rotate-180' : ''}`} />
                {expandido.proposta ? 'Recolher' : 'Expandir'}
              </button>
            </div>
          </div>
        )}

        {/* CARD DADOS DA PROPOSTA */}
        {cliente && expandido.proposta && (
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 border border-gray-100 w-full max-w-6xl mx-auto hover:shadow-xl hover:scale-[1.01] hover:-translate-y-1 transition-all duration-300">
            <div className="grid grid-cols-4 gap-4">
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300">
                <label className="block text-xs font-semibold mb-1.5 text-gray-500 uppercase tracking-wide flex items-center gap-1"><Calendar size={12} />Data</label>
                <input type="text" value={pedido.data} className="w-full text-sm font-bold text-gray-700 bg-transparent border-none focus:outline-none" disabled />
              </div>
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300">
                <label className="block text-xs font-semibold mb-1.5 text-gray-500 uppercase tracking-wide flex items-center gap-1"><Clock size={12} />Hora</label>
                <input type="text" value={pedido.hora} className="w-full text-sm font-bold text-gray-700 bg-transparent border-none focus:outline-none" disabled />
              </div>
              <div className="bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl p-4 shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300">
                <label className="block text-xs font-semibold mb-1.5 text-white/90 uppercase tracking-wide">Proposta Nº</label>
                <input type="text" value={pedido.proposta} className="w-full text-sm font-bold text-white bg-transparent border-none focus:outline-none" disabled />
              </div>
              <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300">
                <label className="block text-xs font-semibold mb-1.5 text-gray-500 uppercase tracking-wide flex items-center gap-1"><User size={12} />Responsável</label>
                {podeSelecionarResponsavel() ? (
                  <select
                    value={responsavelSelecionado || pedido.vendedor}
                    onChange={(e) => {
                      setResponsavelSelecionado(e.target.value);
                      setPedido(prev => ({ ...prev, vendedor: e.target.value }));
                    }}
                    className="w-full text-sm font-bold text-gray-700 bg-transparent border-none focus:outline-none cursor-pointer"
                  >
                    <option value={pedido.vendedor}>{pedido.vendedor}</option>
                    {listaUsuarios
                      .filter(u => u.nome_completo !== pedido.vendedor && u.nome !== pedido.vendedor)
                      .map(u => (
                        <option key={u.id} value={u.nome_completo || u.nome}>
                          {u.nome_completo || u.nome} ({u.departamento})
                        </option>
                      ))
                    }
                  </select>
                ) : (
                  <input type="text" value={pedido.vendedor} className="w-full text-sm font-bold text-gray-700 bg-transparent border-none focus:outline-none" disabled />
                )}
              </div>
            </div>
          </div>
        )}

        {/* DIVISÓRIA - DADOS DO CLIENTE */}
        <div className="w-full max-w-6xl mx-auto mb-6">
          <div className="w-full h-px bg-gray-200 mb-6"></div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 group cursor-default">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                <User size={20} className="text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Dados do Cliente</h2>
                <p className="text-xs text-gray-400">Informações do cliente</p>
              </div>
            </div>
            {cliente && (
              <button 
                onClick={() => toggleExpandir('cliente')} 
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
              >
                <ChevronDown size={20} className={`transition-transform duration-300 ${expandido.cliente ? 'rotate-180' : ''}`} />
                {expandido.cliente ? 'Recolher' : 'Expandir'}
              </button>
            )}
          </div>
        </div>

        {/* CARD DADOS DO CLIENTE */}
        {expandido.cliente && (
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-6 w-full max-w-6xl mx-auto border border-gray-100 hover:shadow-2xl hover:scale-[1.01] hover:-translate-y-1 transition-all duration-300">

          {!showCadastro && !cliente && (
            <div className="space-y-5">
              {/* Campo unificado de busca por CPF/CNPJ ou Nome */}
              <div className="flex items-center gap-3">
                <div className="flex-1 relative" ref={buscaNomeRef}>
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <Building2 size={20} className="text-gray-400" />
                  </div>
                  <input 
                    type="text" 
                    value={cnpj} 
                    onChange={(e) => handleCampoBusca(e.target.value)} 
                    onFocus={() => { if (sugestoesClientes.length > 0) setMostrarSugestoes(true); }}
                    onKeyDown={(e) => { if (e.key === 'Enter' && !mostrarSugestoes && pareceDocumento(cnpj)) buscar(); }}
                    placeholder="Digite o CNPJ, CPF ou nome do cliente..." 
                    className="w-full pl-12 pr-10 py-4 text-base border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-500 hover:border-blue-300 transition-all duration-300 bg-white" 
                  />
                  {buscandoNome && (
                    <div className="absolute inset-y-0 right-0 pr-4 flex items-center">
                      <div className="animate-spin h-5 w-5 border-2 border-blue-500 border-t-transparent rounded-full"></div>
                    </div>
                  )}
                  {/* Dropdown de sugestões ao digitar nome */}
                  {mostrarSugestoes && sugestoesClientes.length > 0 && (
                    <div ref={sugestoesRef} className="absolute z-50 w-full mt-1 bg-white border-2 border-blue-200 rounded-xl shadow-2xl max-h-64 overflow-y-auto">
                      {sugestoesClientes.map((cli) => (
                        <button
                          key={cli.id}
                          type="button"
                          onClick={() => selecionarClienteSugestao(cli)}
                          className="w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100 last:border-b-0 flex items-center justify-between gap-3"
                        >
                          <div className="flex-1 min-w-0">
                            <p className="font-semibold text-gray-800 truncate">{cli.nome}</p>
                            <p className="text-sm text-gray-500">{cli.cnpj || 'Sem CPF/CNPJ'}{cli.cidade ? ` • ${cli.cidade}/${cli.estado}` : ''}</p>
                          </div>
                          <span className="text-xs text-blue-500 font-medium flex-shrink-0">Selecionar</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <button 
                  onClick={() => buscar()} 
                  disabled={!cnpj.trim() || !pareceDocumento(cnpj)}
                  className={`px-8 py-4 rounded-xl flex items-center gap-2 font-semibold transition-all duration-300 shadow-md group ${
                    !cnpj.trim() || !pareceDocumento(cnpj)
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 hover:scale-105 hover:shadow-lg'
                  }`}
                >
                  <Search size={20} className="group-hover:rotate-12 transition-transform duration-300" />
                  Buscar
                </button>
              </div>

              {/* Botão de cadastrar - mais compacto */}
              <button 
                onClick={() => setShowCadastro(true)} 
                className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold transition-all duration-300 group"
              >
                <div className="bg-emerald-100 p-1.5 rounded-lg group-hover:bg-emerald-200 group-hover:scale-110 transition-all duration-300">
                  <Plus size={18} className="group-hover:rotate-90 transition-transform duration-300" />
                </div>
                <span className="group-hover:underline">Cadastrar novo cliente</span>
              </button>
            </div>
          )}

          {showCadastro && (
            <div className="bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50 rounded-2xl p-8 border-2 border-blue-200 shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="flex justify-between items-center mb-8">
                <div className="flex items-center gap-3">
                  <div className="bg-gradient-to-br from-blue-500 to-cyan-500 p-3 rounded-xl shadow-lg hover:scale-110 transition-transform duration-300">
                    <Plus size={24} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">Novo Cliente</h3>
                </div>
                <div className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-5 py-2 rounded-xl font-bold text-sm shadow-lg flex items-center gap-2">
                  <CheckCircle size={16} />
                  NOVO
                </div>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Nome *</label><input type="text" value={novoCliente.nome} onChange={(e) => setNovoCliente({...novoCliente, nome: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100">
                  <label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">CPF/CNPJ *</label>
                  <input 
                    type="text" 
                    value={novoCliente.cnpj} 
                    onChange={(e) => handleCnpjChange(e.target.value)}
                    placeholder="000.000.000-00 ou 00.000.000/0000-00"
                    maxLength={18}
                    className={`w-full p-3 border-2 rounded-xl focus:ring-2 focus:outline-none transition-all duration-300 ${
                      erroValidacao.cnpj 
                        ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-red-100' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-100'
                    }`}
                  />
                  {verificandoCnpj && <p className="text-xs text-blue-500 mt-1 flex items-center gap-1"><Clock size={12} className="animate-spin" /> Verificando...</p>}
                  {erroValidacao.cnpj && <p className="text-xs text-red-500 mt-1 font-semibold">{erroValidacao.cnpj}</p>}
                </div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Endereço</label><input type="text" value={novoCliente.endereco} onChange={(e) => setNovoCliente({...novoCliente, endereco: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Bairro</label><input type="text" value={novoCliente.bairro} onChange={(e) => setNovoCliente({...novoCliente, bairro: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Cidade</label><input type="text" value={novoCliente.cidade} onChange={(e) => setNovoCliente({...novoCliente, cidade: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Estado</label><select value={novoCliente.estado} onChange={(e) => setNovoCliente({...novoCliente, estado: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer transition-all duration-300"><option value="Parana">Paraná</option><option value="Santa Catarina">Santa Catarina</option></select></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100">
                  <label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Telefone *</label>
                  <input 
                    type="text" 
                    value={novoCliente.telefone} 
                    onChange={(e) => handleTelefoneChange(e.target.value)}
                    placeholder="(99) 99999-9999"
                    maxLength={15}
                    className={`w-full p-3 border-2 rounded-xl focus:ring-2 focus:outline-none transition-all duration-300 ${
                      erroValidacao.telefone 
                        ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-red-100' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-100'
                    }`}
                  />
                  {erroValidacao.telefone && <p className="text-xs text-red-500 mt-1 font-semibold">{erroValidacao.telefone}</p>}
                </div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Email</label><input type="email" value={novoCliente.email} onChange={(e) => setNovoCliente({...novoCliente, email: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Rede</label><select value={novoCliente.rede || ''} onChange={(e) => setNovoCliente({...novoCliente, rede: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300 cursor-pointer"><option value="">Selecione uma rede...</option><option value="Rede Bem Viver">Rede Bem Viver</option><option value="Rede Construnião">Rede Construnião</option><option value="Rede Constru&Cia (Maringá)">Rede Constru&Cia (Maringá)</option><option value="Rede Constru&Cia (Cascavel)">Rede Constru&Cia (Cascavel)</option><option value="Rede Grandeoeste">Rede Grandeoeste</option></select></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100"><label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Constituição / Nascimento</label><input type="date" value={novoCliente.data_constituicao_nascimento || ''} onChange={(e) => setNovoCliente({...novoCliente, data_constituicao_nascimento: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300" /></div>
              </div>
              <div className="flex gap-4 mt-8">
                <button onClick={salvar} className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-10 py-4 rounded-xl flex items-center gap-3 font-bold shadow-lg hover:from-blue-600 hover:to-cyan-600 hover:scale-105 hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group"><Save size={22} className="group-hover:rotate-12 transition-transform duration-300" />Salvar Cliente</button>
                <button onClick={() => setShowCadastro(false)} className="bg-gradient-to-r from-gray-400 to-gray-500 text-white px-10 py-4 rounded-xl flex items-center gap-3 font-bold shadow-lg hover:from-gray-500 hover:to-gray-600 hover:scale-105 hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group"><X size={22} className="group-hover:rotate-90 transition-transform duration-300" />Cancelar</button>
              </div>
            </div>
          )}

          {cliente && !editandoCliente && (
            <div className="bg-gradient-to-br from-blue-50 via-cyan-50 to-white rounded-2xl p-6 border-2 border-blue-200 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex justify-between items-start">
                <div className="grid grid-cols-3 gap-x-8 gap-y-4 flex-1">
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><User size={12} />Cliente</p><p className="font-bold text-gray-800 text-lg group-hover:text-blue-600 transition-colors duration-300">{cliente.nome}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><Building2 size={12} />CNPJ</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.cnpj}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><MapPin size={12} />Endereço</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.endereco || '-'}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1">Bairro</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.bairro || '-'}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1">Cidade</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.cidade}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1">Estado</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.estado}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><Phone size={12} />Telefone</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.telefone || '-'}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><Mail size={12} />Email</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.email || '-'}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><Building2 size={12} />Rede</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.rede || '-'}</p></div>
                  <div className="group"><p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1"><Calendar size={12} />Constituição / Nasc.</p><p className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">{cliente.data_constituicao_nascimento ? new Date(cliente.data_constituicao_nascimento).toLocaleDateString('pt-BR') : '-'}</p></div>
                </div>
                {!pedidoSalvo && (
                  <div className="flex flex-col gap-3 ml-6">
                    <button onClick={() => { setCliente(null); setCnpj(''); }} className="bg-gradient-to-r from-red-500 to-rose-600 text-white px-6 py-3 rounded-xl hover:from-red-600 hover:to-rose-700 hover:scale-105 hover:-translate-y-1 hover:shadow-lg flex items-center gap-2 font-bold transition-all duration-300 shadow-md group"><X size={18} className="group-hover:rotate-90 transition-transform duration-300" />Trocar</button>
                    <button onClick={iniciarEdicaoCliente} className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-xl hover:from-blue-600 hover:to-blue-700 hover:scale-105 hover:-translate-y-1 hover:shadow-lg flex items-center gap-2 font-bold transition-all duration-300 shadow-md group"><Edit2 size={18} className="group-hover:rotate-12 transition-transform duration-300" />Editar</button>
                  </div>
                )}
                {pedidoSalvo && (
                  <div className="ml-6 bg-gradient-to-r from-green-50 to-emerald-50 px-5 py-4 rounded-xl border-2 border-green-200 shadow-md">
                    <div className="flex items-center gap-2 text-green-600"><CheckCircle size={20} /><span className="font-bold">Salvo</span></div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Box de Observação do Cliente */}
          {cliente && !editandoCliente && (
            <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm" style={{ color: '#1F3D7A' }}>
                <strong>Observação:</strong>{' '}
                {observacaoCliente ? (
                  <span>{observacaoCliente}</span>
                ) : (
                  <span className="text-slate-400 italic font-normal">Sem observações cadastradas</span>
                )}
              </p>
            </div>
          )}

          {cliente && editandoCliente && clienteEditado && (
            <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-white rounded-2xl p-8 border-2 border-amber-300 shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center gap-3 mb-8">
                <div className="bg-gradient-to-br from-amber-500 to-orange-600 p-3 rounded-xl shadow-lg">
                  <Edit2 size={24} className="text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Editar Cliente</h3>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Nome *{!podeEditarNomeCliente && <span className="ml-2 normal-case font-normal text-gray-400">(somente perfil de aprovação de cadastro)</span>}</label><input type="text" value={clienteEditado.nome} onChange={(e) => setClienteEditado({...clienteEditado, nome: e.target.value})} disabled={!podeEditarNomeCliente} title={!podeEditarNomeCliente ? 'Apenas usuários com perfil de aprovação de cadastro podem alterar o nome' : undefined} className={`w-full p-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-all duration-300 ${podeEditarNomeCliente ? 'focus:border-amber-500 focus:ring-2 focus:ring-amber-100' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`} /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">CNPJ *</label><input type="text" value={clienteEditado.cnpj} onChange={(e) => setClienteEditado({...clienteEditado, cnpj: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Endereço</label><input type="text" value={clienteEditado.endereco || ''} onChange={(e) => setClienteEditado({...clienteEditado, endereco: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Bairro</label><input type="text" value={clienteEditado.bairro || ''} onChange={(e) => setClienteEditado({...clienteEditado, bairro: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Cidade</label><input type="text" value={clienteEditado.cidade || ''} onChange={(e) => setClienteEditado({...clienteEditado, cidade: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Estado</label><select value={clienteEditado.estado || 'Parana'} onChange={(e) => setClienteEditado({...clienteEditado, estado: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl bg-white focus:border-amber-500 focus:ring-2 focus:ring-amber-100 cursor-pointer transition-all duration-300"><option value="Parana">Paraná</option><option value="Santa Catarina">Santa Catarina</option></select></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Telefone</label><input type="text" value={clienteEditado.telefone || ''} onChange={(e) => setClienteEditado({...clienteEditado, telefone: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Email</label><input type="email" value={clienteEditado.email || ''} onChange={(e) => setClienteEditado({...clienteEditado, email: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100 col-span-2"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Rede</label><select value={clienteEditado.rede || ''} onChange={(e) => setClienteEditado({...clienteEditado, rede: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl bg-white focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300 cursor-pointer"><option value="">Selecione uma rede...</option><option value="Rede Bem Viver">Rede Bem Viver</option><option value="Rede Construnião">Rede Construnião</option><option value="Rede Constru&Cia (Maringá)">Rede Constru&Cia (Maringá)</option><option value="Rede Constru&Cia (Cascavel)">Rede Constru&Cia (Cascavel)</option><option value="Rede Grandeoeste">Rede Grandeoeste</option></select></div>
                <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-gray-100 col-span-2"><label className="block text-xs font-bold mb-2 text-gray-500 uppercase tracking-wide">Constituição / Nascimento</label><input type="date" value={clienteEditado.data_constituicao_nascimento ? clienteEditado.data_constituicao_nascimento.substring(0, 10) : ''} onChange={(e) => setClienteEditado({...clienteEditado, data_constituicao_nascimento: e.target.value})} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-2 focus:ring-amber-100 focus:outline-none transition-all duration-300" /></div>
              </div>
              <div className="flex gap-4 mt-8">
                <button onClick={salvarEdicaoCliente} className="bg-gradient-to-r from-amber-500 to-orange-600 text-white px-10 py-4 rounded-xl flex items-center gap-3 font-bold shadow-lg hover:from-amber-600 hover:to-orange-700 hover:scale-105 hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group"><Save size={22} className="group-hover:rotate-12 transition-transform duration-300" />Salvar Alterações</button>
                <button onClick={cancelarEdicaoCliente} className="bg-gradient-to-r from-gray-400 to-gray-500 text-white px-10 py-4 rounded-xl flex items-center gap-3 font-bold shadow-lg hover:from-gray-500 hover:to-gray-600 hover:scale-105 hover:-translate-y-1 hover:shadow-xl transition-all duration-300 group"><X size={22} className="group-hover:rotate-90 transition-transform duration-300" />Cancelar</button>
              </div>
            </div>
          )}
          </div>
        )}

        {/* DIVISÓRIA - DADOS DA ENTREGA */}
        {cliente && (
          <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
            <div className="w-full h-px bg-gray-200 mb-6"></div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3 group cursor-default">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                  <MapPin size={20} className="text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Dados da Entrega</h2>
                  <p className="text-xs text-gray-400">Endereço de entrega do pedido</p>
                </div>
              </div>
              <button 
                onClick={() => toggleExpandir('entrega')} 
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
              >
                <ChevronDown size={20} className={`transition-transform duration-300 ${expandido.entrega ? 'rotate-180' : ''}`} />
                {expandido.entrega ? 'Recolher' : 'Expandir'}
              </button>
            </div>
          </div>
        )}

        {/* CARD DADOS DA ENTREGA */}
        {cliente && expandido.entrega && (
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-6 w-full max-w-6xl mx-auto border border-gray-100 hover:shadow-2xl hover:scale-[1.01] hover:-translate-y-1 transition-all duration-300">
            
            {/* Pergunta: Endereço de entrega é o mesmo? */}
            <div className="mb-6">
              <label className="block text-sm font-bold mb-3 text-blue-600 uppercase tracking-wide">
                O endereço de entrega é o mesmo que o endereço do cliente? *
              </label>
              <select
                value={mesmoEnderecoCliente === null ? '' : mesmoEnderecoCliente === true ? 'sim' : 'nao'}
                onChange={(e) => {
                  if (e.target.value === 'sim') setMesmoEnderecoCliente(true);
                  else if (e.target.value === 'nao') setMesmoEnderecoCliente(false);
                  else setMesmoEnderecoCliente(null);
                }}
                disabled={pedidoSalvo}
                className={`w-full p-4 text-base font-semibold border-2 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg ${
                  pedidoSalvo 
                    ? 'bg-gray-100 cursor-not-allowed border-gray-200' 
                    : 'bg-white border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer hover:border-blue-400'
                }`}
              >
                <option value="">Selecione...</option>
                <option value="sim">SIM</option>
                <option value="nao">NÃO</option>
              </select>
            </div>

            {/* Se MESMO ENDEREÇO = SIM: Mostrar dados do cliente */}
            {mesmoEnderecoCliente === true && (
              <div className="bg-gradient-to-br from-blue-50 via-cyan-50 to-white rounded-2xl p-6 border-2 border-blue-200 shadow-lg">
                <div className="flex items-center gap-2 mb-4">
                  <CheckCircle size={20} className="text-blue-600" />
                  <h3 className="text-lg font-bold text-blue-700">Dados do Cliente</h3>
                </div>
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="group">
                    <p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1 flex items-center gap-1">
                      <MapPin size={12} />
                      Endereço
                    </p>
                    <p className="font-bold text-gray-800 text-base group-hover:text-blue-600 transition-colors duration-300">
                      {cliente.endereco || '-'}
                    </p>
                  </div>
                  <div className="group">
                    <p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1">Bairro</p>
                    <p className="font-bold text-gray-800 text-base group-hover:text-blue-600 transition-colors duration-300">
                      {cliente.bairro || '-'}
                    </p>
                  </div>
                  <div className="group">
                    <p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1">Cidade</p>
                    <p className="font-bold text-gray-800 text-base group-hover:text-blue-600 transition-colors duration-300">
                      {cliente.cidade}
                    </p>
                  </div>
                  <div className="group">
                    <p className="text-xs text-blue-500 font-bold uppercase tracking-wide mb-1">Estado</p>
                    <p className="font-bold text-gray-800 text-base group-hover:text-blue-600 transition-colors duration-300">
                      {cliente.estado}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Se MESMO ENDEREÇO = NÃO: Mostrar campos para preenchimento */}
            {mesmoEnderecoCliente === false && (
              <div className="bg-gradient-to-br from-blue-50 via-cyan-50 to-white rounded-2xl p-6 border-2 border-blue-200 shadow-lg">
                <div className="flex items-center gap-2 mb-4">
                  <Edit2 size={20} className="text-blue-600" />
                  <h3 className="text-lg font-bold text-blue-700">Preencha o Endereço de Entrega</h3>
                </div>
                <div className="grid grid-cols-2 gap-5">
                  <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100">
                    <label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide flex items-center gap-1">
                      <MapPin size={12} />
                      Endereço *
                    </label>
                    <input
                      type="text"
                      value={enderecoEntrega}
                      onChange={(e) => setEnderecoEntrega(e.target.value)}
                      disabled={pedidoSalvo}
                      placeholder="Digite o endereço de entrega"
                      className={`w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300 ${
                        pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''
                      }`}
                    />
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100">
                    <label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Bairro *</label>
                    <input
                      type="text"
                      value={bairroEntrega}
                      onChange={(e) => setBairroEntrega(e.target.value)}
                      disabled={pedidoSalvo}
                      placeholder="Digite o bairro"
                      className={`w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300 ${
                        pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''
                      }`}
                    />
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100">
                    <label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Cidade *</label>
                    <input
                      type="text"
                      value={cidadeEntrega}
                      onChange={(e) => setCidadeEntrega(e.target.value)}
                      disabled={pedidoSalvo}
                      placeholder="Digite a cidade"
                      className={`w-full p-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-300 ${
                        pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''
                      }`}
                    />
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 border border-blue-100">
                    <label className="block text-xs font-bold mb-2 text-blue-600 uppercase tracking-wide">Estado *</label>
                    <select
                      value={estadoEntrega}
                      onChange={(e) => setEstadoEntrega(e.target.value)}
                      disabled={pedidoSalvo}
                      className={`w-full p-3 border-2 border-gray-200 rounded-xl bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer transition-all duration-300 ${
                        pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''
                      }`}
                    >
                      <option value="Parana">Paraná</option>
                      <option value="Santa Catarina">Santa Catarina</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
            
            {/* TAXA DE ENTREGA - Aparece quando endereço está definido e usuário tem permissão */}
            {mesmoEnderecoCliente !== null && ['Admin', 'Diretoria', 'Administrativo', 'Vendas'].includes(usuarioLogado?.departamento) && (
              <div className="mt-6 pt-6 border-t-2 border-blue-100">
                <div className="grid grid-cols-2 gap-6">
                  {/* Pergunta: Tem taxa de entrega? */}
                  <div>
                    <label className="block text-sm font-bold mb-3 text-blue-600 uppercase tracking-wide">
                      Taxa de Entrega? *
                    </label>
                    <select
                      value={temTaxaEntrega === null ? '' : temTaxaEntrega === true ? 'sim' : 'nao'}
                      onChange={(e) => {
                        if (e.target.value === 'sim') {
                          setTemTaxaEntrega(true);
                        } else if (e.target.value === 'nao') {
                          setTemTaxaEntrega(false);
                          setValorTaxaEntrega('');
                        } else {
                          setTemTaxaEntrega(null);
                          setValorTaxaEntrega('');
                        }
                      }}
                      disabled={pedidoSalvo}
                      className={`w-full p-4 text-base font-semibold border-2 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg ${
                        pedidoSalvo 
                          ? 'bg-gray-100 cursor-not-allowed border-gray-200' 
                          : 'bg-white border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer hover:border-blue-400'
                      }`}
                    >
                      <option value="">Selecione...</option>
                      <option value="sim">SIM</option>
                      <option value="nao">NÃO</option>
                    </select>
                  </div>
                  
                  {/* Valor da Taxa de Entrega - Aparece apenas se SIM */}
                  {temTaxaEntrega === true && (
                    <div>
                      <label className="block text-sm font-bold mb-3 text-blue-600 uppercase tracking-wide">
                        Valor da Taxa de Entrega (R$) *
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={valorTaxaEntrega}
                        onChange={(e) => setValorTaxaEntrega(e.target.value)}
                        disabled={pedidoSalvo}
                        placeholder="0,00"
                        className={`w-full p-4 text-base font-semibold border-2 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg ${
                          pedidoSalvo 
                            ? 'bg-gray-100 cursor-not-allowed border-gray-200' 
                            : 'bg-white border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 hover:border-blue-400'
                        }`}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {cliente && (
          <>
            {/* DIVISÓRIA - PEDIDO */}
            <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
              <div className="w-full h-px bg-gray-200 mb-6"></div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 group cursor-default">
                  <div className={`w-10 h-10 ${modoVendaEspecial ? 'bg-gradient-to-br from-purple-500 to-pink-500' : 'bg-gradient-to-br from-blue-500 to-cyan-500'} rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300`}>
                    {modoVendaEspecial ? <Package size={20} className="text-white" /> : <ShoppingCart size={20} className="text-white" />}
                  </div>
                  <div>
                    <h2 className={`text-xl font-bold ${modoVendaEspecial ? 'bg-gradient-to-r from-purple-600 to-pink-500' : 'bg-gradient-to-r from-blue-600 to-cyan-500'} bg-clip-text text-transparent`}>
                      {modoVendaEspecial ? 'Produtos Especiais' : 'Pedido'}
                    </h2>
                    <p className="text-xs text-gray-400">
                      {modoVendaEspecial ? 'Demais produtos (sem cálculo de margem/pontuação)' : 'Adicione os itens do pedido'}
                    </p>
                  </div>
                </div>
                <button 
                  onClick={() => toggleExpandir('pedido')} 
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                >
                  <ChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${expandido.pedido ? 'rotate-180' : ''}`} />
                  {expandido.pedido ? 'Recolher' : 'Expandir'}
                </button>
              </div>
            </div>

            {expandido.pedido && (
            <>
            {/* MODO VENDA NORMAL - FORRO E ACABAMENTOS */}
            {!modoVendaEspecial && (
            <div className="bg-white rounded-xl shadow-md p-6 mb-6 w-full max-w-6xl mx-auto hover:shadow-lg transition-all duration-300">
              <div className="flex justify-between items-center mb-4">
                {/* Título removido - sem texto "FORRO" */}
                <div></div>
                <div className="flex items-center gap-3">
                  {/* Botão Vender Produtos Especiais */}
                  {podeVenderProdutosEspeciais() && !pedidoSalvo && (
                    <button 
                      onClick={ativarModoVendaEspecial} 
                      className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-2 rounded-lg hover:opacity-90 hover:scale-105 hover:shadow-md flex items-center gap-2 transition-all duration-300 group"
                    >
                      <Package size={18} className="group-hover:rotate-12 transition-transform duration-300" />
                      Vender Produtos Especiais
                    </button>
                  )}
                  {!pedidoSalvo ? (
                    <button onClick={addForro} className="text-white px-4 py-2 rounded-lg hover:opacity-90 hover:scale-105 hover:shadow-md flex items-center gap-2 transition-all duration-300 group" style={{backgroundColor: '#1F3D7A'}}><Plus size={18} className="group-hover:rotate-90 transition-transform duration-300" />Adicionar</button>
                  ) : (
                    <span className="bg-gray-100 text-gray-500 px-4 py-2 rounded-lg flex items-center gap-2 font-semibold text-sm"><CheckCircle size={16} />Bloqueado</span>
                  )}
                </div>
              </div>
              <table className="w-full text-xs table-fixed">
                <thead>
                  <tr className="text-white" style={{background: 'linear-gradient(to right, #1F3D7A, #2E5090)'}}>
                    <th className="p-2 text-center rounded-l-lg w-[90px]">ORDEM</th>
                    <th className="p-2 text-center w-[45px]">CÓD</th>
                    <th className="p-2 text-center">PRODUTO</th>
                    <th className="p-2 text-center w-[50px]">TIP</th>
                    <th className="p-2 text-center w-[60px]">QTDE</th>
                    <th className="p-2 text-center w-[95px]">COMP</th>
                    <th className="p-2 text-center w-[70px]">M²</th>
                    <th className="p-2 text-center w-[70px]">R$ UN</th>
                    <th className="p-2 text-center w-[100px]">R$ TOT</th>
                    <th className="p-2 rounded-r-lg w-[200px]">AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  {pedido.forro.map((f, i) => {
                    // Encontrar os acabamentos vinculados a este forro
                    const acabamentosDoForro = pedido.acessorios.filter(a => a.forroId === f.id);
                    // Verificar se o forro tem valor total > 0 para habilitar adicionar acabamento
                    const podeAdicionarAcabamento = (parseFloat(f.total) || 0) > 0;
                    
                    // ========================================
                    // PONTUAÇÃO AGRUPADA POR FAMÍLIA
                    // Soma todos os forros da mesma família + acabamentos para calcular a pontuação
                    // ========================================
                    const familia = f.familia;
                    const tipoTabela = f.ordem;
                    
                    // Encontrar TODOS os forros da mesma família e mesma tabela
                    const forrosDaFamilia = pedido.forro.filter(fo => fo.familia === familia && fo.ordem === tipoTabela);
                    
                    // Somar totais de todos os forros da família
                    const totalForroFamilia = forrosDaFamilia.reduce((acc, fo) => acc + (parseFloat(fo.total) || 0), 0);
                    const custoForroFamilia = forrosDaFamilia.reduce((acc, fo) => {
                      const m2 = parseFloat(fo.m2) || 0;
                      const custo = parseFloat(fo.custo) || 0;
                      return acc + (m2 * custo);
                    }, 0);
                    
                    // Encontrar TODOS os acabamentos vinculados a forros desta família
                    const forroIdsDaFamilia = forrosDaFamilia.map(fo => fo.id);
                    const acabamentosDaFamilia = pedido.acessorios.filter(a => forroIdsDaFamilia.includes(a.forroId));
                    
                    const totalAcabamentosFamilia = acabamentosDaFamilia.reduce((acc, a) => acc + (parseFloat(a.total) || 0), 0);
                    const custoAcabamentosFamilia = acabamentosDaFamilia.reduce((acc, a) => acc + ((parseInt(a.qtde) || 0) * (parseFloat(a.custo) || 0)), 0);
                    
                    // Totais da família inteira (forros + acabamentos)
                    const totalFamilia = totalForroFamilia + totalAcabamentosFamilia;
                    const custoFamilia = custoForroFamilia + custoAcabamentosFamilia;
                    const lucroFamilia = totalFamilia - custoFamilia;
                    
                    const margemAtingida = totalFamilia > 0 ? (lucroFamilia / totalFamilia) * 100 : 0;
                    const margemExigida = getMargemExigida(familia, cliente?.estado, tipoTabela) || 0;
                    let pontuacaoForro = margemAtingida - margemExigida;
                    // Famílias com pontuação dividida por 3
                    if (['Forro 8 mm', 'Forro Colorido'].includes(familia)) {
                      pontuacaoForro = pontuacaoForro / 3;
                    }
                    const statusForro = totalFamilia > 0 ? getStatusByScore(pontuacaoForro) : null;
                    const configForro = statusForro ? getStatusConfig(statusForro) : null;
                    
                    return (
                      <React.Fragment key={f.id || i}>
                        {/* Linha do Forro - fundo cinza mais escuro */}
                        <tr className="border-b hover:bg-gray-200 transition-colors duration-200" style={{backgroundColor: '#e8e8e8'}}>
                          <td className="p-1 text-center">
                            <select value={f.ordem} onChange={(e) => updForro(i, 'ordem', e.target.value)} disabled={pedidoSalvo} className={`w-full p-1 border rounded font-bold text-center ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : 'bg-yellow-50'}`}>
                              <option value="Tabela 1">Tabela 1</option>
                              <option value="Tabela 2">Tabela 2</option>
                            </select>
                          </td>
                          <td className="p-1 text-center"><input type="text" value={f.codigo || ''} className="w-full p-1 bg-transparent text-center font-bold" disabled /></td>
                          <td className="p-1">
                            <select value={f.produto} onChange={(e) => updForro(i, 'produto', e.target.value)} disabled={pedidoSalvo} className={`w-full p-1 border rounded ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''}`}>
                              <option value="">Selecione...</option>
                              {produtosForro.map((p, idx) => <option key={idx} value={p.produto}>{p.produto}</option>)}
                            </select>
                          </td>
                          <td className="p-1 text-center font-bold">{f.tip}</td>
                          <td className="p-1 text-center">
                            <input type="number" min="0" value={f.qtde} onChange={(e) => updForro(i, 'qtde', e.target.value)} disabled={pedidoSalvo} className={`w-full p-1 border rounded text-center ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''}`} />
                          </td>
                          <td className="p-1 text-center">
                            <div className="flex items-center gap-0.5 justify-center">
                              <input 
                                type="text" 
                                value={f.comp} 
                                onChange={(e) => {
                                  // Converter vírgula para ponto
                                  let valor = e.target.value.replace(',', '.');
                                  updForro(i, 'comp', valor);
                                }}
                                onBlur={(e) => {
                                  // Validar e arredondar para 0.1 (10cm) ao sair do campo
                                  let valor = parseFloat(e.target.value.replace(',', '.')) || 3;
                                  // Limitar entre 3 e 12
                                  if (valor < 3) valor = 3;
                                  if (valor > 12) valor = 12;
                                  // Arredondar para 1 casa decimal (10 em 10 cm)
                                  valor = Math.round(valor * 10) / 10;
                                  updForro(i, 'comp', valor.toString());
                                }}
                                disabled={pedidoSalvo} 
                                className={`w-12 p-1 border rounded text-center text-sm ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                placeholder="6"
                              />
                              <span className="text-xs text-gray-500 ml-0.5">m</span>
                              <div className="flex flex-col">
                                <button 
                                  type="button"
                                  onClick={() => {
                                    let valor = parseFloat(f.comp) || 3;
                                    valor = Math.round((valor + 0.1) * 10) / 10;
                                    if (valor > 12) valor = 12;
                                    updForro(i, 'comp', valor.toString());
                                  }}
                                  disabled={pedidoSalvo || parseFloat(f.comp) >= 12}
                                  className="text-gray-500 hover:text-blue-600 disabled:opacity-30 disabled:cursor-not-allowed"
                                  title="Aumentar 10cm"
                                >
                                  <ChevronUp size={14} />
                                </button>
                                <button 
                                  type="button"
                                  onClick={() => {
                                    let valor = parseFloat(f.comp) || 3;
                                    valor = Math.round((valor - 0.1) * 10) / 10;
                                    if (valor < 3) valor = 3;
                                    updForro(i, 'comp', valor.toString());
                                  }}
                                  disabled={pedidoSalvo || parseFloat(f.comp) <= 3}
                                  className="text-gray-500 hover:text-blue-600 disabled:opacity-30 disabled:cursor-not-allowed"
                                  title="Diminuir 10cm"
                                >
                                  <ChevronDown size={14} />
                                </button>
                              </div>
                            </div>
                          </td>
                          <td className="p-1 text-center"><input type="text" value={formatarMoeda(f.m2)} className="w-full p-1 bg-blue-50 font-bold text-center" disabled /></td>
                          <td className="p-1 text-center">
                            <div className="relative group">
                              <input 
                                type="number" 
                                step="0.01" 
                                value={f.preco} 
                                onChange={(e) => updForro(i, 'preco', e.target.value)} 
                                disabled={pedidoSalvo} 
                                className={`w-full p-1 border rounded text-center ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : ''} ${f.abaixoMinimo ? 'border-red-500 bg-red-50 text-red-600 border-2' : ''}`} 
                              />
                              {f.abaixoMinimo && f.valorMinimo > 0 && (
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 bg-red-600 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-50">
                                  Mínimo: R$ {f.valorMinimo?.toFixed(2)}
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-red-600"></div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="p-1 text-center"><input type="text" value={`R$ ${formatarMoeda(f.total)}`} className="w-full p-1 bg-green-50 font-bold text-center" disabled /></td>
                          <td className="p-1">
                            <div className="flex items-center justify-between gap-2">
                              <div className="flex items-center gap-1">
                                {!pedidoSalvo && podeAdicionarAcabamento && (
                                  <button 
                                    onClick={() => addAcessorioParaForro(f.id, f.ordem)} 
                                    className="text-white hover:opacity-90 px-2 py-1 rounded text-[10px] font-semibold flex items-center gap-1 whitespace-nowrap"
                                    style={{backgroundColor: '#00BEFF'}}
                                    title="Adicionar acabamento"
                                  >
                                    <Plus size={12} />
                                    Acabamento
                                  </button>
                                )}
                                {!pedidoSalvo && (
                                  <button onClick={() => delForro(i)} className="bg-red-500 text-white p-1.5 rounded hover:bg-red-600" title="Remover">
                                    <Trash2 size={14} />
                                  </button>
                                )}
                              </div>
                              {statusForro && configForro && (
                                <span className={`px-2 py-1 rounded text-[10px] font-bold whitespace-nowrap ${configForro.bgSolid} ${configForro.textColor}`}>
                                  {statusForro === 'EM ANÁLISE' ? 'ANÁLISE' : statusForro}
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                        
                        {/* Linhas de Acabamento vinculadas ao forro - fundo cinza mais claro */}
                        {acabamentosDoForro.map((a) => {
                          const acessIndex = pedido.acessorios.findIndex(ac => ac === a);
                          return (
                            <tr key={`acess-${acessIndex}`} className="border-b hover:bg-gray-100 transition-colors duration-200" style={{backgroundColor: '#f5f5f5'}}>
                              <td className="p-1 text-center">
                                {/* Mostra a mesma tabela do forro pai - não pode editar */}
                                <input type="text" value={a.ordem} className="w-full p-1 bg-gray-100 text-center font-bold text-xs" disabled title="Segue a tabela do forro" />
                              </td>
                              <td className="p-1 text-center"><input type="text" value={a.cod || ''} className="w-full p-1 text-center font-bold bg-transparent" disabled /></td>
                              <td className="p-1">
                                <div className="flex items-center gap-1">
                                  <span className="text-gray-400 text-[10px] font-bold">↳</span>
                                  <select value={a.produto} onChange={(e) => updAcess(acessIndex, 'produto', e.target.value)} disabled={pedidoSalvo} className={`w-full p-1 border rounded text-xs ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : 'border-cyan-200'}`}>
                                    <option value="">Selecione...</option>
                                    {acessoriosLista.map((x, idx) => <option key={idx} value={x.produto}>{x.produto}</option>)}
                                  </select>
                                </div>
                              </td>
                              <td className="p-1 text-center font-bold text-gray-500">{a.tip}</td>
                              <td className="p-1 text-center">
                                <input type="number" min="0" value={a.qtde} onChange={(e) => updAcess(acessIndex, 'qtde', e.target.value)} disabled={pedidoSalvo} className={`w-full p-1 border rounded text-center ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : 'border-cyan-200'}`} />
                              </td>
                              <td className="p-1 text-center text-gray-400 text-[10px]" colSpan="2">
                                {/* Acabamento não tem COMP e M² */}
                                -
                              </td>
                              <td className="p-1 text-center">
                                <div className="relative group">
                                  <input 
                                    type="number" 
                                    step="0.01" 
                                    value={a.preco} 
                                    onChange={(e) => updAcess(acessIndex, 'preco', e.target.value)} 
                                    disabled={pedidoSalvo} 
                                    className={`w-full p-1 border rounded text-center ${pedidoSalvo ? 'bg-gray-100 cursor-not-allowed' : 'border-cyan-200'} ${a.abaixoMinimo ? 'border-red-500 bg-red-50 text-red-600 border-2' : ''}`} 
                                  />
                                  {a.abaixoMinimo && a.valorMinimo > 0 && (
                                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 bg-red-600 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-50">
                                      Mínimo: R$ {a.valorMinimo?.toFixed(2)}
                                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-red-600"></div>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="p-1 text-center"><input type="text" value={`R$ ${formatarMoeda(a.total)}`} className="w-full p-1 bg-green-50 font-bold text-center" disabled /></td>
                              <td className="p-1">
                                <div className="flex items-center justify-between gap-2">
                                  <div className="flex items-center gap-1">
                                    {!pedidoSalvo && (
                                      <button onClick={() => delAcess(acessIndex)} className="bg-red-500 text-white p-1 rounded hover:bg-red-600 transition-colors" title="Remover acabamento">
                                        <Trash2 size={14} />
                                      </button>
                                    )}
                                  </div>
                                  {/* Mostrar o mesmo status do forro pai */}
                                  {statusForro && configForro && (
                                    <span className={`px-2 py-1 rounded text-[10px] font-bold whitespace-nowrap ${configForro.bgSolid} ${configForro.textColor}`}>
                                      {statusForro === 'EM ANÁLISE' ? 'ANÁLISE' : statusForro}
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                {/* Linha de Totais */}
                {pedido.forro.length > 0 && (
                  <tfoot>
                    <tr className="bg-gray-100 border-t-2 border-gray-300">
                      <td colSpan={5} className="p-2">
                        <div className="flex items-center justify-end gap-4 flex-wrap w-full">
                          {podeVerPercentualAcabamento() && (() => {
                              const totalForro = (tab1.valorForro || 0) + (tab2.valorForro || 0);
                              const totalAcabamento = (tab1.valorAcabamento || 0) + (tab2.valorAcabamento || 0);
                              const percentualAcabamento = totalForro > 0 ? (totalAcabamento / totalForro) * 100 : 0;
                              return (
                                <span className="text-blue-600 font-bold text-xs whitespace-nowrap">
                                  % Acabamento: {percentualAcabamento.toFixed(1)}%
                                </span>
                              );
                            })()}
                          <span className="text-gray-600 font-semibold text-xs whitespace-nowrap">
                            Qtde. Acabamentos: {pedido.acessorios.reduce((acc, a) => acc + (parseInt(a.qtde ?? a.quantidade) || 0), 0)}
                          </span>
                        </div>
                      </td>
                      <td className="p-2 text-right">
                        <span className="text-gray-600 font-bold text-xs whitespace-nowrap">TOTAIS:</span>
                      </td>
                      <td className="p-2 text-center">
                        <span className="text-gray-700 font-bold text-sm whitespace-nowrap">{formatarMoeda(pedido.forro.reduce((acc, f) => acc + (parseFloat(f.m2) || 0), 0))} m²</span>
                      </td>
                      <td className="p-2"></td>
                      <td className="p-2 text-center">
                        <span className="text-gray-700 font-bold text-sm whitespace-nowrap">R$ {formatarMoeda(
                          pedido.forro.reduce((acc, f) => acc + (parseFloat(f.total) || 0), 0) +
                          pedido.acessorios.reduce((acc, a) => acc + (parseFloat(a.total) || 0), 0)
                        )}</span>
                      </td>
                      <td className="p-2">
                        {/* Status Geral do Pedido */}
                        {(() => {
                          const totalVendaGeral = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0);
                          const pontTab1 = tab1.temItens ? Math.min(tab1.pontuacao || 0, 50) : 0;
                          const pontTab2 = tab2.temItens ? Math.min(tab2.pontuacao || 0, 50) : 0;
                          const pontuacaoGeral = Math.min(pontTab1 + pontTab2, 50);
                          const statusGeral = totalVendaGeral === 0 ? 'INVIÁVEL' : getStatusByScore(pontuacaoGeral);
                          const configGeral = getStatusConfig(statusGeral);
                          const IconeGeral = configGeral?.icon;
                          
                          return totalVendaGeral > 0 ? (
                            <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-bold ${configGeral?.bgSolid} ${configGeral?.textColor}`}>
                              {IconeGeral && <IconeGeral size={16} />}
                              {statusGeral}
                            </span>
                          ) : null;
                        })()}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
              
              {/* Mensagem quando não há forros */}
              {pedido.forro.length === 0 && (
                <div className="text-center py-8 text-gray-400">
                  <ShoppingCart size={40} className="mx-auto mb-2 opacity-30" />
                  <p className="text-sm">Nenhum item adicionado ainda</p>
                  <p className="text-xs">Clique em "Adicionar" para incluir um forro</p>
                </div>
              )}
            </div>
            )}
            
            {/* ========================================
                MODO VENDA ESPECIAL - PRODUTOS ESPECIAIS
                Só aparece quando ativa o modo de venda especial
            ======================================== */}
            {modoVendaEspecial && (
              <div className="bg-white rounded-xl shadow-md p-6 mb-6 w-full max-w-6xl mx-auto hover:shadow-lg transition-all duration-300 border-2 border-purple-200">
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center gap-2">
                    <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-semibold">
                      {itensEspeciais.length} {itensEspeciais.length === 1 ? 'item' : 'itens'}
                    </span>
                    {totalProdutosEspeciais > 0 && (
                      <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
                        Total: R$ {formatarMoeda(totalProdutosEspeciais)}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-3">
                    {/* Botão Voltar para Venda Normal */}
                    {!pedidoSalvo && (
                      <button 
                        onClick={ativarModoVendaNormal} 
                        className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-4 py-2 rounded-lg hover:opacity-90 hover:scale-105 hover:shadow-md flex items-center gap-2 transition-all duration-300 group"
                      >
                        <ShoppingCart size={18} className="group-hover:rotate-12 transition-transform duration-300" />
                        Vender Produtos Normais
                      </button>
                    )}
                    {!pedidoSalvo ? (
                      <button 
                        onClick={addItemEspecial} 
                        className="text-white px-4 py-2 rounded-lg hover:opacity-90 hover:scale-105 hover:shadow-md flex items-center gap-2 transition-all duration-300 group bg-gradient-to-r from-purple-500 to-pink-500"
                      >
                        <Plus size={18} className="group-hover:rotate-90 transition-transform duration-300" />
                        Adicionar Produto
                      </button>
                    ) : (
                      <span className="bg-gray-100 text-gray-500 px-4 py-2 rounded-lg flex items-center gap-2 font-semibold text-sm">
                        <CheckCircle size={16} />Bloqueado
                      </span>
                    )}
                  </div>
                </div>

                {itensEspeciais.length > 0 ? (
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="text-white" style={{background: 'linear-gradient(to right, #9333ea, #ec4899)'}}>
                        <th className="p-2 text-center rounded-l-lg w-[60px]">#</th>
                        <th className="p-2 text-center w-[80px]">CÓD</th>
                        <th className="p-2 text-left">PRODUTO</th>
                        <th className="p-2 text-center w-[100px]">FAMÍLIA</th>
                        <th className="p-2 text-center w-[80px]">QTDE</th>
                        <th className="p-2 text-center w-[120px]">PREÇO UN</th>
                        <th className="p-2 text-center w-[120px]">TOTAL</th>
                        <th className="p-2 text-center rounded-r-lg w-[60px]">AÇÕES</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itensEspeciais.map((item, idx) => (
                        <tr key={item.id} className="border-b hover:bg-purple-50 transition-colors">
                          <td className="p-2 text-center font-bold text-purple-600">{idx + 1}</td>
                          <td className="p-2 text-center">
                            <input type="text" value={item.codigo} className="w-full p-1 bg-gray-50 text-center text-xs" disabled />
                          </td>
                          <td className="p-2">
                            <select
                              value={item.produto}
                              onChange={(e) => updItemEspecial(idx, 'produto', e.target.value)}
                              disabled={pedidoSalvo}
                              className="w-full p-2 border rounded-lg text-sm focus:border-purple-400 focus:ring-2 focus:ring-purple-100"
                            >
                              <option value="">Selecione um produto...</option>
                              {produtosEspeciais.map((p, i) => (
                                <option key={i} value={p.produto}>{p.produto}</option>
                              ))}
                            </select>
                          </td>
                          <td className="p-2 text-center">
                            <input type="text" value={item.familia} className="w-full p-1 bg-gray-50 text-center text-xs" disabled />
                          </td>
                          <td className="p-2">
                            <input
                              type="number"
                              min="1"
                              value={item.qtde}
                              onChange={(e) => updItemEspecial(idx, 'qtde', e.target.value)}
                              disabled={pedidoSalvo}
                              className="w-full p-2 border rounded-lg text-center focus:border-purple-400"
                            />
                          </td>
                          <td className="p-2">
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              value={item.preco}
                              onChange={(e) => updItemEspecial(idx, 'preco', e.target.value)}
                              disabled={pedidoSalvo}
                              placeholder="0,00"
                              className="w-full p-2 border rounded-lg text-center focus:border-purple-400"
                            />
                          </td>
                          <td className="p-2 text-center">
                            <input 
                              type="text" 
                              value={`R$ ${formatarMoeda(item.total)}`} 
                              className="w-full p-2 bg-green-50 font-bold text-center rounded-lg" 
                              disabled 
                            />
                          </td>
                          <td className="p-2 text-center">
                            {!pedidoSalvo && (
                              <button 
                                onClick={() => remItemEspecial(idx)} 
                                className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition-colors" 
                                title="Remover produto"
                              >
                                <Trash2 size={14} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center py-8 text-gray-400">
                    <Package size={40} className="mx-auto mb-2 opacity-30" />
                    <p className="text-sm">Nenhum produto especial adicionado</p>
                    <p className="text-xs">Clique em "Adicionar Produto" para incluir</p>
                  </div>
                )}

                {/* Aviso informativo */}
                <div className="mt-4 p-3 bg-purple-50 border border-purple-200 rounded-lg">
                  <p className="text-xs text-purple-700 flex items-center gap-2">
                    <AlertCircle size={14} />
                    <span>Estes produtos são do grupo "Demais Produtos" e <strong>não entram</strong> no cálculo de margem, receita ou pontuação.</span>
                  </p>
                </div>
              </div>
            )}
            </>
            )}

            {/* DIVISÓRIA - RESUMO */}
            <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
              <div className="w-full h-px bg-gray-200 mb-6"></div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 group cursor-default">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                    <ShoppingCart size={20} className="text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Resumo da Compra</h2>
                    <p className="text-xs text-gray-400">Visão geral dos itens e valores</p>
                  </div>
                </div>
                <button 
                  onClick={() => toggleExpandir('resumo')} 
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                >
                  <ChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${expandido.resumo ? 'rotate-180' : ''}`} />
                  {expandido.resumo ? 'Recolher' : 'Expandir'}
                </button>
              </div>
            </div>

            {expandido.resumo && (
            <>
            {/* CARD RESUMO DA COMPRA */}
            <div className="w-full max-w-6xl mx-auto bg-white rounded-2xl shadow-xl p-8 border border-gray-100 mb-6 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
              
              {/* RESUMO PARA PRODUTOS ESPECIAIS */}
              {modoVendaEspecial ? (
                <div className="space-y-6">
                  {/* Card único para produtos especiais */}
                  <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl hover:scale-[1.01] transition-all duration-300 border-2 border-purple-200">
                    <div className="bg-gradient-to-r from-purple-600 to-pink-500 p-4 text-white font-bold text-lg flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Package size={24} className="text-white" />
                        <span className="text-xl">PRODUTOS ESPECIAIS</span>
                      </div>
                      <div className="bg-white/20 px-4 py-2 rounded-xl">
                        <span className="text-white/80 text-xs mr-2">Status:</span>
                        <span className="font-black text-lg">VIÁVEL</span>
                      </div>
                    </div>
                    <div className="p-6">
                      {itensEspeciais.length > 0 ? (
                        <>
                          <table className="w-full text-sm">
                            <thead>
                              <tr className="border-b-2">
                                <th className="pb-3 text-left">Produto</th>
                                <th className="pb-3 text-right">Qtde</th>
                                <th className="pb-3 text-right">Preço</th>
                                <th className="pb-3 text-right">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {itensEspeciais.filter(item => item.produto).map((item, i) => (
                                <tr key={i} className="border-b hover:bg-purple-50 transition-colors duration-200">
                                  <td className="py-2">{item.produto}</td>
                                  <td className="py-2 text-right">{item.qtde}</td>
                                  <td className="py-2 text-right">R$ {formatarMoeda(item.preco)}</td>
                                  <td className="py-2 text-right font-bold">R$ {formatarMoeda(item.total)}</td>
                                </tr>
                              ))}
                              <tr className="bg-purple-50 font-bold border-t-2">
                                <td colSpan="3" className="py-3">TOTAL</td>
                                <td className="py-3 text-right text-lg text-purple-600">R$ {formatarMoeda(totalProdutosEspeciais)}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="mt-4 flex items-center justify-center">
                            <StatusBadge status="VIÁVEL" tamanho="md" fullWidth />
                          </div>
                        </>
                      ) : (
                        <p className="text-center py-8 text-gray-400">Nenhum produto adicionado</p>
                      )}
                    </div>
                  </div>

                  {/* Card de informações */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-white rounded-xl p-5 border-2 border-purple-100 shadow-md">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
                          <Package size={16} className="text-white" />
                        </div>
                        <h4 className="text-sm font-bold text-purple-600">ITENS</h4>
                      </div>
                      <span className="text-3xl font-black text-purple-600">{itensEspeciais.filter(i => i.produto).length}</span>
                    </div>
                    <div className="bg-white rounded-xl p-5 border-2 border-green-100 shadow-md">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-8 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
                          <DollarSign size={16} className="text-white" />
                        </div>
                        <h4 className="text-sm font-bold text-green-600">VALOR TOTAL</h4>
                      </div>
                      <span className="text-3xl font-black text-green-600">R$ {formatarMoeda(totalProdutosEspeciais)}</span>
                    </div>
                  </div>

                  {/* Aviso */}
                  <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg">
                    <p className="text-sm text-purple-700 flex items-center gap-2">
                      <AlertCircle size={16} />
                      <span>Produtos Especiais são automaticamente considerados <strong>VIÁVEL</strong> e não entram no cálculo de margem ou pontuação.</span>
                    </p>
                  </div>
                </div>
              ) : (
              /* RESUMO NORMAL - TABELAS 1 E 2 */
              <>
              <div className="grid grid-cols-2 gap-6">
                {[{data: tab1, status: status1, config: config1, cor: '#0d5dfc'}, {data: tab2, status: status2, config: config2, cor: '#00BEFF'}].map((t, idx) => (
                  <div key={idx} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl hover:scale-[1.02] transition-all duration-300 border border-gray-100">
                    <div style={{backgroundColor: t.cor}} className="p-4 text-white font-bold text-lg flex items-center justify-between min-h-[60px]">
                      <span className="text-xl">TABELA {idx + 1}</span>
                      {t.data.temItens && (
                        <div className="bg-white/20 px-4 py-2 rounded-xl">
                          <span className="text-white/80 text-xs mr-2">Pontuação:</span>
                          <span className="font-black text-lg">{formatarPontuacao(t.data.pontuacao)}</span>
                        </div>
                      )}
                    </div>
                    <div className="p-6">
                      {t.data.temItens && t.data.resumo.length > 0 ? (
                        <>
                          <table className="w-full text-sm">
                            <thead><tr className="border-b-2"><th className="pb-3 text-left">Produto</th><th className="pb-3 text-right">Preço</th><th className="pb-3 text-right">Qtd/m²</th><th className="pb-3 text-right">Total</th></tr></thead>
                            <tbody>
                              {t.data.resumo.map((r, i) => (
                                <tr key={i} className={`border-b hover:bg-slate-50 transition-colors duration-200 ${r.isAcabamento ? 'bg-slate-50' : ''}`}>
                                  <td className="py-2">
                                    <div className="flex items-center gap-1">
                                      {r.isAcabamento && <span className="text-gray-400 text-sm font-bold">↳</span>}
                                      <span className={r.isAcabamento ? 'text-slate-600' : ''}>{limparNomeProduto(r.produto)}</span>
                                    </div>
                                  </td>
                                  <td className="py-2 text-right">R$ {formatarMoeda(r.preco)}</td>
                                  <td className="py-2 text-right">{r.isForro ? (parseFloat(r.qtdade) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (r.qtdade || 0)}</td>
                                  <td className="py-2 text-right font-bold">R$ {formatarMoeda(r.total)}</td>
                                </tr>
                              ))}
                              <tr className="bg-slate-100 font-bold border-t-2"><td colSpan="3" className="py-3">TOTAL</td><td className="py-3 text-right text-lg">R$ {formatarMoeda(t.data.valorGerado)}</td></tr>
                            </tbody>
                          </table>
                          {t.config && (
                            <div className="mt-4">
                              <StatusBadge status={t.status} tamanho="md" fullWidth />
                            </div>
                          )}
                        </>
                      ) : <p className="text-center py-8 text-gray-400">Nenhum item</p>}
                    </div>
                  </div>
                ))}
              </div>

              {/* SEÇÃO DE MÉTRICAS - Reorganizado */}
              {(tab1.temItens || tab2.temItens) && (
                <div className="mt-8 pt-6 border-t-2 border-gray-100">
                  <div className={`grid gap-4 ${podeVerPercentualAcabamento() ? 'grid-cols-3' : 'grid-cols-2'}`}>
                    {/* % de Acabamento - Aparece apenas para Admin, Diretoria, Administrativo e Vendas */}
                    {podeVerPercentualAcabamento() && (
                    <div className="bg-white rounded-xl p-5 border-2 border-blue-100 shadow-md hover:shadow-lg hover:scale-[1.02] hover:border-blue-300 transition-all duration-300">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                          <BarChart3 size={16} className="text-white" />
                        </div>
                        <h4 className="text-sm font-bold text-blue-600 uppercase tracking-wide">% Acabamento</h4>
                      </div>
                      {(() => {
                        const totalForro = (tab1.valorForro || 0) + (tab2.valorForro || 0);
                        const totalAcabamento = (tab1.valorAcabamento || 0) + (tab2.valorAcabamento || 0);
                        const percentualAcabamento = totalForro > 0 ? (totalAcabamento / totalForro) * 100 : 0;
                        const metaAcabamento = 30;
                        const atingiuMeta = percentualAcabamento >= metaAcabamento;
                        
                        return (
                          <div className="space-y-3">
                            <div className="flex items-end justify-between">
                              <span className={`text-3xl font-black ${atingiuMeta ? 'text-emerald-600' : 'text-blue-600'}`}>
                                {percentualAcabamento.toFixed(1)}%
                              </span>
                              <span className="text-xs text-gray-400 font-medium">
                                meta <span className="font-bold text-gray-600">{metaAcabamento}%</span>
                              </span>
                            </div>
                            {/* Barra de progresso */}
                            <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
                              <div 
                                className={`h-full rounded-full transition-all duration-500 ${atingiuMeta ? 'bg-gradient-to-r from-emerald-500 to-green-400' : 'bg-gradient-to-r from-blue-500 to-cyan-400'}`}
                                style={{ width: `${Math.min((percentualAcabamento / metaAcabamento) * 100, 100)}%` }}
                              ></div>
                            </div>
                            <div className="grid grid-cols-2 gap-2 text-xs">
                              <div className="text-left">
                                <div className="font-bold text-gray-700">R$ {formatarMoeda(totalAcabamento)}</div>
                                <div className="text-gray-400 text-[10px] uppercase">Acabamento</div>
                              </div>
                              <div className="text-right">
                                <div className="font-bold text-gray-700">R$ {formatarMoeda(totalForro)}</div>
                                <div className="text-gray-400 text-[10px] uppercase">Forro</div>
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                    )}

                    {/* Card PONTUAÇÃO + STATUS (juntos, centralizado verticalmente) */}
                    <div className="bg-white rounded-xl p-4 border-2 border-blue-100 shadow-md hover:shadow-lg hover:scale-[1.02] hover:border-blue-300 transition-all duration-300 flex items-center">
                      {(() => {
                        const totalVendaGeral = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0);
                        
                        // Pontuação de cada tabela com cap de 50
                        const pontTab1 = tab1.temItens ? Math.min(tab1.pontuacao || 0, 50) : 0;
                        const pontTab2 = tab2.temItens ? Math.min(tab2.pontuacao || 0, 50) : 0;
                        
                        // Pontuação geral = SOMA das pontuações, também limitada a 50 no total
                        const pontuacaoGeral = Math.min(pontTab1 + pontTab2, 50);
                        
                        const statusGeral = totalVendaGeral === 0 ? 'INVIÁVEL' : getStatusByScore(pontuacaoGeral);
                        const configGeral = getStatusConfig(statusGeral);
                        const IconeGeral = configGeral?.icon || AlertTriangle;
                        
                        return (
                          <div className="flex flex-col w-full justify-center">
                            {/* Pontuação Geral */}
                            <div className="flex items-center gap-2 mb-2">
                              <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                                <BarChart3 size={14} className="text-white" />
                              </div>
                              <h4 className="text-sm font-bold text-blue-600 uppercase tracking-wide">Pontuação Geral</h4>
                              <span className={`text-2xl font-black ml-auto ${pontuacaoGeral >= 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                                {pontuacaoGeral.toFixed(2).replace('.', ',')}
                              </span>
                            </div>
                            {/* Status */}
                            <div className="flex items-center gap-2 pt-2 border-t border-gray-100">
                              <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                                <IconeGeral size={14} className="text-white" />
                              </div>
                              <h4 className="text-sm font-bold text-blue-600 uppercase tracking-wide">Status</h4>
                              <div className="ml-auto">
                                <StatusBadge status={statusGeral} tamanho="lg" />
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                    </div>

                    {/* Card VALOR TOTAL DO PEDIDO (azul) */}
                    <div className="bg-white rounded-xl p-4 border-2 border-blue-100 shadow-md hover:shadow-lg hover:scale-[1.02] hover:border-blue-300 transition-all duration-300">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                          <DollarSign size={14} className="text-white" />
                        </div>
                        <h4 className="text-sm font-bold text-blue-600 uppercase tracking-wide">Valor Total</h4>
                      </div>
                      {(() => {
                        const totalProdutos = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0);
                        const taxaEntrega = temTaxaEntrega ? (parseFloat(valorTaxaEntrega) || 0) : 0;
                        const totalGeral = totalProdutos + taxaEntrega;
                        // Mostrar taxa de entrega para Vendas, Diretoria, Admin, Administrativo
                        const dep = (usuarioLogado?.departamento || '').toLowerCase();
                        const mostrarTaxaEntrega = dep === 'vendas' || dep === 'diretoria' || dep === 'admin' || dep === 'administrativo';
                        
                        return (
                          <div className="space-y-1">
                            <div className="flex justify-between items-center">
                              <span className="text-xs text-gray-500">Total Produtos</span>
                              <span className="text-lg font-bold text-gray-700">R$ {formatarMoeda(totalProdutos)}</span>
                            </div>
                            {mostrarTaxaEntrega && taxaEntrega > 0 && (
                              <div className="flex justify-between items-center">
                                <span className="text-xs text-gray-500">Taxa Entrega</span>
                                <span className="text-sm font-medium text-gray-600">R$ {formatarMoeda(taxaEntrega)}</span>
                              </div>
                            )}
                            {mostrarTaxaEntrega && taxaEntrega > 0 && (
                              <div className="flex justify-between items-center pt-1 border-t border-blue-200">
                                <span className="text-xs font-bold text-blue-600">TOTAL GERAL</span>
                                <span className="text-xl font-black text-blue-600">R$ {formatarMoeda(totalGeral)}</span>
                              </div>
                            )}
                            {(!mostrarTaxaEntrega || taxaEntrega === 0) && (
                              <div className="text-center pt-1">
                                <span className="text-2xl font-black text-blue-600">R$ {formatarMoeda(totalProdutos)}</span>
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              )}
              </>
              )}
            </div>
            </>
            )}

            {/* ========================================
                SEÇÃO DE FORMAS DE PAGAMENTO
            ======================================== */}
            
            {/* DIVISÓRIA - FORMAS DE PAGAMENTO */}
            <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
              <div className="w-full h-px bg-gray-200 mb-6"></div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 group cursor-default">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                    <CreditCard size={20} className="text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Formas de Pagamento</h2>
                    <p className="text-xs text-gray-400">Selecione até 4 formas de pagamento</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-slate-100 to-gray-100 rounded-xl border border-slate-200">
                    <span className="text-sm text-slate-700 font-medium">Selecionadas:</span>
                    <span className="text-lg font-bold text-slate-600">{getFormasPagamentoSelecionadas()}/4</span>
                  </div>
                  <button 
                    onClick={() => toggleExpandir('pagamento')} 
                    className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                  >
                    <ChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${expandido.pagamento ? 'rotate-180' : ''}`} />
                    {expandido.pagamento ? 'Recolher' : 'Expandir'}
                  </button>
                </div>
              </div>
            </div>

            {expandido.pagamento && (
              <div className="w-full max-w-6xl mx-auto bg-white rounded-2xl shadow-xl p-8 border border-gray-100 mb-6 hover:shadow-2xl transition-all duration-300">
                <div className="space-y-4">
                  {formasPagamento.map((fp, index) => (
                    <div 
                      key={index} 
                      className={`rounded-xl border-2 transition-all duration-300 ${
                        fp.forma 
                          ? 'border-blue-300 bg-gradient-to-r from-blue-50 to-cyan-50 shadow-md' 
                          : 'border-gray-200 bg-gray-50 hover:border-gray-300'
                      }`}
                    >
                      <div className="p-4">
                        <div className="flex items-center gap-4">
                          {/* Número da opção */}
                          <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-bold text-lg shadow-sm ${
                            fp.forma 
                              ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white' 
                              : 'bg-gray-200 text-gray-500'
                          }`}>
                            {index + 1}
                          </div>

                          {/* Select da forma de pagamento */}
                          <div className="flex-1">
                            <select
                              value={fp.forma}
                              onChange={(e) => atualizarFormaPagamento(index, 'forma', e.target.value)}
                              disabled={pedidoSalvo}
                              className={`w-full p-3 border-2 rounded-xl font-medium transition-all duration-300 ${
                                pedidoSalvo 
                                  ? 'bg-gray-100 cursor-not-allowed text-gray-500' 
                                  : fp.forma 
                                    ? 'border-blue-300 bg-white text-gray-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-100' 
                                    : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                              }`}
                            >
                              <option value="">Selecione uma forma de pagamento...</option>
                              {FORMAS_PAGAMENTO.map((forma) => (
                                <option key={forma.id} value={forma.label}>
                                  {forma.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Campo de observação */}
                          <div className="flex-1">
                            {(() => {
                              const formaConfig = FORMAS_PAGAMENTO.find(f => f.label === fp.forma);
                              const obrigatorio = formaConfig?.exigeObservacao || false;
                              const faltaObservacao = obrigatorio && (!fp.observacao || fp.observacao.trim() === '');
                              
                              return (
                                <input
                                  type="text"
                                  value={fp.observacao}
                                  onChange={(e) => atualizarFormaPagamento(index, 'observacao', e.target.value)}
                                  placeholder={obrigatorio ? "Observação obrigatória *" : "Observações (opcional)..."}
                                  disabled={pedidoSalvo || !fp.forma}
                                  className={`w-full p-3 border-2 rounded-xl transition-all duration-300 ${
                                    pedidoSalvo || !fp.forma
                                      ? 'bg-gray-100 cursor-not-allowed text-gray-400 border-gray-200' 
                                      : faltaObservacao
                                        ? 'border-red-300 bg-red-50 text-gray-700 hover:border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100'
                                        : obrigatorio && fp.observacao
                                          ? 'border-green-300 bg-green-50 text-gray-700 hover:border-green-400 focus:border-green-500 focus:ring-2 focus:ring-green-100'
                                          : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                  }`}
                                />
                              );
                            })()}
                          </div>

                          {/* Botão limpar */}
                          {fp.forma && !pedidoSalvo && (
                            <button
                              onClick={() => limparFormaPagamento(index)}
                              className="p-2 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-300"
                              title="Limpar"
                            >
                              <X size={20} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Resumo das formas selecionadas */}
                {getFormasPagamentoSelecionadas() > 0 && (
                  <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border border-blue-200">
                    <h4 className="font-bold text-blue-700 mb-3 flex items-center gap-2">
                      <CheckCircle size={18} />
                      Formas de Pagamento Selecionadas
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {formasPagamento.filter(f => f.forma).map((f, i) => (
                        <div key={i} className="flex items-center gap-2 px-3 py-2 bg-white rounded-lg border border-blue-200 shadow-sm">
                          <Wallet size={16} className="text-blue-600" />
                          <span className="font-medium text-gray-700">{f.forma}</span>
                          {f.observacao && (
                            <span className="text-xs text-gray-500 italic">({f.observacao})</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Aviso se nenhuma forma foi selecionada e há itens */}
                {temItensNoPedido() && getFormasPagamentoSelecionadas() === 0 && !pedidoSalvo && (
                  <div className="mt-6 p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-200">
                    <div className="flex items-center gap-3">
                      <AlertTriangle size={20} className="text-amber-600" />
                      <span className="text-amber-700 font-medium">Selecione pelo menos uma forma de pagamento para salvar o pedido.</span>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ========================================
                SEÇÃO: ANÁLISE DE CRÉDITO PARCELADO
            ======================================== */}
            {cliente && temFormaPagamentoParcelada() && (
              <>
                {/* DIVISÓRIA - ANÁLISE DE CRÉDITO */}
                <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
                  <div className="w-full h-px bg-gray-200 mb-6"></div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 group cursor-default">
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                        <BarChart3 size={20} className="text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Análise de Crédito Parcelado</h2>
                        <p className="text-xs text-gray-400">Avaliação do limite de crédito do cliente</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className={`flex items-center gap-2 px-4 py-2 rounded-xl border ${
                        analiseCredito.ultrapassouLimite 
                          ? 'bg-gradient-to-r from-red-100 to-orange-100 border-red-200' 
                          : analiseCredito.limiteCredito === 0 
                            ? 'bg-gradient-to-r from-amber-100 to-yellow-100 border-amber-200'
                            : 'bg-gradient-to-r from-green-100 to-emerald-100 border-green-200'
                      }`}>
                        {analiseCredito.ultrapassouLimite ? (
                          <><AlertTriangle size={16} className="text-red-600" /><span className="text-sm text-red-700 font-medium">Limite Excedido</span></>
                        ) : analiseCredito.limiteCredito === 0 ? (
                          <><AlertTriangle size={16} className="text-amber-600" /><span className="text-sm text-amber-700 font-medium">Sem Limite</span></>
                        ) : (
                          <><CheckCircle size={16} className="text-green-600" /><span className="text-sm text-green-700 font-medium">OK</span></>
                        )}
                      </div>
                      <button 
                        onClick={() => toggleExpandir('analiseCredito')} 
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                      >
                        <ChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${expandido.analiseCredito ? 'rotate-180' : ''}`} />
                        {expandido.analiseCredito ? 'Recolher' : 'Expandir'}
                      </button>
                    </div>
                  </div>
                </div>

                {expandido.analiseCredito && (
                  <div className="w-full max-w-6xl mx-auto bg-white rounded-2xl shadow-xl p-8 border border-gray-100 mb-6 hover:shadow-2xl transition-all duration-300">
                    {analiseCredito.carregando ? (
                      <div className="flex items-center justify-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                        <span className="ml-3 text-gray-600">Calculando análise de crédito...</span>
                      </div>
                    ) : (
                      <div className="space-y-6">
                        {/* Cards de Informações do Cliente */}
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                          {/* Porte do Cliente */}
                          <div className="rounded-xl border-2 border-gray-200 bg-gray-50 p-4 hover:shadow-md hover:scale-105 transition-all duration-300">
                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 rounded-xl bg-gray-200 flex items-center justify-center">
                                <Building2 size={18} className="text-gray-500" />
                              </div>
                              <div>
                                <div className="text-xs text-gray-500 uppercase font-medium">Porte do Cliente</div>
                                <div className="text-lg font-bold text-gray-800">{analiseCredito.porte || 'Não definido'}</div>
                              </div>
                            </div>
                          </div>

                          {/* Limite de Crédito */}
                          <div className={`rounded-xl border-2 p-4 hover:shadow-md hover:scale-105 transition-all duration-300 ${
                            analiseCredito.limiteCredito > 0 
                              ? 'border-green-300 bg-gradient-to-r from-green-50 to-emerald-50' 
                              : 'border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50'
                          }`}>
                            <div className="flex items-center gap-3">
                              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                                analiseCredito.limiteCredito > 0 
                                  ? 'bg-gradient-to-br from-green-500 to-emerald-500' 
                                  : 'bg-gradient-to-br from-amber-500 to-yellow-500'
                              }`}>
                                <Wallet size={18} className="text-white" />
                              </div>
                              <div className="flex-1">
                                <div className="text-xs text-gray-500 uppercase font-medium">Limite de Crédito</div>
                                <div className={`text-lg font-bold ${analiseCredito.limiteCredito > 0 ? 'text-green-600' : 'text-amber-600'}`}>
                                  R$ {formatarMoeda(analiseCredito.limiteCredito)}
                                </div>
                                {analiseCredito.porte && analiseCredito.porte !== 'Não definido' && (
                                  <div className="text-xs mt-0.5">
                                    {analiseCredito.limitePersonalizado ? (
                                      <span className="text-gray-500">Personalizado (padrão: R$ {formatarMoeda(analiseCredito.limitePadrao)})</span>
                                    ) : (
                                      <span className="text-gray-500">Padrão do porte</span>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Pedidos (3 meses) */}
                          <div className="rounded-xl border-2 border-blue-300 bg-gradient-to-r from-blue-50 to-cyan-50 p-4 hover:shadow-md hover:scale-105 transition-all duration-300">
                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center">
                                <FileText size={18} className="text-white" />
                              </div>
                              <div>
                                <div className="text-xs text-gray-500 uppercase font-medium">Pedidos (3 meses)</div>
                                <div className="text-lg font-bold text-blue-600">{analiseCredito.quantidade} pedido(s)</div>
                              </div>
                            </div>
                          </div>

                          {/* % do Limite - Card novo */}
                          <div className={`rounded-xl border-2 p-4 hover:shadow-md hover:scale-105 transition-all duration-300 ${
                            analiseCredito.percentualDoLimite > 150 
                              ? 'border-red-300 bg-gradient-to-r from-red-50 to-orange-50' 
                              : analiseCredito.percentualDoLimite > 100
                                ? 'border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50'
                                : 'border-blue-300 bg-gradient-to-r from-blue-50 to-cyan-50'
                          }`}>
                            <div className="flex items-center gap-3">
                              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                                analiseCredito.percentualDoLimite > 150 
                                  ? 'bg-gradient-to-br from-red-500 to-orange-500' 
                                  : analiseCredito.percentualDoLimite > 100
                                    ? 'bg-gradient-to-br from-amber-500 to-yellow-500'
                                    : 'bg-gradient-to-br from-blue-500 to-cyan-500'
                              }`}>
                                <Percent size={18} className="text-white" />
                              </div>
                              <div>
                                <div className="text-xs text-gray-500 uppercase font-medium">% do Limite</div>
                                <div className={`text-lg font-bold ${
                                  analiseCredito.percentualDoLimite > 150 
                                    ? 'text-red-600' 
                                    : analiseCredito.percentualDoLimite > 100
                                      ? 'text-amber-600'
                                      : 'text-blue-600'
                                }`}>
                                  {analiseCredito.percentualDoLimite.toFixed(1)}%
                                </div>
                                <div className="text-xs text-gray-400">
                                  {analiseCredito.percentualDoLimite > 150 ? 'Limite excedido!' : analiseCredito.percentualDoLimite > 100 ? 'Acima do limite' : 'Dentro do limite'}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Cálculo da Média */}
                        <div className="p-6 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border border-blue-200 hover:shadow-md transition-all duration-300">
                          <h4 className="font-bold text-blue-700 mb-4 flex items-center gap-2">
                            <BarChart3 size={18} />
                            Cálculo da Média de Valores Parcelados
                          </h4>
                          
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div className="bg-white rounded-lg p-4 border border-blue-200 shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300">
                              <div className="text-xs text-gray-500 uppercase mb-1">Histórico (3 meses)</div>
                              <div className="text-xl font-bold text-gray-700">R$ {formatarMoeda(analiseCredito.totalHistorico)}</div>
                              <div className="text-xs text-gray-400">{analiseCredito.quantidade} pedido(s)</div>
                            </div>
                            
                            <div className="bg-white rounded-lg p-4 border border-blue-200 shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300">
                              <div className="text-xs text-blue-500 uppercase mb-1">Pedido Atual</div>
                              <div className="text-xl font-bold text-blue-600">R$ {formatarMoeda(analiseCredito.valorPedidoAtual)}</div>
                              <div className="text-xs text-gray-400">Tabela 1 + Tabela 2</div>
                            </div>
                            
                            <div className="bg-white rounded-lg p-4 border border-blue-200 shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300">
                              <div className="text-xs text-gray-500 uppercase mb-1">Total Geral</div>
                              <div className="text-xl font-bold text-gray-700">R$ {formatarMoeda(analiseCredito.totalGeral || 0)}</div>
                              <div className="text-xs text-gray-400">{analiseCredito.quantidadeTotal || 0} pedido(s)</div>
                            </div>
                            
                            <div className={`rounded-lg p-4 border shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300 ${
                              analiseCredito.ultrapassouLimite 
                                ? 'bg-red-50 border-red-300' 
                                : 'bg-green-50 border-green-300'
                            }`}>
                              <div className={`text-xs uppercase mb-1 ${analiseCredito.ultrapassouLimite ? 'text-red-500' : 'text-green-500'}`}>Média Parcelado</div>
                              <div className={`text-xl font-bold ${analiseCredito.ultrapassouLimite ? 'text-red-600' : 'text-green-600'}`}>
                                R$ {formatarMoeda(analiseCredito.mediaParcelado)}
                              </div>
                              <div className="text-xs text-gray-400">Total ÷ Qtd Pedidos</div>
                            </div>
                          </div>
                        </div>

                        {/* Alerta de Status */}
                        {analiseCredito.ultrapassouLimite && (
                          <div className="p-4 bg-gradient-to-r from-red-50 to-orange-50 rounded-xl border border-red-200 hover:shadow-md transition-all duration-300">
                            <div className="flex items-center gap-3">
                              <AlertTriangle size={20} className="text-red-600" />
                              <div>
                                <span className="text-red-700 font-medium">Atenção: Ultrapassou 150% do Limite!</span>
                                <span className="text-red-600 ml-2">
                                  A média está em <strong>{analiseCredito.percentualDoLimite.toFixed(1)}%</strong> do limite (R$ {formatarMoeda(analiseCredito.mediaParcelado)} / R$ {formatarMoeda(analiseCredito.limiteCredito)})
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {!analiseCredito.ultrapassouLimite && analiseCredito.limiteCredito > 0 && analiseCredito.percentualDoLimite > 100 && (
                          <div className="p-4 bg-gradient-to-r from-amber-50 to-yellow-50 rounded-xl border border-amber-200 hover:shadow-md transition-all duration-300">
                            <div className="flex items-center gap-3">
                              <AlertTriangle size={20} className="text-amber-600" />
                              <span className="text-amber-700 font-medium">Acima do Limite - A média está em {analiseCredito.percentualDoLimite.toFixed(1)}% do limite (tolerância até 150%).</span>
                            </div>
                          </div>
                        )}

                        {!analiseCredito.ultrapassouLimite && analiseCredito.limiteCredito > 0 && analiseCredito.percentualDoLimite <= 100 && (
                          <div className="p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200 hover:shadow-md transition-all duration-300">
                            <div className="flex items-center gap-3">
                              <CheckCircle size={20} className="text-green-600" />
                              <span className="text-green-700 font-medium">Dentro do Limite de Crédito - A média está em {analiseCredito.percentualDoLimite.toFixed(1)}% do limite aprovado.</span>
                            </div>
                          </div>
                        )}

                        {analiseCredito.limiteCredito === 0 && (
                          <div className="p-4 bg-gradient-to-r from-amber-50 to-yellow-50 rounded-xl border border-amber-200 hover:shadow-md transition-all duration-300">
                            <div className="flex items-center gap-3">
                              <AlertTriangle size={20} className="text-amber-600" />
                              <span className="text-amber-700 font-medium">Limite de Crédito Não Definido - Considere definir um limite antes de aprovar vendas parceladas.</span>
                            </div>
                          </div>
                        )}

                        {/* Histórico de Pedidos */}
                        {analiseCredito.pedidosTodos && analiseCredito.pedidosTodos.length > 0 && (
                          <div className="border-2 border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300">
                            <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between">
                              <h4 className="font-bold text-gray-700 flex items-center gap-2">
                                <FileText size={16} className="text-blue-500" />
                                Histórico de Pedidos (Últimos 3 Meses)
                              </h4>
                              <div className="flex gap-3 text-xs">
                                <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                                  Total: {analiseCredito.quantidade} pedido(s)
                                </span>
                                <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full">
                                  Parcelados: {analiseCredito.quantidadeParcelados} ({analiseCredito.percentualParcelamento?.toFixed(1) || 0}%)
                                </span>
                              </div>
                            </div>
                            <div className="overflow-x-auto">
                              <table className="w-full text-sm">
                                <thead>
                                  <tr className="bg-gray-50 border-b border-gray-200">
                                    <th className="text-left p-3 font-medium text-gray-600">Proposta</th>
                                    <th className="text-left p-3 font-medium text-gray-600">Data</th>
                                    <th className="text-center p-3 font-medium text-gray-600">Tipo</th>
                                    <th className="text-right p-3 font-medium text-gray-600">Tab. 1</th>
                                    <th className="text-right p-3 font-medium text-gray-600">Tab. 2</th>
                                    <th className="text-right p-3 font-medium text-gray-600">Total</th>
                                    <th className="text-left p-3 font-medium text-gray-600">Formas de Pagamento</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {analiseCredito.pedidosTodos.map((p, idx) => (
                                    <tr key={idx} className={`border-b border-gray-100 hover:bg-blue-50/50 transition-colors ${p.ehParcelado ? 'bg-purple-50/30' : ''}`}>
                                      <td className="p-3 font-medium text-blue-600">{p.numero_proposta}</td>
                                      <td className="p-3 text-gray-600">{new Date(p.created_at).toLocaleDateString('pt-BR')}</td>
                                      <td className="p-3 text-center">
                                        {p.ehParcelado ? (
                                          <span className="inline-flex items-center gap-1 bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full text-xs font-medium">
                                            <CreditCard size={12} />
                                            Parcelado
                                          </span>
                                        ) : (
                                          <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-2 py-0.5 rounded-full text-xs font-medium">
                                            <Banknote size={12} />
                                            À Vista
                                          </span>
                                        )}
                                      </td>
                                      <td className="p-3 text-right text-gray-700">R$ {formatarMoeda(p.valor_tabela1 || 0)}</td>
                                      <td className="p-3 text-right text-gray-700">R$ {formatarMoeda(p.valor_tabela2 || 0)}</td>
                                      <td className="p-3 text-right font-semibold text-gray-800">R$ {formatarMoeda((p.valor_tabela1 || 0) + (p.valor_tabela2 || 0))}</td>
                                      <td className="p-3 text-gray-600 text-xs">
                                        {[p.forma_pagamento_1, p.forma_pagamento_2, p.forma_pagamento_3, p.forma_pagamento_4]
                                          .filter(Boolean)
                                          .join(', ')}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            {/* DIVISÓRIA - VISÃO ADMINISTRATIVA */}
            {podeVerVisaoAdmin() && (
              <>
                <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
                  <div className="w-full h-px bg-gray-200 mb-6"></div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 group cursor-default">
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                        <BarChart3 size={20} className="text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Visão Administrativa</h2>
                        <p className="text-xs text-gray-400">Análise de custos e rentabilidade</p>
                      </div>
                    </div>
                    <button 
                      onClick={() => toggleExpandir('admin')} 
                      className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                    >
                      <ChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${expandido.admin ? 'rotate-180' : ''}`} />
                      {expandido.admin ? 'Recolher' : 'Expandir'}
                    </button>
                  </div>
                </div>

                {expandido.admin && (
                <div className="w-full max-w-6xl mx-auto bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl shadow-xl p-8 border border-slate-200 mb-6 hover:shadow-2xl hover:scale-[1.005] hover:-translate-y-1 transition-all duration-300">
                <div className="space-y-8">
                  {[{data: tab1, nome: 'TABELA 1', status: status1, config: config1, cor: '#0d5dfc', badge: 'bg-blue-600'}, {data: tab2, nome: 'TABELA 2', status: status2, config: config2, cor: '#00BEFF', badge: 'bg-cyan-600'}].map((tabela, tIdx) => (
                    <div key={tIdx} className="bg-white rounded-2xl overflow-hidden border-2 border-slate-300 shadow-lg hover:shadow-xl hover:scale-[1.01] transition-all duration-300">
                      <div style={{backgroundColor: tabela.cor}} className="p-6 flex items-center justify-between flex-wrap gap-3">
                        <div className="flex items-center gap-3"><div className="w-1 h-8 bg-white/30 rounded-full"></div><h3 className="text-2xl font-bold text-white">{tabela.nome}</h3></div>
                        {tabela.data.temItens && tabela.data.resumo.length > 0 && (
                          <div className="flex gap-3 text-white text-sm flex-wrap">
                            <div className="text-right bg-white/10 px-3 py-2 rounded-lg hover:bg-white/20 transition-colors duration-200"><div className="text-white/80 text-[10px] uppercase">Total Venda</div><div className="text-base font-bold">R$ {formatarMoeda(tabela.data.valorGerado)}</div></div>
                            <div className="text-right bg-white/10 px-3 py-2 rounded-lg hover:bg-white/20 transition-colors duration-200"><div className="text-white/80 text-[10px] uppercase">Lucro</div><div className="text-base font-bold">R$ {formatarMoeda(tabela.data.lucro)}</div></div>
                            <div className="text-right bg-white/10 px-3 py-2 rounded-lg hover:bg-white/20 transition-colors duration-200"><div className="text-white/80 text-[10px] uppercase">Margem</div><div className="text-base font-bold">{tabela.data.margem?.toFixed(2).replace('.', ',')}%</div></div>
                            <div className="text-right bg-white/10 px-3 py-2 rounded-lg hover:bg-white/20 transition-colors duration-200"><div className="text-white/80 text-[10px] uppercase">Pontuação</div><div className="text-base font-bold">{formatarPontuacao(tabela.data.pontuacao)}</div></div>
                          </div>
                        )}
                      </div>
                      <div className="p-6 bg-slate-50">
                        {tabela.data.temItens && tabela.data.resumo.length > 0 ? (
                          <div className="overflow-x-auto bg-white rounded-xl border border-slate-200 shadow-sm">
                            <table className="w-full text-sm">
                              <thead>
                                <tr className="bg-slate-100 text-slate-700 border-b-2 border-slate-300">
                                  <th className="py-4 px-3 text-left font-bold uppercase text-xs whitespace-nowrap">Produto</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Preço</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">QTD/M²</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Total Venda</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Custo Un.</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Custo Total</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Lucro</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Margem</th>
                                  <th className="py-4 px-3 text-right font-bold uppercase text-xs whitespace-nowrap">Pontuação</th>
                                </tr>
                              </thead>
                              <tbody className="text-slate-700">
                                {tabela.data.resumo.map((r, i) => {
                                  const lucroItem = r.lucro || 0;
                                  const custoTotal = r.custoTotal || 0;
                                  const custoUnit = r.custoUnit || 0;
                                  const preco = r.preco || 0;
                                  const qtdade = r.qtdade || 0;
                                  const margemAtingida = r.margemAtingida || 0;
                                  const pontuacao = r.pontuacao || 0;
                                  return (
                                    <tr key={i} className={`border-b border-slate-200 hover:bg-blue-50 transition-colors duration-200 ${r.isAcabamento ? 'bg-slate-50' : ''}`}>
                                      <td className="py-4 px-3 whitespace-nowrap">
                                        <div className="flex items-center gap-2">
                                          {r.isAcabamento ? (
                                            <span className="text-gray-400 text-sm font-bold ml-2">↳</span>
                                          ) : (
                                            <div className={`w-2 h-2 rounded-full ${tabela.badge}`}></div>
                                          )}
                                          <span className={`font-semibold ${r.isAcabamento ? 'text-slate-600' : 'text-slate-800'}`}>{limparNomeProduto(r.produto)}</span>
                                        </div>
                                      </td>
                                      <td className="py-4 px-3 text-right text-slate-600 whitespace-nowrap">R$ {formatarMoeda(preco)}</td>
                                      <td className="py-4 px-3 text-right text-slate-600 whitespace-nowrap">{qtdade.toFixed(2).replace('.', ',')}</td>
                                      <td className="py-4 px-3 text-right font-bold text-slate-800 whitespace-nowrap">R$ {formatarMoeda(r.total)}</td>
                                      <td className="py-4 px-3 text-right text-slate-500 whitespace-nowrap">R$ {formatarMoeda(custoUnit)}</td>
                                      <td className="py-4 px-3 text-right text-slate-500 whitespace-nowrap">R$ {formatarMoeda(custoTotal)}</td>
                                      <td className="py-4 px-3 text-right font-bold whitespace-nowrap">{lucroItem >= 0 ? <span className="text-emerald-600">R$ {formatarMoeda(lucroItem)}</span> : <span className="text-red-600">R$ {formatarMoeda(lucroItem)}</span>}</td>
                                      <td className="py-4 px-3 text-right font-bold whitespace-nowrap">{margemAtingida >= 0 ? <span className="text-emerald-600">{margemAtingida.toFixed(2).replace('.', ',')}%</span> : <span className="text-red-600">{margemAtingida.toFixed(2).replace('.', ',')}%</span>}</td>
                                      <td className="py-4 px-3 text-right font-bold whitespace-nowrap">
                                        {pontuacao >= 0 
                                          ? <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-emerald-100 text-emerald-700"><TrendingUp size={14} />+{pontuacao.toFixed(2).replace('.', ',')}</span>
                                          : <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-red-100 text-red-700"><TrendingDown size={14} />{pontuacao.toFixed(2).replace('.', ',')}</span>
                                        }
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        ) : (<div className="text-center py-12 bg-white rounded-xl border border-slate-200"><p className="text-slate-500 text-lg font-medium">Nenhum item</p></div>)}
                      </div>
                    </div>
                  ))}

                  {/* RESUMO TOTAL DAS TABELAS */}
                  {(tab1.temItens || tab2.temItens) && (
                    <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl overflow-hidden border-2 border-blue-400 shadow-xl">
                      <div className="p-6">
                        <div className="flex items-center justify-between flex-wrap gap-4">
                          <div className="flex items-center gap-3">
                            <div className="w-1 h-8 bg-white/30 rounded-full"></div>
                            <h3 className="text-2xl font-bold text-white">RESUMO DO PEDIDO</h3>
                          </div>
                          {(() => {
                            const totalVendaGeral = (tab1.temItens ? tab1.valorGerado : 0) + (tab2.temItens ? tab2.valorGerado : 0);
                            const lucroGeral = (tab1.temItens ? tab1.lucro : 0) + (tab2.temItens ? tab2.lucro : 0);
                            
                            // Pontuação de cada tabela com cap de 50
                            const pontTab1 = tab1.temItens ? Math.min(tab1.pontuacao || 0, 50) : 0;
                            const pontTab2 = tab2.temItens ? Math.min(tab2.pontuacao || 0, 50) : 0;
                            
                            // Pontuação geral = SOMA das pontuações, também limitada a 50 no total
                            const pontuacaoGeral = Math.min(pontTab1 + pontTab2, 50);
                            
                            const statusGeral = totalVendaGeral === 0 ? 'INVIÁVEL' : getStatusByScore(pontuacaoGeral);
                            const configGeral = getStatusConfig(statusGeral);
                            
                            return (
                              <div className="flex gap-3 text-white text-sm flex-wrap">
                                <div className="text-right bg-white/10 px-3 py-2 rounded-xl hover:bg-white/20 transition-colors duration-200">
                                  <div className="text-white/80 text-[10px] uppercase">Total Venda</div>
                                  <div className="text-lg font-bold">R$ {formatarMoeda(totalVendaGeral)}</div>
                                </div>
                                <div className="text-right bg-white/10 px-3 py-2 rounded-xl hover:bg-white/20 transition-colors duration-200">
                                  <div className="text-white/80 text-[10px] uppercase">Lucro Total</div>
                                  <div className="text-lg font-bold">R$ {formatarMoeda(lucroGeral)}</div>
                                </div>
                                <div className="text-right bg-white/10 px-3 py-2 rounded-xl hover:bg-white/20 transition-colors duration-200">
                                  <div className="text-white/80 text-[10px] uppercase">Margem</div>
                                  <div className="text-lg font-bold">{totalVendaGeral > 0 ? ((lucroGeral / totalVendaGeral) * 100).toFixed(2).replace('.', ',') : '0,00'}%</div>
                                </div>
                                <div className="text-right bg-white/10 px-3 py-2 rounded-xl hover:bg-white/20 transition-colors duration-200">
                                  <div className="text-white/80 text-[10px] uppercase">Pontuação</div>
                                  <div className="text-lg font-bold">{pontuacaoGeral.toFixed(2).replace('.', ',')}</div>
                                </div>
                                <div className={`flex items-center justify-center gap-2 px-6 py-2 rounded-xl bg-gradient-to-r ${configGeral.bgGradient}`}>
                                  {configGeral.icon && <configGeral.icon size={20} className="text-white" />}
                                  <div className="text-lg font-black text-white">{statusGeral}</div>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              )}
              </>
            )}

            {/* ========================================
                SEÇÃO DE OBSERVAÇÃO DO PEDIDO
            ======================================== */}
            
            {/* DIVISÓRIA - OBSERVAÇÃO */}
            <div className="w-full max-w-6xl mx-auto mt-10 mb-6">
              <div className="w-full h-px bg-gray-200 mb-6"></div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 group cursor-default">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                    <FileText size={20} className="text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Observação</h2>
                    <p className="text-xs text-gray-400">Detalhes e anotações do pedido</p>
                  </div>
                </div>
                <button 
                  onClick={() => toggleExpandir('observacao')} 
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                >
                  <ChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${expandido.observacao ? 'rotate-180' : ''}`} />
                  {expandido.observacao ? 'Recolher' : 'Expandir'}
                </button>
              </div>
            </div>

            {/* CARD OBSERVAÇÃO */}
            {expandido.observacao && (
            <div className="w-full max-w-6xl mx-auto bg-white rounded-2xl shadow-xl p-6 border border-gray-100 mb-6 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
              <textarea
                value={observacaoPedido}
                onChange={(e) => setObservacaoPedido(e.target.value)}
                disabled={pedidoSalvo}
                placeholder="Digite aqui observações, detalhes especiais, instruções de entrega, ou qualquer informação relevante sobre o pedido..."
                className={`w-full h-32 p-4 border-2 rounded-xl text-sm resize-none transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-200 ${
                  pedidoSalvo 
                    ? 'bg-gray-50 border-gray-200 text-gray-500 cursor-not-allowed' 
                    : 'bg-white border-gray-200 hover:border-blue-300 focus:border-blue-400'
                }`}
              />
              {pedidoSalvo && observacaoPedido && (
                <div className="mt-3 flex items-center gap-2 text-sm text-gray-500">
                  <CheckCircle size={16} className="text-emerald-500" />
                  <span>Observação salva com o pedido</span>
                </div>
              )}
            </div>
            )}

            {/* DIVISÓRIA FINAL */}
            <div className="w-full max-w-6xl mx-auto mt-6 mb-6">
              <div className="w-full h-px bg-gray-200"></div>
            </div>

            {/* BOTÃO SALVAR PEDIDO */}
            {temItensNoPedido() && !pedidoSalvo && (
              <div className="w-full max-w-6xl mx-auto mt-6 mb-6">
                {/* TEMPORARIAMENTE COMENTADO - Bloqueio por tabela inviável (reativar futuramente)
                {temTabelaInviavel() ? (
                  <div className="relative bg-white rounded-2xl py-6 px-8 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 overflow-hidden group">
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-400 via-orange-400 to-red-400"></div>
                    <div className="flex items-center justify-center gap-6">
                      <div className="w-14 h-14 bg-gradient-to-br from-red-400 to-orange-500 rounded-xl flex items-center justify-center shadow-lg shadow-red-200 rotate-3 group-hover:rotate-0 transition-transform duration-300 flex-shrink-0">
                        <XCircle size={28} className="text-white" />
                      </div>
                      <div className="text-left">
                        <h3 className="text-xl font-bold text-gray-800">Revise o Pedido</h3>
                        <p className="text-gray-500 text-sm">A pontuação geral do pedido está classificada como <span className="inline-flex items-center gap-1.5 ml-1 px-3 py-0.5 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-full text-xs font-bold"><span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>INVIÁVEL</span></p>
                      </div>
                    </div>
                  </div>
                ) : ( */}
                  <div className="relative bg-white rounded-2xl py-6 px-8 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 overflow-hidden group cursor-pointer" onClick={salvarPedido}>
                    {/* Barra gradiente no topo */}
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-400 via-green-400 to-emerald-400"></div>
                    
                    {/* Conteúdo em linha */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-6">
                        <div className="w-14 h-14 bg-gradient-to-br from-emerald-400 to-green-500 rounded-xl flex items-center justify-center shadow-lg shadow-emerald-200 rotate-3 group-hover:rotate-0 transition-transform duration-300 flex-shrink-0">
                          <Save size={28} className="text-white" />
                        </div>
                        <div className="text-left">
                          <h3 className="text-xl font-bold text-gray-800">Salvar Orçamento</h3>
                          <p className="text-gray-500 text-sm">O orçamento será salvo</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-emerald-500 to-green-500 text-white rounded-full text-sm font-bold shadow-lg shadow-emerald-200 group-hover:scale-105 transition-transform duration-300">
                        <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
                        SALVAR ORÇAMENTO
                      </div>
                    </div>
                  </div>
                {/* FIM DO BLOCO COMENTADO - reativar o ternário temTabelaInviavel() acima quando necessário
                )}
                */}
              </div>
            )}

            {/* LINHA FINAL APÓS SALVAR */}
            {temItensNoPedido() && !pedidoSalvo && (
              <div className="w-full max-w-6xl mx-auto mt-2 mb-6">
                <div className="w-full h-px bg-gray-200"></div>
              </div>
            )}

            {/* STATUS E RESUMO DO PEDIDO - APÓS SALVAR */}
            {pedidoSalvo && (
              <div className="w-full max-w-6xl mx-auto mb-6">
                {/* Header de Sucesso */}
                <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden mb-6 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
                  <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-emerald-400 via-teal-400 to-cyan-400"></div>
                  <div className="p-8">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-5">
                        <div className="relative">
                          <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-2xl flex items-center justify-center shadow-lg shadow-emerald-200 rotate-3">
                            <CheckCircle size={32} className="text-white" />
                          </div>
                          <div className="absolute -top-1 -right-1 w-5 h-5 bg-emerald-400 rounded-full flex items-center justify-center">
                            <Check size={12} className="text-white" />
                          </div>
                        </div>
                        <div>
                          <h2 className="text-2xl font-bold text-slate-800">Orçamento Salvo com Sucesso!</h2>
                          <p className="text-slate-500 mt-1">Orçamento <span className="font-semibold text-slate-700">{pedido.proposta}</span> registrado no sistema</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-xs text-slate-400 uppercase tracking-wide">Data do Orçamento</div>
                        <div className="text-lg font-bold text-slate-700">{pedido.data}</div>
                        <div className="flex items-center justify-end gap-4 mt-2">
                          <div className="text-sm">
                            <span className="text-slate-400">Início Pedido: </span>
                            <span className="text-slate-600 font-medium">{pedido.hora?.substring(0, 5)}</span>
                          </div>
                          <div className="text-sm">
                            <span className="text-slate-400">Fim Pedido: </span>
                            <span className="text-slate-600 font-medium">{horaFimPedido?.substring(0, 5)}</span>
                          </div>
                        </div>
                        {calcularTempoTotal() && (
                          <div className="mt-1 text-sm">
                            <span className="text-slate-400">Tempo total do pedido: </span>
                            <span className="text-emerald-600 font-semibold">{calcularTempoTotal()}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Linha Divisória */}
                <div className="w-full h-px bg-gray-200 mb-6"></div>

                {/* Cards das Tabelas */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                  {/* Tabela 1 */}
                  {tab1.temItens && tab1.resumo.length > 0 && (
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-300">
                      {/* Banner do tipo de documento */}
                      <div className="bg-slate-400 text-white text-center py-2 font-bold text-sm uppercase tracking-wider">
                        Orçamento
                      </div>
                      <div className="p-6 border-b border-gray-100">
                        <div className="flex items-center justify-between mb-4">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-white" style={{backgroundColor: '#0d5dfc'}}>1</div>
                            <h3 className="font-bold text-slate-800 text-lg">Tabela 1</h3>
                          </div>
                          {config1 && <StatusBadge status={status1} tamanho="xs" />}
                        </div>
                        
                        {/* Valor Total Destacado */}
                        {(() => {
                          const dep = (usuarioLogado?.departamento || '').toLowerCase();
                          const mostrarFrete = dep === 'vendas' || dep === 'diretoria' || dep === 'admin' || dep === 'administrativo';
                          const qtdTabelas = (tab1.temItens && tab1.resumo.length > 0 ? 1 : 0) + (tab2.temItens && tab2.resumo.length > 0 ? 1 : 0);
                          const freteTotal = temTaxaEntrega ? (parseFloat(valorTaxaEntrega) || 0) : 0;
                          const fretePorTabela = qtdTabelas > 0 ? freteTotal / qtdTabelas : 0;
                          const totalGeral = tab1.valorGerado + fretePorTabela;
                          
                          return (
                            <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 mb-4">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-slate-500 text-sm font-medium">Valor Total</span>
                                <span className="text-xl font-bold text-slate-800">R$ {formatarMoeda(tab1.valorGerado)}</span>
                              </div>
                              {mostrarFrete && temTaxaEntrega && fretePorTabela > 0 && (
                                <>
                                  <div className="flex items-center justify-between mb-2 pt-2 border-t border-slate-200">
                                    <span className="text-orange-600 text-sm font-medium">Valor Frete</span>
                                    <span className="text-lg font-bold text-orange-600">R$ {formatarMoeda(fretePorTabela)}</span>
                                  </div>
                                  <div className="flex items-center justify-between pt-2 border-t border-slate-300">
                                    <span className="text-emerald-700 text-sm font-bold">Total Geral</span>
                                    <span className="text-2xl font-bold text-emerald-700">R$ {formatarMoeda(totalGeral)}</span>
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })()}

                      </div>

                      {/* Ações */}
                      <div className="p-4 bg-slate-50 flex items-center justify-center gap-3">
                        {pedidoSalvo && (
                          <button onClick={() => imprimirProposta('Tabela 1')} className="flex-1 text-white px-4 py-3 rounded-xl flex items-center justify-center gap-2 font-bold text-sm hover:shadow-lg hover:scale-[1.02] transition-all duration-300" style={{backgroundColor: '#0d5dfc'}}>
                            <Printer size={18} />
                            Imprimir Orçamento
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Tabela 2 */}
                  {tab2.temItens && tab2.resumo.length > 0 && (
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-300">
                      {/* Banner do tipo de documento */}
                      <div className="bg-slate-400 text-white text-center py-2 font-bold text-sm uppercase tracking-wider">
                        Orçamento
                      </div>
                      <div className="p-6 border-b border-gray-100">
                        <div className="flex items-center justify-between mb-4">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-white" style={{backgroundColor: '#00BEFF'}}>2</div>
                            <h3 className="font-bold text-slate-800 text-lg">Tabela 2</h3>
                          </div>
                          {config2 && <StatusBadge status={status2} tamanho="xs" />}
                        </div>
                        
                        {/* Valor Total Destacado */}
                        {(() => {
                          const dep = (usuarioLogado?.departamento || '').toLowerCase();
                          const mostrarFrete = dep === 'vendas' || dep === 'diretoria' || dep === 'admin' || dep === 'administrativo';
                          const qtdTabelas = (tab1.temItens && tab1.resumo.length > 0 ? 1 : 0) + (tab2.temItens && tab2.resumo.length > 0 ? 1 : 0);
                          const freteTotal = temTaxaEntrega ? (parseFloat(valorTaxaEntrega) || 0) : 0;
                          const fretePorTabela = qtdTabelas > 0 ? freteTotal / qtdTabelas : 0;
                          const totalGeral = tab2.valorGerado + fretePorTabela;
                          
                          return (
                            <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 mb-4">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-slate-500 text-sm font-medium">Valor Total</span>
                                <span className="text-xl font-bold text-slate-800">R$ {formatarMoeda(tab2.valorGerado)}</span>
                              </div>
                              {mostrarFrete && temTaxaEntrega && fretePorTabela > 0 && (
                                <>
                                  <div className="flex items-center justify-between mb-2 pt-2 border-t border-slate-200">
                                    <span className="text-orange-600 text-sm font-medium">Valor Frete</span>
                                    <span className="text-lg font-bold text-orange-600">R$ {formatarMoeda(fretePorTabela)}</span>
                                  </div>
                                  <div className="flex items-center justify-between pt-2 border-t border-slate-300">
                                    <span className="text-emerald-700 text-sm font-bold">Total Geral</span>
                                    <span className="text-2xl font-bold text-emerald-700">R$ {formatarMoeda(totalGeral)}</span>
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })()}

                      </div>

                      {/* Ações */}
                      <div className="p-4 bg-slate-50 flex items-center justify-center gap-3">
                        {pedidoSalvo && (
                          <button onClick={() => imprimirProposta('Tabela 2')} className="flex-1 text-white px-4 py-3 rounded-xl flex items-center justify-center gap-2 font-bold text-sm hover:shadow-lg hover:scale-[1.02] transition-all duration-300" style={{backgroundColor: '#00BEFF'}}>
                            <Printer size={18} />
                            Imprimir Orçamento
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Card único se só tem uma tabela */}
                  {tab1.temItens && tab1.resumo.length > 0 && (!tab2.temItens || tab2.resumo.length === 0) && (
                    <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-2xl p-8 border-2 border-dashed border-slate-200 flex flex-col items-center justify-center text-center hover:shadow-lg hover:-translate-y-2 hover:border-slate-300 transition-all duration-300">
                      <div className="w-12 h-12 bg-slate-200 rounded-full flex items-center justify-center mb-3">
                        <FileText size={24} className="text-slate-400" />
                      </div>
                      <h3 className="font-semibold text-slate-600 mb-1">Tabela 2 não utilizada</h3>
                      <p className="text-sm text-slate-400">Este pedido possui apenas uma tabela de preços</p>
                    </div>
                  )}
                </div>

                {/* Card de Produtos Especiais (se houver) */}
                {itensEspeciais.length > 0 && (
                  <div className="mt-6">
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-300">
                      {/* Banner do tipo de documento */}
                      <div className="bg-slate-400 text-white text-center py-2 font-bold text-sm uppercase tracking-wider">
                        Demais Produtos
                      </div>
                      <div className="p-6 border-b border-gray-100">
                        <div className="flex items-center justify-between mb-4">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-white bg-gradient-to-br from-slate-500 to-slate-600">
                              <Package size={20} />
                            </div>
                            <h3 className="font-bold text-slate-800 text-lg">Produtos Especiais</h3>
                          </div>
                          <span className="px-3 py-1 rounded-full text-xs font-bold bg-green-100 text-green-700">
                            → VIÁVEL
                          </span>
                        </div>
                        
                        {/* Valor Total Destacado */}
                        {(() => {
                          const dep = (usuarioLogado?.departamento || '').toLowerCase();
                          const mostrarFrete = dep === 'vendas' || dep === 'diretoria' || dep === 'admin' || dep === 'administrativo';
                          const qtdTabelas = (tab1.temItens && tab1.resumo.length > 0 ? 1 : 0) + (tab2.temItens && tab2.resumo.length > 0 ? 1 : 0);
                          const freteTotal = temTaxaEntrega ? (parseFloat(valorTaxaEntrega) || 0) : 0;
                          // Se não há tabelas normais, o frete total vai para produtos especiais
                          const freteEspeciais = qtdTabelas === 0 ? freteTotal : 0;
                          const totalGeralEspeciais = totalProdutosEspeciais + freteEspeciais;
                          return (
                            <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 mb-4">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-slate-500 text-sm font-medium">Valor Total</span>
                                <span className="text-xl font-bold text-slate-800">R$ {formatarMoeda(totalProdutosEspeciais)}</span>
                              </div>
                              {mostrarFrete && temTaxaEntrega && freteEspeciais > 0 && (
                                <>
                                  <div className="flex items-center justify-between mb-2 pt-2 border-t border-slate-200">
                                    <span className="text-orange-600 text-sm font-medium">Valor Frete</span>
                                    <span className="text-lg font-bold text-orange-600">R$ {formatarMoeda(freteEspeciais)}</span>
                                  </div>
                                  <div className="flex items-center justify-between pt-2 border-t border-slate-300">
                                    <span className="text-emerald-700 text-sm font-bold">Total Geral</span>
                                    <span className="text-2xl font-bold text-emerald-700">R$ {formatarMoeda(totalGeralEspeciais)}</span>
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })()}
                      </div>

                      {/* Ações */}
                      <div className="p-4 bg-slate-50 flex items-center justify-center gap-3">
                        {pedidoSalvo && (
                          <button onClick={() => imprimirProposta('Tabela 1')} className="flex-1 text-white px-4 py-3 rounded-xl flex items-center justify-center gap-2 font-bold text-sm hover:shadow-lg hover:scale-[1.02] transition-all duration-300 bg-gradient-to-r from-slate-500 to-slate-600">
                            <Printer size={18} />
                            Imprimir Pedido
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Linha Divisória 1 */}
                <div className="w-full h-px bg-gray-200 my-6"></div>

                {/* Botão Novo Pedido */}
                <div className="flex justify-center">
                  <button 
                    onClick={iniciarNovoPedido} 
                    className="group relative bg-white border-2 border-slate-200 text-slate-700 px-8 py-4 rounded-xl flex items-center gap-3 font-bold shadow-lg hover:shadow-xl hover:-translate-y-2 hover:border-blue-300 hover:text-blue-600 transition-all duration-300"
                  >
                    <div className="w-10 h-10 bg-slate-100 group-hover:bg-blue-100 rounded-lg flex items-center justify-center transition-colors duration-300">
                      <Plus size={22} className="group-hover:rotate-90 transition-transform duration-300" />
                    </div>
                    Iniciar Novo Pedido
                    <ArrowRight size={18} className="opacity-0 group-hover:opacity-100 -ml-2 group-hover:ml-0 transition-all duration-300" />
                  </button>
                </div>

                {/* Linha Divisória 2 */}
                <div className="w-full h-px bg-gray-200 mt-6"></div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PrimaliaPVCSystem;